import { baseApi as api } from "../baseApi";
export const addTagTypes = [
  "Auth",
  "EmailVerification",
  "PhoneVerification",
  "Account",
  "Signup",
  "Support",
  "Billing",
  "StripeWebhook",
  "Company",
  "CompanyUser",
  "Certificate",
  "Caf",
  "FolioPolicy",
  "FolioRequest",
  "CompanyFolioAutomation",
  "CompanyFolioRequest",
  "FolioAnnulment",
  "Event",
  "Webhook",
  "Dte",
  "Envio",
  "Intercambio",
  "SesWebhook",
  "Integrations",
  "Boleta",
  "ConsumoFolios",
  "Onboarding",
  "EmittedDteImport",
  "Libro",
  "SiiAvance",
  "SiiTestSet",
  "SiiIntercambioSet",
  "Health",
  "AdminHealth",
  "Reports",
  "Sandbox",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      authControllerLogin: build.query<
        AuthControllerLoginApiResponse,
        AuthControllerLoginApiArg
      >({
        query: () => ({ url: `/auth/login` }),
        providesTags: ["Auth"],
      }),
      authControllerCallback: build.query<
        AuthControllerCallbackApiResponse,
        AuthControllerCallbackApiArg
      >({
        query: (queryArg) => ({
          url: `/auth/callback`,
          params: {
            code: queryArg.code,
            state: queryArg.state,
            error: queryArg.error,
          },
        }),
        providesTags: ["Auth"],
      }),
      authControllerLogout: build.mutation<
        AuthControllerLogoutApiResponse,
        AuthControllerLogoutApiArg
      >({
        query: () => ({ url: `/auth/logout`, method: "POST" }),
        invalidatesTags: ["Auth"],
      }),
      emailVerificationControllerStatus: build.query<
        EmailVerificationControllerStatusApiResponse,
        EmailVerificationControllerStatusApiArg
      >({
        query: () => ({ url: `/api/account/email-verification` }),
        providesTags: ["EmailVerification"],
      }),
      emailVerificationControllerSend: build.mutation<
        EmailVerificationControllerSendApiResponse,
        EmailVerificationControllerSendApiArg
      >({
        query: () => ({
          url: `/api/account/email-verification/send`,
          method: "POST",
        }),
        invalidatesTags: ["EmailVerification"],
      }),
      emailVerificationControllerVerify: build.mutation<
        EmailVerificationControllerVerifyApiResponse,
        EmailVerificationControllerVerifyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/email-verification/verify`,
          method: "POST",
          body: queryArg.verifyEmailDto,
        }),
        invalidatesTags: ["EmailVerification"],
      }),
      phoneVerificationControllerStatus: build.query<
        PhoneVerificationControllerStatusApiResponse,
        PhoneVerificationControllerStatusApiArg
      >({
        query: () => ({ url: `/api/account/phone-verification` }),
        providesTags: ["PhoneVerification"],
      }),
      phoneVerificationControllerSend: build.mutation<
        PhoneVerificationControllerSendApiResponse,
        PhoneVerificationControllerSendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/phone-verification/send`,
          method: "POST",
          body: queryArg.sendPhoneCodeDto,
        }),
        invalidatesTags: ["PhoneVerification"],
      }),
      phoneVerificationControllerVerify: build.mutation<
        PhoneVerificationControllerVerifyApiResponse,
        PhoneVerificationControllerVerifyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/phone-verification/verify`,
          method: "POST",
          body: queryArg.verifyPhoneDto,
        }),
        invalidatesTags: ["PhoneVerification"],
      }),
      accountControllerAccount: build.query<
        AccountControllerAccountApiResponse,
        AccountControllerAccountApiArg
      >({
        query: () => ({ url: `/api/account` }),
        providesTags: ["Account"],
      }),
      accountControllerUpdateSelection: build.mutation<
        AccountControllerUpdateSelectionApiResponse,
        AccountControllerUpdateSelectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/selection`,
          method: "PUT",
          body: queryArg.updateSelectionDto,
        }),
        invalidatesTags: ["Account"],
      }),
      accountControllerOnboarding: build.query<
        AccountControllerOnboardingApiResponse,
        AccountControllerOnboardingApiArg
      >({
        query: () => ({ url: `/api/account/onboarding` }),
        providesTags: ["Account"],
      }),
      accountControllerReadSegment: build.query<
        AccountControllerReadSegmentApiResponse,
        AccountControllerReadSegmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/segment`,
        }),
        providesTags: ["Account"],
      }),
      accountControllerUpdateSegment: build.mutation<
        AccountControllerUpdateSegmentApiResponse,
        AccountControllerUpdateSegmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/segment`,
          method: "PUT",
          body: queryArg.updateSegmentDto,
        }),
        invalidatesTags: ["Account"],
      }),
      accountControllerIssueApiKey: build.mutation<
        AccountControllerIssueApiKeyApiResponse,
        AccountControllerIssueApiKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/api-keys`,
          method: "POST",
        }),
        invalidatesTags: ["Account"],
      }),
      accountControllerRevokeApiKey: build.mutation<
        AccountControllerRevokeApiKeyApiResponse,
        AccountControllerRevokeApiKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/api-keys/${queryArg.apiKeyId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Account"],
      }),
      accountControllerListMembers: build.query<
        AccountControllerListMembersApiResponse,
        AccountControllerListMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/members`,
        }),
        providesTags: ["Account"],
      }),
      accountControllerAddMember: build.mutation<
        AccountControllerAddMemberApiResponse,
        AccountControllerAddMemberApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/members`,
          method: "POST",
          body: queryArg.addMemberDto,
        }),
        invalidatesTags: ["Account"],
      }),
      accountControllerUpdateMemberRole: build.mutation<
        AccountControllerUpdateMemberRoleApiResponse,
        AccountControllerUpdateMemberRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/members/${queryArg.userId}`,
          method: "PATCH",
          body: queryArg.updateMemberRoleDto,
        }),
        invalidatesTags: ["Account"],
      }),
      accountControllerRemoveMember: build.mutation<
        AccountControllerRemoveMemberApiResponse,
        AccountControllerRemoveMemberApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/members/${queryArg.userId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Account"],
      }),
      signupControllerSignup: build.mutation<
        SignupControllerSignupApiResponse,
        SignupControllerSignupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signup`,
          method: "POST",
          body: queryArg.signupDto,
        }),
        invalidatesTags: ["Signup"],
      }),
      supportControllerToken: build.mutation<
        SupportControllerTokenApiResponse,
        SupportControllerTokenApiArg
      >({
        query: () => ({
          url: `/api/account/support-chat/token`,
          method: "POST",
        }),
        invalidatesTags: ["Support"],
      }),
      billingControllerStatus: build.query<
        BillingControllerStatusApiResponse,
        BillingControllerStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/billing`,
        }),
        providesTags: ["Billing"],
      }),
      billingControllerStartSetup: build.mutation<
        BillingControllerStartSetupApiResponse,
        BillingControllerStartSetupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/billing/setup`,
          method: "POST",
        }),
        invalidatesTags: ["Billing"],
      }),
      billingControllerConfirmSetup: build.mutation<
        BillingControllerConfirmSetupApiResponse,
        BillingControllerConfirmSetupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/account/tenants/${queryArg.tenantId}/billing/setup/confirm`,
          method: "POST",
          body: queryArg.confirmSetupDto,
        }),
        invalidatesTags: ["Billing"],
      }),
      stripeWebhookControllerReceive: build.mutation<
        StripeWebhookControllerReceiveApiResponse,
        StripeWebhookControllerReceiveApiArg
      >({
        query: () => ({ url: `/webhooks/stripe`, method: "POST" }),
        invalidatesTags: ["StripeWebhook"],
      }),
      companyControllerCreate: build.mutation<
        CompanyControllerCreateApiResponse,
        CompanyControllerCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies`,
          method: "POST",
          body: queryArg.createCompanyDto,
        }),
        invalidatesTags: ["Company"],
      }),
      companyControllerList: build.query<
        CompanyControllerListApiResponse,
        CompanyControllerListApiArg
      >({
        query: () => ({ url: `/api/companies` }),
        providesTags: ["Company"],
      }),
      companyControllerFindOne: build.query<
        CompanyControllerFindOneApiResponse,
        CompanyControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/api/companies/${queryArg.id}` }),
        providesTags: ["Company"],
      }),
      companyControllerUpdate: build.mutation<
        CompanyControllerUpdateApiResponse,
        CompanyControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateCompanyDto,
        }),
        invalidatesTags: ["Company"],
      }),
      companyControllerSetSiiCredentials: build.mutation<
        CompanyControllerSetSiiCredentialsApiResponse,
        CompanyControllerSetSiiCredentialsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.id}/sii-credentials`,
          method: "PUT",
          body: queryArg.setSiiCredentialsDto,
        }),
        invalidatesTags: ["Company"],
      }),
      companyControllerGetSiiCredentials: build.query<
        CompanyControllerGetSiiCredentialsApiResponse,
        CompanyControllerGetSiiCredentialsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.id}/sii-credentials`,
        }),
        providesTags: ["Company"],
      }),
      companyControllerClearSiiCredentials: build.mutation<
        CompanyControllerClearSiiCredentialsApiResponse,
        CompanyControllerClearSiiCredentialsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.id}/sii-credentials`,
          method: "DELETE",
        }),
        invalidatesTags: ["Company"],
      }),
      companyControllerPromoteToProduction: build.mutation<
        CompanyControllerPromoteToProductionApiResponse,
        CompanyControllerPromoteToProductionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.id}/promote-to-production`,
          method: "POST",
          body: queryArg.promoteToProductionDto,
        }),
        invalidatesTags: ["Company"],
      }),
      companyUserControllerList: build.query<
        CompanyUserControllerListApiResponse,
        CompanyUserControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/users`,
        }),
        providesTags: ["CompanyUser"],
      }),
      companyUserControllerAuthorize: build.mutation<
        CompanyUserControllerAuthorizeApiResponse,
        CompanyUserControllerAuthorizeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/users`,
          method: "POST",
          body: queryArg.authorizeCompanyUserDto,
        }),
        invalidatesTags: ["CompanyUser"],
      }),
      companyUserControllerSetRole: build.mutation<
        CompanyUserControllerSetRoleApiResponse,
        CompanyUserControllerSetRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/users/${queryArg.userId}`,
          method: "PATCH",
          body: queryArg.updateCompanyUserRoleDto,
        }),
        invalidatesTags: ["CompanyUser"],
      }),
      companyUserControllerRevoke: build.mutation<
        CompanyUserControllerRevokeApiResponse,
        CompanyUserControllerRevokeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/users/${queryArg.userId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["CompanyUser"],
      }),
      certificateControllerList: build.query<
        CertificateControllerListApiResponse,
        CertificateControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/certificates`,
        }),
        providesTags: ["Certificate"],
      }),
      certificateControllerUpload: build.mutation<
        CertificateControllerUploadApiResponse,
        CertificateControllerUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/certificates`,
          method: "POST",
          body: queryArg.uploadCertificateDto,
        }),
        invalidatesTags: ["Certificate"],
      }),
      cafControllerUpload: build.mutation<
        CafControllerUploadApiResponse,
        CafControllerUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/cafs`,
          method: "POST",
          body: queryArg.uploadCafDto,
        }),
        invalidatesTags: ["Caf"],
      }),
      cafControllerList: build.query<
        CafControllerListApiResponse,
        CafControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/cafs`,
        }),
        providesTags: ["Caf"],
      }),
      cafControllerPreview: build.mutation<
        CafControllerPreviewApiResponse,
        CafControllerPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/cafs/preview`,
          method: "POST",
          body: queryArg.uploadCafDto,
        }),
        invalidatesTags: ["Caf"],
      }),
      cafControllerAnnulmentCandidates: build.query<
        CafControllerAnnulmentCandidatesApiResponse,
        CafControllerAnnulmentCandidatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/cafs/annulment-candidates`,
        }),
        providesTags: ["Caf"],
      }),
      folioPolicyControllerList: build.query<
        FolioPolicyControllerListApiResponse,
        FolioPolicyControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-policies`,
        }),
        providesTags: ["FolioPolicy"],
      }),
      folioPolicyControllerUpdate: build.mutation<
        FolioPolicyControllerUpdateApiResponse,
        FolioPolicyControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-policies/${queryArg.dteType}`,
          method: "PUT",
          body: queryArg.updateFolioPolicyDto,
        }),
        invalidatesTags: ["FolioPolicy"],
      }),
      folioRequestControllerList: build.query<
        FolioRequestControllerListApiResponse,
        FolioRequestControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/folio-requests`,
          params: {
            companyId: queryArg.companyId,
            dteType: queryArg.dteType,
            status: queryArg.status,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["FolioRequest"],
      }),
      companyFolioAutomationControllerStatus: build.query<
        CompanyFolioAutomationControllerStatusApiResponse,
        CompanyFolioAutomationControllerStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-automation`,
        }),
        providesTags: ["CompanyFolioAutomation"],
      }),
      companyFolioRequestControllerRequestNow: build.mutation<
        CompanyFolioRequestControllerRequestNowApiResponse,
        CompanyFolioRequestControllerRequestNowApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-requests`,
          method: "POST",
          body: queryArg.requestFoliosNowDto,
        }),
        invalidatesTags: ["CompanyFolioRequest"],
      }),
      folioAnnulmentControllerRequestConsultation: build.mutation<
        FolioAnnulmentControllerRequestConsultationApiResponse,
        FolioAnnulmentControllerRequestConsultationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-consultations`,
          method: "POST",
        }),
        invalidatesTags: ["FolioAnnulment"],
      }),
      folioAnnulmentControllerLatestConsultation: build.query<
        FolioAnnulmentControllerLatestConsultationApiResponse,
        FolioAnnulmentControllerLatestConsultationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-consultations/latest`,
        }),
        providesTags: ["FolioAnnulment"],
      }),
      folioAnnulmentControllerCreate: build.mutation<
        FolioAnnulmentControllerCreateApiResponse,
        FolioAnnulmentControllerCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-annulments`,
          method: "POST",
          body: queryArg.createFolioAnnulmentDto,
        }),
        invalidatesTags: ["FolioAnnulment"],
      }),
      folioAnnulmentControllerList: build.query<
        FolioAnnulmentControllerListApiResponse,
        FolioAnnulmentControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-annulments`,
        }),
        providesTags: ["FolioAnnulment"],
      }),
      folioAnnulmentControllerCreateBatch: build.mutation<
        FolioAnnulmentControllerCreateBatchApiResponse,
        FolioAnnulmentControllerCreateBatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-annulments/batch`,
          method: "POST",
          body: queryArg.createFolioAnnulmentBatchDto,
        }),
        invalidatesTags: ["FolioAnnulment"],
      }),
      folioAnnulmentControllerGet: build.query<
        FolioAnnulmentControllerGetApiResponse,
        FolioAnnulmentControllerGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-annulments/${queryArg.annulmentId}`,
        }),
        providesTags: ["FolioAnnulment"],
      }),
      folioAnnulmentControllerVerify: build.mutation<
        FolioAnnulmentControllerVerifyApiResponse,
        FolioAnnulmentControllerVerifyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-annulments/${queryArg.annulmentId}/verify`,
          method: "POST",
        }),
        invalidatesTags: ["FolioAnnulment"],
      }),
      folioAnnulmentControllerSettings: build.query<
        FolioAnnulmentControllerSettingsApiResponse,
        FolioAnnulmentControllerSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-annulment-settings`,
        }),
        providesTags: ["FolioAnnulment"],
      }),
      folioAnnulmentControllerUpdateSettings: build.mutation<
        FolioAnnulmentControllerUpdateSettingsApiResponse,
        FolioAnnulmentControllerUpdateSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/folio-annulment-settings`,
          method: "PATCH",
          body: queryArg.updateFolioAnnulmentSettingsDto,
        }),
        invalidatesTags: ["FolioAnnulment"],
      }),
      eventControllerCatalog: build.query<
        EventControllerCatalogApiResponse,
        EventControllerCatalogApiArg
      >({
        query: () => ({ url: `/api/events/catalog` }),
        providesTags: ["Event"],
      }),
      eventControllerStats: build.query<
        EventControllerStatsApiResponse,
        EventControllerStatsApiArg
      >({
        query: () => ({ url: `/api/events/stats` }),
        providesTags: ["Event"],
      }),
      eventControllerList: build.query<
        EventControllerListApiResponse,
        EventControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events`,
          params: {
            name: queryArg.name,
            aggregateId: queryArg.aggregateId,
            cursor: queryArg.cursor,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Event"],
      }),
      webhookControllerCreate: build.mutation<
        WebhookControllerCreateApiResponse,
        WebhookControllerCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/webhooks/subscriptions`,
          method: "POST",
          body: queryArg.createWebhookSubscriptionDto,
        }),
        invalidatesTags: ["Webhook"],
      }),
      webhookControllerList: build.query<
        WebhookControllerListApiResponse,
        WebhookControllerListApiArg
      >({
        query: () => ({ url: `/api/webhooks/subscriptions` }),
        providesTags: ["Webhook"],
      }),
      webhookControllerUpdate: build.mutation<
        WebhookControllerUpdateApiResponse,
        WebhookControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/webhooks/subscriptions/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateWebhookSubscriptionDto,
        }),
        invalidatesTags: ["Webhook"],
      }),
      webhookControllerRemove: build.mutation<
        WebhookControllerRemoveApiResponse,
        WebhookControllerRemoveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/webhooks/subscriptions/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Webhook"],
      }),
      webhookControllerRotate: build.mutation<
        WebhookControllerRotateApiResponse,
        WebhookControllerRotateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/webhooks/subscriptions/${queryArg.id}/rotate-secret`,
          method: "POST",
        }),
        invalidatesTags: ["Webhook"],
      }),
      webhookControllerTest: build.mutation<
        WebhookControllerTestApiResponse,
        WebhookControllerTestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/webhooks/subscriptions/${queryArg.id}/test`,
          method: "POST",
        }),
        invalidatesTags: ["Webhook"],
      }),
      webhookControllerDeliveries: build.query<
        WebhookControllerDeliveriesApiResponse,
        WebhookControllerDeliveriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/webhooks/deliveries`,
          params: {
            subscriptionId: queryArg.subscriptionId,
            status: queryArg.status,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Webhook"],
      }),
      webhookControllerResend: build.mutation<
        WebhookControllerResendApiResponse,
        WebhookControllerResendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/webhooks/deliveries/${queryArg.id}/resend`,
          method: "POST",
        }),
        invalidatesTags: ["Webhook"],
      }),
      dteControllerCreate: build.mutation<
        DteControllerCreateApiResponse,
        DteControllerCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dtes`,
          method: "POST",
          body: queryArg.createDteDto,
        }),
        invalidatesTags: ["Dte"],
      }),
      dteControllerList: build.query<
        DteControllerListApiResponse,
        DteControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dtes`,
          params: {
            companyId: queryArg.companyId,
            dteType: queryArg.dteType,
            status: queryArg.status,
            envioStatus: queryArg.envioStatus,
            from: queryArg["from"],
            to: queryArg.to,
            receiver: queryArg.receiver,
            limit: queryArg.limit,
            offset: queryArg.offset,
            updatedSince: queryArg.updatedSince,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["Dte"],
      }),
      dteControllerParseSourceXml: build.mutation<
        DteControllerParseSourceXmlApiResponse,
        DteControllerParseSourceXmlApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dtes/source-xml`,
          method: "POST",
          body: queryArg.sourceXmlRequestDto,
        }),
        invalidatesTags: ["Dte"],
      }),
      dteControllerFindOne: build.query<
        DteControllerFindOneApiResponse,
        DteControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/api/dtes/${queryArg.id}` }),
        providesTags: ["Dte"],
      }),
      dteControllerGetXml: build.query<
        DteControllerGetXmlApiResponse,
        DteControllerGetXmlApiArg
      >({
        query: (queryArg) => ({ url: `/api/dtes/${queryArg.id}/xml` }),
        providesTags: ["Dte"],
      }),
      dteControllerGetXmlUrl: build.query<
        DteControllerGetXmlUrlApiResponse,
        DteControllerGetXmlUrlApiArg
      >({
        query: (queryArg) => ({ url: `/api/dtes/${queryArg.id}/xml-url` }),
        providesTags: ["Dte"],
      }),
      dteControllerEmail: build.mutation<
        DteControllerEmailApiResponse,
        DteControllerEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dtes/${queryArg.id}/email`,
          method: "POST",
          body: queryArg.emailDteDto,
        }),
        invalidatesTags: ["Dte"],
      }),
      dteControllerGetPdf: build.query<
        DteControllerGetPdfApiResponse,
        DteControllerGetPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dtes/${queryArg.id}/pdf`,
          params: {
            variant: queryArg.variant,
          },
        }),
        providesTags: ["Dte"],
      }),
      envioControllerCreate: build.mutation<
        EnvioControllerCreateApiResponse,
        EnvioControllerCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/envios`,
          method: "POST",
          body: queryArg.createEnvioDto,
        }),
        invalidatesTags: ["Envio"],
      }),
      envioControllerSend: build.mutation<
        EnvioControllerSendApiResponse,
        EnvioControllerSendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/envios/${queryArg.id}/send`,
          method: "POST",
        }),
        invalidatesTags: ["Envio"],
      }),
      envioControllerReconcile: build.mutation<
        EnvioControllerReconcileApiResponse,
        EnvioControllerReconcileApiArg
      >({
        query: () => ({ url: `/api/envios/reconcile`, method: "POST" }),
        invalidatesTags: ["Envio"],
      }),
      envioControllerFindOne: build.query<
        EnvioControllerFindOneApiResponse,
        EnvioControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/api/envios/${queryArg.id}` }),
        providesTags: ["Envio"],
      }),
      envioControllerGetXml: build.query<
        EnvioControllerGetXmlApiResponse,
        EnvioControllerGetXmlApiArg
      >({
        query: (queryArg) => ({ url: `/api/envios/${queryArg.id}/xml` }),
        providesTags: ["Envio"],
      }),
      intercambioControllerIngest: build.mutation<
        IntercambioControllerIngestApiResponse,
        IntercambioControllerIngestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/inbound/envios`,
          method: "POST",
          body: queryArg.ingestEnvioDto,
        }),
        invalidatesTags: ["Intercambio"],
      }),
      intercambioControllerListEnvios: build.query<
        IntercambioControllerListEnviosApiResponse,
        IntercambioControllerListEnviosApiArg
      >({
        query: (queryArg) => ({
          url: `/api/inbound/envios`,
          params: {
            companyId: queryArg.companyId,
          },
        }),
        providesTags: ["Intercambio"],
      }),
      intercambioControllerGetEnvio: build.query<
        IntercambioControllerGetEnvioApiResponse,
        IntercambioControllerGetEnvioApiArg
      >({
        query: (queryArg) => ({ url: `/api/inbound/envios/${queryArg.id}` }),
        providesTags: ["Intercambio"],
      }),
      intercambioControllerRespondEnvio: build.mutation<
        IntercambioControllerRespondEnvioApiResponse,
        IntercambioControllerRespondEnvioApiArg
      >({
        query: (queryArg) => ({
          url: `/api/inbound/envios/${queryArg.id}/respond`,
          method: "POST",
          body: queryArg.respondEnvioDto,
        }),
        invalidatesTags: ["Intercambio"],
      }),
      intercambioControllerDownloadResponse: build.query<
        IntercambioControllerDownloadResponseApiResponse,
        IntercambioControllerDownloadResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/inbound/envios/${queryArg.id}/responses/${queryArg.kind}`,
        }),
        providesTags: ["Intercambio"],
      }),
      intercambioControllerList: build.query<
        IntercambioControllerListApiResponse,
        IntercambioControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/inbound/dtes`,
          params: {
            companyId: queryArg.companyId,
            updatedSince: queryArg.updatedSince,
            cursor: queryArg.cursor,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Intercambio"],
      }),
      intercambioControllerAcknowledge: build.mutation<
        IntercambioControllerAcknowledgeApiResponse,
        IntercambioControllerAcknowledgeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/inbound/dtes/${queryArg.id}/acknowledge`,
          method: "POST",
          body: queryArg.acknowledgeDto,
        }),
        invalidatesTags: ["Intercambio"],
      }),
      intercambioControllerAcuseRecibo: build.mutation<
        IntercambioControllerAcuseReciboApiResponse,
        IntercambioControllerAcuseReciboApiArg
      >({
        query: (queryArg) => ({
          url: `/api/inbound/dtes/${queryArg.id}/recibo`,
          method: "POST",
          body: queryArg.acuseReciboDto,
        }),
        invalidatesTags: ["Intercambio"],
      }),
      sesWebhookControllerReceive: build.mutation<
        SesWebhookControllerReceiveApiResponse,
        SesWebhookControllerReceiveApiArg
      >({
        query: (queryArg) => ({
          url: `/inbound/ses-notification`,
          method: "POST",
          body: queryArg.snsEnvelopeDto,
        }),
        invalidatesTags: ["SesWebhook"],
      }),
      integrationsControllerConnectors: build.query<
        IntegrationsControllerConnectorsApiResponse,
        IntegrationsControllerConnectorsApiArg
      >({
        query: () => ({ url: `/api/integrations/connectors` }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerPendingCounts: build.query<
        IntegrationsControllerPendingCountsApiResponse,
        IntegrationsControllerPendingCountsApiArg
      >({
        query: () => ({ url: `/api/integrations/connections/pending-counts` }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerCreate: build.mutation<
        IntegrationsControllerCreateApiResponse,
        IntegrationsControllerCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections`,
          method: "POST",
          body: queryArg.createConnectionDto,
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerList: build.query<
        IntegrationsControllerListApiResponse,
        IntegrationsControllerListApiArg
      >({
        query: () => ({ url: `/api/integrations/connections` }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerBoletaImport: build.mutation<
        IntegrationsControllerBoletaImportApiResponse,
        IntegrationsControllerBoletaImportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/boleta-import`,
          method: "POST",
          body: queryArg.createBoletaImportDto,
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerGet: build.query<
        IntegrationsControllerGetApiResponse,
        IntegrationsControllerGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}`,
        }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerUpdate: build.mutation<
        IntegrationsControllerUpdateApiResponse,
        IntegrationsControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateConnectionDto,
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerRemove: build.mutation<
        IntegrationsControllerRemoveApiResponse,
        IntegrationsControllerRemoveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerRotateCredentials: build.mutation<
        IntegrationsControllerRotateCredentialsApiResponse,
        IntegrationsControllerRotateCredentialsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/credentials`,
          method: "PUT",
          body: queryArg.rotateCredentialsDto,
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerHealth: build.query<
        IntegrationsControllerHealthApiResponse,
        IntegrationsControllerHealthApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/health`,
        }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerActivate: build.mutation<
        IntegrationsControllerActivateApiResponse,
        IntegrationsControllerActivateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/activate`,
          method: "POST",
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerPause: build.mutation<
        IntegrationsControllerPauseApiResponse,
        IntegrationsControllerPauseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/pause`,
          method: "POST",
          body: queryArg.pauseConnectionDto,
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerMappings: build.query<
        IntegrationsControllerMappingsApiResponse,
        IntegrationsControllerMappingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/mappings`,
        }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerUpsertMapping: build.mutation<
        IntegrationsControllerUpsertMappingApiResponse,
        IntegrationsControllerUpsertMappingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/mappings`,
          method: "POST",
          body: queryArg.upsertMappingDto,
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerImportMasters: build.mutation<
        IntegrationsControllerImportMastersApiResponse,
        IntegrationsControllerImportMastersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/mappings/import`,
          method: "POST",
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerSyncNow: build.mutation<
        IntegrationsControllerSyncNowApiResponse,
        IntegrationsControllerSyncNowApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/sync`,
          method: "POST",
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerUpload: build.mutation<
        IntegrationsControllerUploadApiResponse,
        IntegrationsControllerUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/upload`,
          method: "POST",
          body: queryArg.uploadConnectionFileDto,
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerSyncRuns: build.query<
        IntegrationsControllerSyncRunsApiResponse,
        IntegrationsControllerSyncRunsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/sync-runs`,
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerDocuments: build.query<
        IntegrationsControllerDocumentsApiResponse,
        IntegrationsControllerDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/documents`,
          params: {
            status: queryArg.status,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerRetry: build.mutation<
        IntegrationsControllerRetryApiResponse,
        IntegrationsControllerRetryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.connectionId}/documents/${queryArg.documentId}/retry`,
          method: "POST",
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerApprove: build.mutation<
        IntegrationsControllerApproveApiResponse,
        IntegrationsControllerApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.connectionId}/documents/${queryArg.documentId}/approve`,
          method: "POST",
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerReconcile: build.mutation<
        IntegrationsControllerReconcileApiResponse,
        IntegrationsControllerReconcileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/reconcile`,
          method: "POST",
          body: queryArg.reconcileDto,
        }),
        invalidatesTags: ["Integrations"],
      }),
      integrationsControllerFindings: build.query<
        IntegrationsControllerFindingsApiResponse,
        IntegrationsControllerFindingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/connections/${queryArg.id}/recon-findings`,
          params: {
            status: queryArg.status,
          },
        }),
        providesTags: ["Integrations"],
      }),
      integrationsControllerResolveFinding: build.mutation<
        IntegrationsControllerResolveFindingApiResponse,
        IntegrationsControllerResolveFindingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/integrations/recon-findings/${queryArg.findingId}/resolve`,
          method: "POST",
          params: {
            status: queryArg.status,
          },
        }),
        invalidatesTags: ["Integrations"],
      }),
      boletaControllerBuild: build.mutation<
        BoletaControllerBuildApiResponse,
        BoletaControllerBuildApiArg
      >({
        query: (queryArg) => ({
          url: `/api/boletas`,
          method: "POST",
          body: queryArg.createBoletaEnvioDto,
        }),
        invalidatesTags: ["Boleta"],
      }),
      boletaControllerList: build.query<
        BoletaControllerListApiResponse,
        BoletaControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/boletas`,
          params: {
            companyId: queryArg.companyId,
            status: queryArg.status,
            from: queryArg["from"],
            to: queryArg.to,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["Boleta"],
      }),
      boletaControllerUpload: build.mutation<
        BoletaControllerUploadApiResponse,
        BoletaControllerUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/boletas/${queryArg.id}/upload`,
          method: "POST",
        }),
        invalidatesTags: ["Boleta"],
      }),
      boletaControllerPoll: build.mutation<
        BoletaControllerPollApiResponse,
        BoletaControllerPollApiArg
      >({
        query: (queryArg) => ({
          url: `/api/boletas/${queryArg.id}/poll`,
          method: "POST",
        }),
        invalidatesTags: ["Boleta"],
      }),
      boletaControllerGet: build.query<
        BoletaControllerGetApiResponse,
        BoletaControllerGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/boletas/${queryArg.id}` }),
        providesTags: ["Boleta"],
      }),
      consumoFoliosControllerBuild: build.mutation<
        ConsumoFoliosControllerBuildApiResponse,
        ConsumoFoliosControllerBuildApiArg
      >({
        query: (queryArg) => ({
          url: `/api/consumo-folios`,
          method: "POST",
          body: queryArg.buildConsumoFoliosDto,
        }),
        invalidatesTags: ["ConsumoFolios"],
      }),
      consumoFoliosControllerList: build.query<
        ConsumoFoliosControllerListApiResponse,
        ConsumoFoliosControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/consumo-folios`,
          params: {
            companyId: queryArg.companyId,
            status: queryArg.status,
            from: queryArg["from"],
            to: queryArg.to,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["ConsumoFolios"],
      }),
      consumoFoliosControllerGet: build.query<
        ConsumoFoliosControllerGetApiResponse,
        ConsumoFoliosControllerGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/consumo-folios/${queryArg.id}` }),
        providesTags: ["ConsumoFolios"],
      }),
      onboardingControllerRun: build.mutation<
        OnboardingControllerRunApiResponse,
        OnboardingControllerRunApiArg
      >({
        query: (queryArg) => ({
          url: `/api/onboarding`,
          method: "POST",
          body: queryArg.onboardingDto,
          headers: {
            "idempotency-key": queryArg["idempotency-key"],
          },
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerPreviewTestSet: build.mutation<
        OnboardingControllerPreviewTestSetApiResponse,
        OnboardingControllerPreviewTestSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/onboarding/test-set/preview`,
          method: "POST",
          body: queryArg.previewTestSetDto,
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerGetDraft: build.query<
        OnboardingControllerGetDraftApiResponse,
        OnboardingControllerGetDraftApiArg
      >({
        query: () => ({ url: `/api/onboarding/draft` }),
        providesTags: ["Onboarding"],
      }),
      onboardingControllerSaveDraft: build.mutation<
        OnboardingControllerSaveDraftApiResponse,
        OnboardingControllerSaveDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/api/onboarding/draft`,
          method: "PUT",
          body: queryArg.saveOnboardingDraftDto,
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerDiscardDraft: build.mutation<
        OnboardingControllerDiscardDraftApiResponse,
        OnboardingControllerDiscardDraftApiArg
      >({
        query: () => ({ url: `/api/onboarding/draft`, method: "DELETE" }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerEmitTestSet: build.mutation<
        OnboardingControllerEmitTestSetApiResponse,
        OnboardingControllerEmitTestSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs/test-set`,
          method: "POST",
          body: queryArg.emitTestSetDto,
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerRunSimulation: build.mutation<
        OnboardingControllerRunSimulationApiResponse,
        OnboardingControllerRunSimulationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs/simulation`,
          method: "POST",
          body: queryArg.createSimulationDto,
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerListRuns: build.query<
        OnboardingControllerListRunsApiResponse,
        OnboardingControllerListRunsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs`,
          params: {
            companyId: queryArg.companyId,
            kind: queryArg.kind,
            status: queryArg.status,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["Onboarding"],
      }),
      onboardingControllerListCertificationLibros: build.query<
        OnboardingControllerListCertificationLibrosApiResponse,
        OnboardingControllerListCertificationLibrosApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-libros`,
          params: {
            companyId: queryArg.companyId,
          },
        }),
        providesTags: ["Onboarding"],
      }),
      onboardingControllerStatus: build.query<
        OnboardingControllerStatusApiResponse,
        OnboardingControllerStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs/${queryArg.id}`,
        }),
        providesTags: ["Onboarding"],
      }),
      onboardingControllerApplyReceptionResult: build.mutation<
        OnboardingControllerApplyReceptionResultApiResponse,
        OnboardingControllerApplyReceptionResultApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs/${queryArg.id}/reception-result`,
          method: "POST",
          body: queryArg.receptionResultDto,
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerAbandonRun: build.mutation<
        OnboardingControllerAbandonRunApiResponse,
        OnboardingControllerAbandonRunApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs/${queryArg.id}/abandon`,
          method: "POST",
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerPreviewSimulation: build.mutation<
        OnboardingControllerPreviewSimulationApiResponse,
        OnboardingControllerPreviewSimulationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs/simulation/preview`,
          method: "POST",
          body: queryArg.previewSimulationDto,
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerEmailMuestras: build.mutation<
        OnboardingControllerEmailMuestrasApiResponse,
        OnboardingControllerEmailMuestrasApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs/muestras/email`,
          method: "POST",
          body: queryArg.emailMuestrasDto,
        }),
        invalidatesTags: ["Onboarding"],
      }),
      onboardingControllerBundle: build.query<
        OnboardingControllerBundleApiResponse,
        OnboardingControllerBundleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/certification-runs/${queryArg.id}/bundle`,
        }),
        providesTags: ["Onboarding"],
      }),
      emittedDteImportControllerStart: build.mutation<
        EmittedDteImportControllerStartApiResponse,
        EmittedDteImportControllerStartApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/emitted-dte-imports`,
          method: "POST",
          body: queryArg.createEmittedDteImportDto,
        }),
        invalidatesTags: ["EmittedDteImport"],
      }),
      emittedDteImportControllerList: build.query<
        EmittedDteImportControllerListApiResponse,
        EmittedDteImportControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/emitted-dte-imports`,
        }),
        providesTags: ["EmittedDteImport"],
      }),
      emittedDteImportControllerAvailability: build.query<
        EmittedDteImportControllerAvailabilityApiResponse,
        EmittedDteImportControllerAvailabilityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/emitted-dte-imports/availability`,
        }),
        providesTags: ["EmittedDteImport"],
      }),
      libroControllerBuild: build.mutation<
        LibroControllerBuildApiResponse,
        LibroControllerBuildApiArg
      >({
        query: (queryArg) => ({
          url: `/api/libros`,
          method: "POST",
          body: queryArg.buildLibroDto,
        }),
        invalidatesTags: ["Libro"],
      }),
      libroControllerList: build.query<
        LibroControllerListApiResponse,
        LibroControllerListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/libros`,
          params: {
            companyId: queryArg.companyId,
            operacion: queryArg.operacion,
            status: queryArg.status,
            periodo: queryArg.periodo,
            from: queryArg["from"],
            to: queryArg.to,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["Libro"],
      }),
      libroControllerUpload: build.mutation<
        LibroControllerUploadApiResponse,
        LibroControllerUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/libros/${queryArg.id}/upload`,
          method: "POST",
        }),
        invalidatesTags: ["Libro"],
      }),
      libroControllerPoll: build.mutation<
        LibroControllerPollApiResponse,
        LibroControllerPollApiArg
      >({
        query: (queryArg) => ({
          url: `/api/libros/${queryArg.id}/poll`,
          method: "POST",
        }),
        invalidatesTags: ["Libro"],
      }),
      libroControllerGet: build.query<
        LibroControllerGetApiResponse,
        LibroControllerGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/libros/${queryArg.id}` }),
        providesTags: ["Libro"],
      }),
      siiAvanceControllerRead: build.query<
        SiiAvanceControllerReadApiResponse,
        SiiAvanceControllerReadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-avance`,
        }),
        providesTags: ["SiiAvance"],
      }),
      siiAvanceControllerDeclare: build.mutation<
        SiiAvanceControllerDeclareApiResponse,
        SiiAvanceControllerDeclareApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-avance/declarations`,
          method: "POST",
          body: queryArg.declareSiiAvanceDto,
        }),
        invalidatesTags: ["SiiAvance"],
      }),
      siiAvanceControllerAdvanceStep: build.mutation<
        SiiAvanceControllerAdvanceStepApiResponse,
        SiiAvanceControllerAdvanceStepApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-avance/step-advances`,
          method: "POST",
          body: queryArg.advanceSiiAvanceStepDto,
        }),
        invalidatesTags: ["SiiAvance"],
      }),
      siiAvanceControllerRecordSetVerdict: build.mutation<
        SiiAvanceControllerRecordSetVerdictApiResponse,
        SiiAvanceControllerRecordSetVerdictApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-avance/set-verdicts`,
          method: "POST",
          body: queryArg.recordSetVerdictDto,
        }),
        invalidatesTags: ["SiiAvance"],
      }),
      siiAvanceControllerRefresh: build.mutation<
        SiiAvanceControllerRefreshApiResponse,
        SiiAvanceControllerRefreshApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-avance/refresh`,
          method: "POST",
        }),
        invalidatesTags: ["SiiAvance"],
      }),
      siiTestSetControllerRead: build.query<
        SiiTestSetControllerReadApiResponse,
        SiiTestSetControllerReadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-test-set`,
        }),
        providesTags: ["SiiTestSet"],
      }),
      siiTestSetControllerDownload: build.mutation<
        SiiTestSetControllerDownloadApiResponse,
        SiiTestSetControllerDownloadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-test-set/downloads`,
          method: "POST",
          body: queryArg.downloadSiiTestSetDto,
        }),
        invalidatesTags: ["SiiTestSet"],
      }),
      siiIntercambioSetControllerRead: build.query<
        SiiIntercambioSetControllerReadApiResponse,
        SiiIntercambioSetControllerReadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-intercambio-set`,
        }),
        providesTags: ["SiiIntercambioSet"],
      }),
      siiIntercambioSetControllerDownload: build.mutation<
        SiiIntercambioSetControllerDownloadApiResponse,
        SiiIntercambioSetControllerDownloadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.companyId}/sii-intercambio-set/downloads`,
          method: "POST",
        }),
        invalidatesTags: ["SiiIntercambioSet"],
      }),
      healthControllerCheck: build.query<
        HealthControllerCheckApiResponse,
        HealthControllerCheckApiArg
      >({
        query: () => ({ url: `/health` }),
        providesTags: ["Health"],
      }),
      adminHealthControllerSnapshot: build.query<
        AdminHealthControllerSnapshotApiResponse,
        AdminHealthControllerSnapshotApiArg
      >({
        query: () => ({ url: `/api/admin/health` }),
        providesTags: ["AdminHealth"],
      }),
      reportsControllerCuadraturaReport: build.query<
        ReportsControllerCuadraturaReportApiResponse,
        ReportsControllerCuadraturaReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/reports/cuadratura`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            companyId: queryArg.companyId,
          },
        }),
        providesTags: ["Reports"],
      }),
      sandboxControllerCreate: build.mutation<
        SandboxControllerCreateApiResponse,
        SandboxControllerCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sandbox`,
          method: "POST",
          body: queryArg.createSandboxDto,
        }),
        invalidatesTags: ["Sandbox"],
      }),
      sandboxControllerList: build.query<
        SandboxControllerListApiResponse,
        SandboxControllerListApiArg
      >({
        query: () => ({ url: `/api/sandbox` }),
        providesTags: ["Sandbox"],
      }),
      sandboxControllerTopUp: build.mutation<
        SandboxControllerTopUpApiResponse,
        SandboxControllerTopUpApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sandbox/${queryArg.companyId}/folios`,
          method: "POST",
          body: queryArg.topUpFoliosDto,
        }),
        invalidatesTags: ["Sandbox"],
      }),
      sandboxControllerTopUpByPath: build.mutation<
        SandboxControllerTopUpByPathApiResponse,
        SandboxControllerTopUpByPathApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sandbox/${queryArg.companyId}/folios/${queryArg.dteType}`,
          method: "POST",
          params: {
            quantity: queryArg.quantity,
          },
        }),
        invalidatesTags: ["Sandbox"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as generatedApi };
export type AuthControllerLoginApiResponse = unknown;
export type AuthControllerLoginApiArg = void;
export type AuthControllerCallbackApiResponse = unknown;
export type AuthControllerCallbackApiArg = {
  code?: string;
  state?: string;
  error?: string;
};
export type AuthControllerLogoutApiResponse = unknown;
export type AuthControllerLogoutApiArg = void;
export type EmailVerificationControllerStatusApiResponse =
  /** status 200  */ EmailVerificationStatusDto;
export type EmailVerificationControllerStatusApiArg = void;
export type EmailVerificationControllerSendApiResponse =
  /** status 200  */ EmailVerificationSentDto;
export type EmailVerificationControllerSendApiArg = void;
export type EmailVerificationControllerVerifyApiResponse = unknown;
export type EmailVerificationControllerVerifyApiArg = {
  verifyEmailDto: VerifyEmailDto;
};
export type PhoneVerificationControllerStatusApiResponse =
  /** status 200  */ PhoneVerificationStatusDto;
export type PhoneVerificationControllerStatusApiArg = void;
export type PhoneVerificationControllerSendApiResponse =
  /** status 200  */ PhoneCodeSentDto;
export type PhoneVerificationControllerSendApiArg = {
  sendPhoneCodeDto: SendPhoneCodeDto;
};
export type PhoneVerificationControllerVerifyApiResponse = unknown;
export type PhoneVerificationControllerVerifyApiArg = {
  verifyPhoneDto: VerifyPhoneDto;
};
export type AccountControllerAccountApiResponse =
  /** status 200  */ AccountResponseDto;
export type AccountControllerAccountApiArg = void;
export type AccountControllerUpdateSelectionApiResponse = unknown;
export type AccountControllerUpdateSelectionApiArg = {
  updateSelectionDto: UpdateSelectionDto;
};
export type AccountControllerOnboardingApiResponse =
  /** status 200  */ OnboardingGateDto;
export type AccountControllerOnboardingApiArg = void;
export type AccountControllerReadSegmentApiResponse =
  /** status 200  */ TenantSegmentDto;
export type AccountControllerReadSegmentApiArg = {
  tenantId: string;
};
export type AccountControllerUpdateSegmentApiResponse =
  /** status 200  */ TenantSegmentDto;
export type AccountControllerUpdateSegmentApiArg = {
  tenantId: string;
  updateSegmentDto: UpdateSegmentDto;
};
export type AccountControllerIssueApiKeyApiResponse =
  /** status 201  */ IssuedApiKeyDto;
export type AccountControllerIssueApiKeyApiArg = {
  tenantId: string;
};
export type AccountControllerRevokeApiKeyApiResponse = unknown;
export type AccountControllerRevokeApiKeyApiArg = {
  tenantId: string;
  apiKeyId: string;
};
export type AccountControllerListMembersApiResponse =
  /** status 200  */ MemberListDto;
export type AccountControllerListMembersApiArg = {
  tenantId: string;
};
export type AccountControllerAddMemberApiResponse =
  /** status 201  */ MemberDto;
export type AccountControllerAddMemberApiArg = {
  tenantId: string;
  addMemberDto: AddMemberDto;
};
export type AccountControllerUpdateMemberRoleApiResponse =
  /** status 200  */ MemberDto;
export type AccountControllerUpdateMemberRoleApiArg = {
  tenantId: string;
  userId: string;
  updateMemberRoleDto: UpdateMemberRoleDto;
};
export type AccountControllerRemoveMemberApiResponse = unknown;
export type AccountControllerRemoveMemberApiArg = {
  tenantId: string;
  userId: string;
};
export type SignupControllerSignupApiResponse =
  /** status 201  */ SignupResponseDto;
export type SignupControllerSignupApiArg = {
  signupDto: SignupDto;
};
export type SupportControllerTokenApiResponse =
  /** status 200  */ SupportChatTokenDto;
export type SupportControllerTokenApiArg = void;
export type BillingControllerStatusApiResponse =
  /** status 200  */ BillingStatusDto;
export type BillingControllerStatusApiArg = {
  tenantId: string;
};
export type BillingControllerStartSetupApiResponse =
  /** status 201  */ SetupSessionDto;
export type BillingControllerStartSetupApiArg = {
  tenantId: string;
};
export type BillingControllerConfirmSetupApiResponse =
  /** status 200  */ BillingStatusDto;
export type BillingControllerConfirmSetupApiArg = {
  tenantId: string;
  confirmSetupDto: ConfirmSetupDto;
};
export type StripeWebhookControllerReceiveApiResponse =
  /** status 200  */ WebhookAckDto;
export type StripeWebhookControllerReceiveApiArg = void;
export type CompanyControllerCreateApiResponse =
  /** status 201  */ CompanyResponseDto;
export type CompanyControllerCreateApiArg = {
  createCompanyDto: CreateCompanyDto;
};
export type CompanyControllerListApiResponse =
  /** status 200  */ CompanyResponseDto[];
export type CompanyControllerListApiArg = void;
export type CompanyControllerFindOneApiResponse =
  /** status 200  */ CompanyResponseDto;
export type CompanyControllerFindOneApiArg = {
  id: string;
};
export type CompanyControllerUpdateApiResponse =
  /** status 200  */ CompanyResponseDto;
export type CompanyControllerUpdateApiArg = {
  id: string;
  updateCompanyDto: UpdateCompanyDto;
};
export type CompanyControllerSetSiiCredentialsApiResponse =
  /** status 200  */ SiiCredentialsStatusDto;
export type CompanyControllerSetSiiCredentialsApiArg = {
  id: string;
  setSiiCredentialsDto: SetSiiCredentialsDto;
};
export type CompanyControllerGetSiiCredentialsApiResponse =
  /** status 200  */ SiiCredentialsStatusDto;
export type CompanyControllerGetSiiCredentialsApiArg = {
  id: string;
};
export type CompanyControllerClearSiiCredentialsApiResponse =
  /** status 200  */ SiiCredentialsStatusDto;
export type CompanyControllerClearSiiCredentialsApiArg = {
  id: string;
};
export type CompanyControllerPromoteToProductionApiResponse =
  /** status 201  */ CompanyResponseDto;
export type CompanyControllerPromoteToProductionApiArg = {
  id: string;
  promoteToProductionDto: PromoteToProductionDto;
};
export type CompanyUserControllerListApiResponse =
  /** status 200  */ CompanyUserListDto;
export type CompanyUserControllerListApiArg = {
  companyId: string;
};
export type CompanyUserControllerAuthorizeApiResponse =
  /** status 201  */ CompanyUserDto;
export type CompanyUserControllerAuthorizeApiArg = {
  companyId: string;
  authorizeCompanyUserDto: AuthorizeCompanyUserDto;
};
export type CompanyUserControllerSetRoleApiResponse =
  /** status 200  */ CompanyUserDto;
export type CompanyUserControllerSetRoleApiArg = {
  companyId: string;
  userId: string;
  updateCompanyUserRoleDto: UpdateCompanyUserRoleDto;
};
export type CompanyUserControllerRevokeApiResponse = unknown;
export type CompanyUserControllerRevokeApiArg = {
  companyId: string;
  userId: string;
};
export type CertificateControllerListApiResponse =
  /** status 200  */ CertificateResponseDto[];
export type CertificateControllerListApiArg = {
  companyId: string;
};
export type CertificateControllerUploadApiResponse =
  /** status 201  */ CertificateResponseDto;
export type CertificateControllerUploadApiArg = {
  companyId: string;
  uploadCertificateDto: UploadCertificateDto;
};
export type CafControllerUploadApiResponse = /** status 201  */ CafSummaryDto;
export type CafControllerUploadApiArg = {
  companyId: string;
  uploadCafDto: UploadCafDto;
};
export type CafControllerListApiResponse = /** status 200  */ CafSummaryDto[];
export type CafControllerListApiArg = {
  companyId: string;
};
export type CafControllerPreviewApiResponse = /** status 201  */ CafPreviewDto;
export type CafControllerPreviewApiArg = {
  companyId: string;
  uploadCafDto: UploadCafDto;
};
export type CafControllerAnnulmentCandidatesApiResponse =
  /** status 200  */ AnnulmentCandidateDto[];
export type CafControllerAnnulmentCandidatesApiArg = {
  companyId: string;
};
export type FolioPolicyControllerListApiResponse =
  /** status 200  */ FolioPolicyDto[];
export type FolioPolicyControllerListApiArg = {
  companyId: string;
};
export type FolioPolicyControllerUpdateApiResponse =
  /** status 200  */ FolioPolicyDto;
export type FolioPolicyControllerUpdateApiArg = {
  companyId: string;
  dteType: number;
  updateFolioPolicyDto: UpdateFolioPolicyDto;
};
export type FolioRequestControllerListApiResponse =
  /** status 200  */ FolioRequestListResponseDto;
export type FolioRequestControllerListApiArg = {
  companyId?: string;
  dteType?: number;
  status?: string;
  limit?: number;
  cursor?: string;
};
export type CompanyFolioAutomationControllerStatusApiResponse =
  /** status 200  */ FolioAutomationStatusDto;
export type CompanyFolioAutomationControllerStatusApiArg = {
  companyId: string;
};
export type CompanyFolioRequestControllerRequestNowApiResponse =
  /** status 202  */ FolioRequestEnqueuedDto;
export type CompanyFolioRequestControllerRequestNowApiArg = {
  companyId: string;
  requestFoliosNowDto: RequestFoliosNowDto;
};
export type FolioAnnulmentControllerRequestConsultationApiResponse =
  /** status 202  */ FolioConsultationDto;
export type FolioAnnulmentControllerRequestConsultationApiArg = {
  companyId: string;
};
export type FolioAnnulmentControllerLatestConsultationApiResponse =
  /** status 200  */ LatestFolioConsultationDto;
export type FolioAnnulmentControllerLatestConsultationApiArg = {
  companyId: string;
};
export type FolioAnnulmentControllerCreateApiResponse =
  /** status 202  */ FolioAnnulmentDto;
export type FolioAnnulmentControllerCreateApiArg = {
  companyId: string;
  createFolioAnnulmentDto: CreateFolioAnnulmentDto;
};
export type FolioAnnulmentControllerListApiResponse =
  /** status 200  */ FolioAnnulmentDto[];
export type FolioAnnulmentControllerListApiArg = {
  companyId: string;
};
export type FolioAnnulmentControllerCreateBatchApiResponse =
  /** status 202  */ FolioAnnulmentBatchDto;
export type FolioAnnulmentControllerCreateBatchApiArg = {
  companyId: string;
  createFolioAnnulmentBatchDto: CreateFolioAnnulmentBatchDto;
};
export type FolioAnnulmentControllerGetApiResponse =
  /** status 200  */ FolioAnnulmentDto;
export type FolioAnnulmentControllerGetApiArg = {
  companyId: string;
  annulmentId: string;
};
export type FolioAnnulmentControllerVerifyApiResponse =
  /** status 202  */ FolioAnnulmentDto;
export type FolioAnnulmentControllerVerifyApiArg = {
  companyId: string;
  annulmentId: string;
};
export type FolioAnnulmentControllerSettingsApiResponse =
  /** status 200  */ FolioAnnulmentSettingsDto;
export type FolioAnnulmentControllerSettingsApiArg = {
  companyId: string;
};
export type FolioAnnulmentControllerUpdateSettingsApiResponse =
  /** status 200  */ FolioAnnulmentSettingsDto;
export type FolioAnnulmentControllerUpdateSettingsApiArg = {
  companyId: string;
  updateFolioAnnulmentSettingsDto: UpdateFolioAnnulmentSettingsDto;
};
export type EventControllerCatalogApiResponse =
  /** status 200  */ EventCatalogResponseDto;
export type EventControllerCatalogApiArg = void;
export type EventControllerStatsApiResponse =
  /** status 200  */ EventCountByNameDto[];
export type EventControllerStatsApiArg = void;
export type EventControllerListApiResponse =
  /** status 200  */ EventListResponseDto;
export type EventControllerListApiArg = {
  name?: string;
  aggregateId?: string;
  cursor?: string;
  limit?: number;
};
export type WebhookControllerCreateApiResponse =
  /** status 201  */ WebhookSubscriptionWithSecretDto;
export type WebhookControllerCreateApiArg = {
  createWebhookSubscriptionDto: CreateWebhookSubscriptionDto;
};
export type WebhookControllerListApiResponse =
  /** status 200  */ WebhookSubscriptionDto[];
export type WebhookControllerListApiArg = void;
export type WebhookControllerUpdateApiResponse =
  /** status 200  */ WebhookSubscriptionDto;
export type WebhookControllerUpdateApiArg = {
  id: string;
  updateWebhookSubscriptionDto: UpdateWebhookSubscriptionDto;
};
export type WebhookControllerRemoveApiResponse =
  /** status 200  */ WebhookDeletedDto;
export type WebhookControllerRemoveApiArg = {
  id: string;
};
export type WebhookControllerRotateApiResponse =
  /** status 201  */ WebhookSecretRotatedDto;
export type WebhookControllerRotateApiArg = {
  id: string;
};
export type WebhookControllerTestApiResponse =
  /** status 202  */ WebhookTestQueuedDto;
export type WebhookControllerTestApiArg = {
  id: string;
};
export type WebhookControllerDeliveriesApiResponse =
  /** status 200  */ WebhookDeliveryDto[];
export type WebhookControllerDeliveriesApiArg = {
  subscriptionId?: string;
  status?: string;
  limit?: number;
};
export type WebhookControllerResendApiResponse =
  /** status 202  */ WebhookResendQueuedDto;
export type WebhookControllerResendApiArg = {
  id: string;
};
export type DteControllerCreateApiResponse = /** status 201  */ DteResponseDto;
export type DteControllerCreateApiArg = {
  createDteDto: CreateDteDto;
};
export type DteControllerListApiResponse =
  /** status 200  */ DteListResponseDto;
export type DteControllerListApiArg = {
  companyId?: string;
  dteType?: number;
  status?: string;
  envioStatus?: string;
  from?: string;
  to?: string;
  receiver?: string;
  limit?: number;
  offset?: number;
  updatedSince?: string;
  cursor?: string;
};
export type DteControllerParseSourceXmlApiResponse =
  /** status 200  */ SourceXmlResponseDto;
export type DteControllerParseSourceXmlApiArg = {
  sourceXmlRequestDto: SourceXmlRequestDto;
};
export type DteControllerFindOneApiResponse =
  /** status 200  */ DteDetailResponseDto;
export type DteControllerFindOneApiArg = {
  id: string;
};
export type DteControllerGetXmlApiResponse = unknown;
export type DteControllerGetXmlApiArg = {
  id: string;
};
export type DteControllerGetXmlUrlApiResponse =
  /** status 200  */ DteXmlUrlResponseDto;
export type DteControllerGetXmlUrlApiArg = {
  id: string;
};
export type DteControllerEmailApiResponse =
  /** status 202  */ DteEmailResponseDto;
export type DteControllerEmailApiArg = {
  id: string;
  emailDteDto: EmailDteDto;
};
export type DteControllerGetPdfApiResponse = unknown;
export type DteControllerGetPdfApiArg = {
  id: string;
  variant?: string;
};
export type EnvioControllerCreateApiResponse =
  /** status 201  */ EnvioResponseDto;
export type EnvioControllerCreateApiArg = {
  createEnvioDto: CreateEnvioDto;
};
export type EnvioControllerSendApiResponse =
  /** status 202  */ EnvioSendQueuedDto;
export type EnvioControllerSendApiArg = {
  id: string;
};
export type EnvioControllerReconcileApiResponse =
  /** status 202  */ ReconcileResultDto;
export type EnvioControllerReconcileApiArg = void;
export type EnvioControllerFindOneApiResponse =
  /** status 200  */ EnvioResponseDto;
export type EnvioControllerFindOneApiArg = {
  id: string;
};
export type EnvioControllerGetXmlApiResponse = unknown;
export type EnvioControllerGetXmlApiArg = {
  id: string;
};
export type IntercambioControllerIngestApiResponse =
  /** status 201  */ IngestResultDto;
export type IntercambioControllerIngestApiArg = {
  ingestEnvioDto: IngestEnvioDto;
};
export type IntercambioControllerListEnviosApiResponse =
  /** status 200  */ InboundEnvioListItemDto[];
export type IntercambioControllerListEnviosApiArg = {
  companyId: string;
};
export type IntercambioControllerGetEnvioApiResponse =
  /** status 200  */ InboundEnvioDetailDto;
export type IntercambioControllerGetEnvioApiArg = {
  id: string;
};
export type IntercambioControllerRespondEnvioApiResponse =
  /** status 200  */ InboundEnvioDetailDto;
export type IntercambioControllerRespondEnvioApiArg = {
  id: string;
  respondEnvioDto: RespondEnvioDto;
};
export type IntercambioControllerDownloadResponseApiResponse = unknown;
export type IntercambioControllerDownloadResponseApiArg = {
  id: string;
  kind: string;
};
export type IntercambioControllerListApiResponse =
  /** status 200  */ InboundDteListResponseDto;
export type IntercambioControllerListApiArg = {
  companyId?: string;
  updatedSince?: string;
  cursor?: string;
  limit?: number;
};
export type IntercambioControllerAcknowledgeApiResponse =
  /** status 200  */ AcknowledgeResultDto;
export type IntercambioControllerAcknowledgeApiArg = {
  id: string;
  acknowledgeDto: AcknowledgeDto;
};
export type IntercambioControllerAcuseReciboApiResponse =
  /** status 200  */ AcknowledgeResultDto;
export type IntercambioControllerAcuseReciboApiArg = {
  id: string;
  acuseReciboDto: AcuseReciboDto;
};
export type SesWebhookControllerReceiveApiResponse =
  /** status 200  */ SesNotificationResultDto;
export type SesWebhookControllerReceiveApiArg = {
  snsEnvelopeDto: SnsEnvelopeDto;
};
export type IntegrationsControllerConnectorsApiResponse =
  /** status 200  */ ConnectorCatalogEntryDto[];
export type IntegrationsControllerConnectorsApiArg = void;
export type IntegrationsControllerPendingCountsApiResponse =
  /** status 200  */ IntegrationPendingCountsDto;
export type IntegrationsControllerPendingCountsApiArg = void;
export type IntegrationsControllerCreateApiResponse =
  /** status 201  */ ConnectionResponseDto;
export type IntegrationsControllerCreateApiArg = {
  createConnectionDto: CreateConnectionDto;
};
export type IntegrationsControllerListApiResponse =
  /** status 200  */ ConnectionResponseDto[];
export type IntegrationsControllerListApiArg = void;
export type IntegrationsControllerBoletaImportApiResponse =
  /** status 201  */ ConnectionResponseDto;
export type IntegrationsControllerBoletaImportApiArg = {
  createBoletaImportDto: CreateBoletaImportDto;
};
export type IntegrationsControllerGetApiResponse =
  /** status 200  */ ConnectionResponseDto;
export type IntegrationsControllerGetApiArg = {
  id: string;
};
export type IntegrationsControllerUpdateApiResponse =
  /** status 200  */ ConnectionResponseDto;
export type IntegrationsControllerUpdateApiArg = {
  id: string;
  updateConnectionDto: UpdateConnectionDto;
};
export type IntegrationsControllerRemoveApiResponse =
  /** status 200  */ ConnectionDeletedDto;
export type IntegrationsControllerRemoveApiArg = {
  id: string;
};
export type IntegrationsControllerRotateCredentialsApiResponse =
  /** status 200  */ ConnectionResponseDto;
export type IntegrationsControllerRotateCredentialsApiArg = {
  id: string;
  rotateCredentialsDto: RotateCredentialsDto;
};
export type IntegrationsControllerHealthApiResponse =
  /** status 200  */ ConnectionHealthDto;
export type IntegrationsControllerHealthApiArg = {
  id: string;
};
export type IntegrationsControllerActivateApiResponse =
  /** status 201  */ ConnectionResponseDto;
export type IntegrationsControllerActivateApiArg = {
  id: string;
};
export type IntegrationsControllerPauseApiResponse =
  /** status 201  */ ConnectionResponseDto;
export type IntegrationsControllerPauseApiArg = {
  id: string;
  pauseConnectionDto: PauseConnectionDto;
};
export type IntegrationsControllerMappingsApiResponse =
  /** status 200  */ MappingResponseDto[];
export type IntegrationsControllerMappingsApiArg = {
  id: string;
};
export type IntegrationsControllerUpsertMappingApiResponse =
  /** status 201  */ MappingResponseDto;
export type IntegrationsControllerUpsertMappingApiArg = {
  id: string;
  upsertMappingDto: UpsertMappingDto;
};
export type IntegrationsControllerImportMastersApiResponse =
  /** status 201  */ MappingImportResultDto;
export type IntegrationsControllerImportMastersApiArg = {
  id: string;
};
export type IntegrationsControllerSyncNowApiResponse =
  /** status 201  */ SyncResultDto;
export type IntegrationsControllerSyncNowApiArg = {
  id: string;
};
export type IntegrationsControllerUploadApiResponse =
  /** status 201  */ BoletaUploadResultDto;
export type IntegrationsControllerUploadApiArg = {
  id: string;
  uploadConnectionFileDto: UploadConnectionFileDto;
};
export type IntegrationsControllerSyncRunsApiResponse =
  /** status 200  */ SyncRunResponseDto[];
export type IntegrationsControllerSyncRunsApiArg = {
  id: string;
  limit?: number;
};
export type IntegrationsControllerDocumentsApiResponse =
  /** status 200  */ IntegrationDocumentResponseDto[];
export type IntegrationsControllerDocumentsApiArg = {
  id: string;
  status?: string;
  limit?: number;
};
export type IntegrationsControllerRetryApiResponse =
  /** status 202  */ IntegrationDocumentQueuedDto;
export type IntegrationsControllerRetryApiArg = {
  connectionId: string;
  documentId: string;
};
export type IntegrationsControllerApproveApiResponse =
  /** status 202  */ IntegrationDocumentQueuedDto;
export type IntegrationsControllerApproveApiArg = {
  connectionId: string;
  documentId: string;
};
export type IntegrationsControllerReconcileApiResponse =
  /** status 201  */ ReconResultDto;
export type IntegrationsControllerReconcileApiArg = {
  id: string;
  reconcileDto: ReconcileDto;
};
export type IntegrationsControllerFindingsApiResponse =
  /** status 200  */ ReconFindingResponseDto[];
export type IntegrationsControllerFindingsApiArg = {
  id: string;
  status?: string;
};
export type IntegrationsControllerResolveFindingApiResponse =
  /** status 201  */ ReconFindingResolvedDto;
export type IntegrationsControllerResolveFindingApiArg = {
  findingId: string;
  status?: string;
};
export type BoletaControllerBuildApiResponse =
  /** status 201  */ BuiltBoletaEnvioDto;
export type BoletaControllerBuildApiArg = {
  createBoletaEnvioDto: CreateBoletaEnvioDto;
};
export type BoletaControllerListApiResponse =
  /** status 200  */ BoletaEnvioListResponseDto;
export type BoletaControllerListApiArg = {
  companyId?: string;
  status?: string;
  from?: string;
  to?: string;
  limit?: number;
  cursor?: string;
};
export type BoletaControllerUploadApiResponse =
  /** status 201  */ BoletaEnvioUploadResultDto;
export type BoletaControllerUploadApiArg = {
  id: string;
};
export type BoletaControllerPollApiResponse =
  /** status 201  */ BoletaEnvioStatusResultDto;
export type BoletaControllerPollApiArg = {
  id: string;
};
export type BoletaControllerGetApiResponse =
  /** status 200  */ BoletaEnvioDetailDto;
export type BoletaControllerGetApiArg = {
  id: string;
};
export type ConsumoFoliosControllerBuildApiResponse =
  /** status 201  */ BuiltConsumoFolioResultDto;
export type ConsumoFoliosControllerBuildApiArg = {
  buildConsumoFoliosDto: BuildConsumoFoliosDto;
};
export type ConsumoFoliosControllerListApiResponse =
  /** status 200  */ ConsumoFolioListResponseDto;
export type ConsumoFoliosControllerListApiArg = {
  companyId?: string;
  status?: string;
  from?: string;
  to?: string;
  limit?: number;
  cursor?: string;
};
export type ConsumoFoliosControllerGetApiResponse =
  /** status 200  */ ConsumoFolioDetailDto;
export type ConsumoFoliosControllerGetApiArg = {
  id: string;
};
export type OnboardingControllerRunApiResponse =
  /** status 201  */ OnboardingResultDto;
export type OnboardingControllerRunApiArg = {
  "idempotency-key": string;
  onboardingDto: OnboardingDto;
};
export type OnboardingControllerPreviewTestSetApiResponse =
  /** status 200  */ TestSetPreviewDto;
export type OnboardingControllerPreviewTestSetApiArg = {
  previewTestSetDto: PreviewTestSetDto;
};
export type OnboardingControllerGetDraftApiResponse =
  /** status 200  */ OnboardingDraftDto;
export type OnboardingControllerGetDraftApiArg = void;
export type OnboardingControllerSaveDraftApiResponse =
  /** status 200  */ OnboardingDraftDto;
export type OnboardingControllerSaveDraftApiArg = {
  saveOnboardingDraftDto: SaveOnboardingDraftDto;
};
export type OnboardingControllerDiscardDraftApiResponse = unknown;
export type OnboardingControllerDiscardDraftApiArg = void;
export type OnboardingControllerEmitTestSetApiResponse =
  /** status 201  */ TestSetEmissionResultDto;
export type OnboardingControllerEmitTestSetApiArg = {
  emitTestSetDto: EmitTestSetDto;
};
export type OnboardingControllerRunSimulationApiResponse =
  /** status 201  */ SimulationResultDto;
export type OnboardingControllerRunSimulationApiArg = {
  createSimulationDto: CreateSimulationDto;
};
export type OnboardingControllerListRunsApiResponse =
  /** status 200  */ CertificationRunListResponseDto;
export type OnboardingControllerListRunsApiArg = {
  companyId?: string;
  kind?: string;
  status?: string;
  limit?: number;
  cursor?: string;
};
export type OnboardingControllerListCertificationLibrosApiResponse =
  /** status 200  */ CertificationLibroDto[];
export type OnboardingControllerListCertificationLibrosApiArg = {
  companyId: string;
};
export type OnboardingControllerStatusApiResponse =
  /** status 200  */ CertificationRunStatusDto;
export type OnboardingControllerStatusApiArg = {
  id: string;
};
export type OnboardingControllerApplyReceptionResultApiResponse =
  /** status 201  */ ApplyReceptionResultSummaryDto;
export type OnboardingControllerApplyReceptionResultApiArg = {
  id: string;
  receptionResultDto: ReceptionResultDto;
};
export type OnboardingControllerAbandonRunApiResponse =
  /** status 200  */ CertificationRunStatusDto;
export type OnboardingControllerAbandonRunApiArg = {
  id: string;
};
export type OnboardingControllerPreviewSimulationApiResponse =
  /** status 200  */ SimulationPreviewDto;
export type OnboardingControllerPreviewSimulationApiArg = {
  previewSimulationDto: PreviewSimulationDto;
};
export type OnboardingControllerEmailMuestrasApiResponse =
  /** status 202  */ MuestrasMailResultDto;
export type OnboardingControllerEmailMuestrasApiArg = {
  emailMuestrasDto: EmailMuestrasDto;
};
export type OnboardingControllerBundleApiResponse = unknown;
export type OnboardingControllerBundleApiArg = {
  id: string;
};
export type EmittedDteImportControllerStartApiResponse =
  /** status 202  */ EmittedDteImportEnqueuedDto;
export type EmittedDteImportControllerStartApiArg = {
  companyId: string;
  createEmittedDteImportDto: CreateEmittedDteImportDto;
};
export type EmittedDteImportControllerListApiResponse =
  /** status 200  */ EmittedDteImportDto[];
export type EmittedDteImportControllerListApiArg = {
  companyId: string;
};
export type EmittedDteImportControllerAvailabilityApiResponse =
  /** status 200  */ EmittedDteImportAvailabilityDto;
export type EmittedDteImportControllerAvailabilityApiArg = {
  companyId: string;
};
export type LibroControllerBuildApiResponse =
  /** status 201  */ BuiltLibroResponseDto;
export type LibroControllerBuildApiArg = {
  buildLibroDto: BuildLibroDto;
};
export type LibroControllerListApiResponse =
  /** status 200  */ LibroListResponseDto;
export type LibroControllerListApiArg = {
  companyId?: string;
  operacion?: string;
  status?: string;
  periodo?: string;
  from?: string;
  to?: string;
  limit?: number;
  cursor?: string;
};
export type LibroControllerUploadApiResponse =
  /** status 201  */ LibroUploadResponseDto;
export type LibroControllerUploadApiArg = {
  id: string;
};
export type LibroControllerPollApiResponse =
  /** status 201  */ LibroStatusResponseDto;
export type LibroControllerPollApiArg = {
  id: string;
};
export type LibroControllerGetApiResponse = /** status 200  */ LibroDetailDto;
export type LibroControllerGetApiArg = {
  id: string;
};
export type SiiAvanceControllerReadApiResponse =
  /** status 200  */ SiiAvanceViewDto;
export type SiiAvanceControllerReadApiArg = {
  companyId: string;
};
export type SiiAvanceControllerDeclareApiResponse =
  /** status 202  */ SiiAvanceDeclarationEnqueuedDto;
export type SiiAvanceControllerDeclareApiArg = {
  companyId: string;
  declareSiiAvanceDto: DeclareSiiAvanceDto;
};
export type SiiAvanceControllerAdvanceStepApiResponse =
  /** status 202  */ SiiAvanceStepAdvanceEnqueuedDto;
export type SiiAvanceControllerAdvanceStepApiArg = {
  companyId: string;
  advanceSiiAvanceStepDto: AdvanceSiiAvanceStepDto;
};
export type SiiAvanceControllerRecordSetVerdictApiResponse =
  /** status 201  */ SetVerdictDto;
export type SiiAvanceControllerRecordSetVerdictApiArg = {
  companyId: string;
  recordSetVerdictDto: RecordSetVerdictDto;
};
export type SiiAvanceControllerRefreshApiResponse =
  /** status 202  */ SiiAvanceRefreshEnqueuedDto;
export type SiiAvanceControllerRefreshApiArg = {
  companyId: string;
};
export type SiiTestSetControllerReadApiResponse =
  /** status 200  */ SiiTestSetViewDto;
export type SiiTestSetControllerReadApiArg = {
  companyId: string;
};
export type SiiTestSetControllerDownloadApiResponse =
  /** status 202  */ SiiTestSetDownloadEnqueuedDto;
export type SiiTestSetControllerDownloadApiArg = {
  companyId: string;
  downloadSiiTestSetDto: DownloadSiiTestSetDto;
};
export type SiiIntercambioSetControllerReadApiResponse =
  /** status 200  */ SiiIntercambioSetViewDto;
export type SiiIntercambioSetControllerReadApiArg = {
  companyId: string;
};
export type SiiIntercambioSetControllerDownloadApiResponse =
  /** status 202  */ SiiIntercambioDownloadEnqueuedDto;
export type SiiIntercambioSetControllerDownloadApiArg = {
  companyId: string;
};
export type HealthControllerCheckApiResponse =
  /** status 200  */ HealthCheckResponseDto;
export type HealthControllerCheckApiArg = void;
export type AdminHealthControllerSnapshotApiResponse =
  /** status 200  */ AdminHealthSnapshotDto;
export type AdminHealthControllerSnapshotApiArg = void;
export type ReportsControllerCuadraturaReportApiResponse =
  /** status 200  */ CuadraturaReportDto;
export type ReportsControllerCuadraturaReportApiArg = {
  /** First issue date included (`YYYY-MM-DD`). */
  from: string;
  /** Last issue date included (`YYYY-MM-DD`), inclusive. */
  to: string;
  /** Restricts the report to one emisor; omitted covers every company. */
  companyId?: string;
};
export type SandboxControllerCreateApiResponse =
  /** status 201  */ SandboxCompanyDto;
export type SandboxControllerCreateApiArg = {
  createSandboxDto: CreateSandboxDto;
};
export type SandboxControllerListApiResponse =
  /** status 200  */ SandboxCompanySummaryDto[];
export type SandboxControllerListApiArg = void;
export type SandboxControllerTopUpApiResponse =
  /** status 201  */ SandboxCafDto;
export type SandboxControllerTopUpApiArg = {
  companyId: string;
  topUpFoliosDto: TopUpFoliosDto;
};
export type SandboxControllerTopUpByPathApiResponse =
  /** status 201  */ SandboxCafDto;
export type SandboxControllerTopUpByPathApiArg = {
  companyId: string;
  dteType: number;
  quantity?: number;
};
export type EmailVerificationStatusDto = {
  /** The address the code goes to, so the screen can show it back. */
  email: string;
  /** Whether this person has already proved the address is theirs. */
  verified: boolean;
};
export type EmailVerificationSentDto = {
  /** Seconds before a resend is accepted. The screen counts this down rather
    than guessing the floor, so the two cannot drift apart. */
  resendAfterSeconds: number;
};
export type VerifyEmailDto = {
  /** The six digits from the message. Kept as a string, not a number: a code
    may legitimately start with a zero, and `042719` parsed as a number is
    `42719` — a code that can never match. */
  code: string;
};
export type PhoneVerificationStatusDto = {
  /** The verified number, masked to its last four digits — enough for somebody
    to recognise their own, and not enough to be worth leaking. `null` when
    there is nothing verified yet. */
  phone: string | null;
  /** Whether this person has already proved the number reaches them. */
  verified: boolean;
  /** Whether a code can actually be delivered in this environment. `false` means
    no provider is configured, and the screen says so instead of leaving
    somebody waiting for a message that is never sent. */
  available: boolean;
};
export type PhoneCodeSentDto = {
  /** Seconds before a resend is accepted. The screen counts this down rather
    than guessing the floor, so the two cannot drift apart. */
  resendAfterSeconds: number;
  /** What it actually went out on. Asking for WhatsApp and being told it went by
    SMS is the difference between looking in the right app and thinking the
    code never arrived. */
  channel: "whatsapp" | "sms";
  /** The number it went to, masked to its last four digits. */
  phone: string;
};
export type SendPhoneCodeDto = {
  /** The number, as the person wrote it. Normalized to E.164 by the service
    rather than by this validator, because a rejection has to say what is wrong
    with the number — and because there is exactly one place that decides what
    `+56 9 8765 4321` means (`src/common/phone.ts`). */
  phone: string;
  /** Where to send it. WhatsApp by default, which is what Chile reads; SMS is
    what somebody picks when their number has no WhatsApp account. */
  channel?: "whatsapp" | "sms";
};
export type VerifyPhoneDto = {
  /** The six digits from the message. Kept as a string, not a number: a code
    may legitimately start with a zero, and `042719` parsed as a number is
    `42719` — a code that can never match. */
  code: string;
};
export type ApiKeySummaryDto = {
  id: string;
  label: string | null;
  isActive: boolean;
  createdAt: string;
  lastUsedAt: string | null;
};
export type AccountTenantDto = {
  id: string;
  name: string;
  slug: string;
  /** The caller's role IN this organisation. Exposed on purpose, so the UI does
    not offer actions that will 403. */
  role: "owner" | "admin" | "member";
  /** What that role allows, already resolved. The SPA has no business carrying a
    second copy of the matrix — two copies drift apart, and the one that lies is
    always the client's, showing a button the backend rejects. See
    `modules/authz/permissions.ts`. */
  permissions: (
    | "company:read"
    | "company:write"
    | "company-users:read"
    | "company-users:write"
    | "certificate:read"
    | "certificate:write"
    | "certificate:self"
    | "caf:read"
    | "caf:write"
    | "caf:annul"
    | "dte:read"
    | "dte:issue"
    | "dte:send"
    | "inbound:read"
    | "inbound:write"
    | "libro:read"
    | "libro:write"
    | "report:read"
    | "integration:read"
    | "integration:operate"
    | "integration:write"
    | "company:create"
    | "members:read"
    | "members:write"
    | "apikey:read"
    | "apikey:write"
    | "settings:read"
    | "settings:write"
  )[];
  isActive: boolean;
  /** What the ORGANIZATION is entitled to, which is a different question from
    the role above — see `modules/authz/entitlements.ts`. The SPA needs it to
    state the trial in one line and to stop offering what a plan does not
    include, rather than letting people find out by being refused. */
  plan: "trialing" | "certifying" | "active" | "free" | "past_due" | "canceled";
  /** When the trial runs out, ISO 8601, or `null` when there is no clock —
    a paying tenant, a tenant that never trialed, and a `certifying` one whose
    clock is stopped while the SII reviews. */
  trialExpiresAt: string | null;
  /** Empty for anyone without `apikey:read`: these are metadata (never the
    secret), but "which machines can act as this organisation" is still
    administrative information. */
  apiKeys: ApiKeySummaryDto[];
  /** The empresa this caller was last working on IN THIS organisation, or `null`
    for one they have never chosen in it. It is a remembered preference, not an
    assertion that the empresa still exists: whoever restores it reconciles it
    against `GET /api/companies` first. See `PUT /api/account/selection`. */
  lastCompanyId: string | null;
};
export type AccountResponseDto = {
  email: string;
  /** The user's id. The SPA needs it to know which of a company's certificates is
    THEIRS, and to avoid offering itself the remove and change-role buttons. */
  userId: string | null;
  tenants: AccountTenantDto[];
  /** The organisation this caller was last working in, or `null`. Together with
    the matching tenant's `lastCompanyId` it is what lets the identity strip
    come back on the right pair from a device that has never seen this account —
    the browser's own copy of the selection only ever covers that browser.
    
    Always one of `tenants`, or `null`: a membership that is gone takes its
    memory with it. The client reconciles it anyway, because a list can change
    between two requests. */
  lastTenantId: string | null;
};
export type UpdateSelectionDto = {
  /** The organisation. Must be one the caller belongs to; anything else is a 403,
    with the same message whether or not it exists (there is no oracle for
    tenant ids). */
  tenantId: string;
  /** The empresa inside that organisation, or omitted for "none chosen" — which
    is what a caller with no companies yet sends.
    
    It is stored as given. Companies live in the per-tenant schemas and this
    plane does not enter them, so the id is a HINT: it is never an authorisation
    (the data plane authorises per empresa on its own) and whoever restores it
    reconciles it against `GET /api/companies` first. The worst a wrong value
    can do is be discarded on the next read. */
  companyId?: string | null;
};
export type OnboardingGateDto = {
  /** Whether the sequence is demanded of this person at all. `false` for anybody
    who existed before it did — they are not sent anywhere. */
  required: boolean;
  /** The step they are on, or `null` when nothing is left. The SPA navigates to
    it; it does not compute it. */
  next: ("segment" | "verify-email" | "verify-phone") | null;
  emailVerified: boolean;
  phoneVerified: boolean;
  segmentAnswered: boolean;
  /** Whether a phone code can be delivered in this environment. `false` takes
    the phone step out of the sequence: a step nobody can complete is a trap,
    not a gate. It is never a choice offered to the person. */
  phoneVerificationAvailable: boolean;
};
export type TenantSegmentDto = {
  segment:
    | (
        | "not_issuing"
        | "sii_free_system"
        | "other_provider"
        | "accountant"
        | "api_integration"
      )
    | null;
  /** ISO 8601, or `null` while the question has never been put. */
  answeredAt: string | null;
};
export type UpdateSegmentDto = {
  /** How this organization issues its tax documents today. One of
    `not_issuing`, `sii_free_system`, `other_provider`, `accountant`,
    `api_integration`.
    
    Explicitly nullable, and `null` is not the same as leaving it out: it
    records that the question was put and skipped, so the screen stops asking. */
  segment?:
    | (
        | "not_issuing"
        | "sii_free_system"
        | "other_provider"
        | "accountant"
        | "api_integration"
      )
    | null;
};
export type IssuedApiKeyDto = {
  apiKeyId: string;
  /** The cleartext value. Shown once, and never obtainable again. */
  apiKey: string;
  label: string;
};
export type MemberDto = {
  userId: string;
  email: string;
  role: "owner" | "admin" | "member";
  /** When they were added to this organisation. */
  createdAt: string;
  /** `false` for as long as the person has never signed in through SSO. The
    screen uses it to explain why someone just added "does not show up": the
    membership exists from the outset, but the account is linked on their first
    sign-in. */
  hasSignedIn: boolean;
};
export type MemberListDto = {
  members: MemberDto[];
};
export type AddMemberDto = {
  /** The email the person signs in to TCIT's SSO with. It is the identity: no
    invitation is sent and no password is created here (see
    `UserService.findOrCreateByEmail`). */
  email: string;
  role: "owner" | "admin" | "member";
};
export type UpdateMemberRoleDto = {
  role: "owner" | "admin" | "member";
};
export type SignupResponseDto = {
  tenantId: string;
  /** The API key in the clear. **It travels exactly once**: it is stored hashed,
    so there is no way to recover it — whoever loses it has to sign in through
    SSO and mint another one at `/account`. */
  apiKey: string;
  organizationSlug: string;
  organizationName: string;
  /** `false` when the SSO provisioning could not be done (best-effort, it never
    blocks the signup). The API key above works regardless. */
  ssoUserProvisioned: boolean;
};
export type SignupDto = {
  organizationName: string;
  /** The organisation's slug. **Optional**: left out, it is derived from
    `organizationName` and a collision is resolved with a numeric suffix
    rather than answered with a 409. Supply it to choose your own — an API
    caller may well care what it is — and a conflict is still a 409 then,
    because a slug you asked for and did not get is worth being told about. */
  organizationSlug?: string;
  email: string;
  /** Optional password for the SSO account created during signup. Only
    forwarded to tcit-doorkeeper — factit never stores it. The provider
    requires 1 uppercase, 1 lowercase, 1 digit and 1 special character;
    when absent or weak it generates "<firstname>Tcit#1234" instead. */
  password?: string;
};
export type SupportChatTokenDto = {
  /** JWT for `zE('messenger', 'loginUser', ...)`. */
  token: string;
  /** Seconds until the token expires. */
  expiresInSeconds: number;
};
export type CardOnFileDto = {
  /** `pending` a setup started and not finished, `requires_action` 3-D Secure in
    flight, `active` a card saved and chargeable, `failed` a setup that was
    declined, `detached` a card that was removed. */
  status: "active" | "pending" | "requires_action" | "failed" | "detached";
  brand: string | null;
  lastFour: string | null;
  expMonth: number | null;
  expYear: number | null;
  /** The provider's decline reason, when there was one. */
  lastError: string | null;
};
export type BillingStatusDto = {
  /** Whether a card can be taken in THIS environment. `false` in dev, in CI and
    in every review app, where the wizard still has to run — so the screen
    skips the step rather than showing a broken one. */
  available: boolean;
  /** The provider's publishable key, which is public by design and is what the
    browser needs to mount the Element. `null` when unavailable. */
  publishableKey: string | null;
  /** What is on file, or `null` when nothing has been started. */
  card: CardOnFileDto | null;
};
export type SetupSessionDto = {
  /** What the browser mounts the Payment Element with. It authorises confirming
    this ONE setup and nothing else, which is why it is the only thing that
    crosses to the client. */
  clientSecret: string;
  setupIntentId: string;
};
export type ConfirmSetupDto = {
  /** The SetupIntent the browser just confirmed. It is an identifier and not a
    result: the outcome is read from the provider, so a caller cannot report a
    card as active by saying so. */
  setupIntentId: string;
};
export type WebhookAckDto = {
  /** Always `true`. The provider needs a 200 to stop retrying, and an event this
    endpoint does not act on is still an event it received — a refusal there
    would accumulate failed deliveries and get the endpoint disabled. */
  received: boolean;
};
export type BranchDto = {
  code: string;
  name?: string;
  address?: string;
};
export type CompanyResponseDto = {
  /** The caller's role IN THIS COMPANY, already resolved: the one from
    `company_user`, or `admin` when they are `owner`/`admin` of the organisation
    — those administer every company. `null` never arrives down this path,
    because a company you cannot see is not listed either. */
  callerRole: ("admin" | "operator" | "viewer") | null;
  /** What that role allows, already resolved. The SPA carries no second copy of
    the matrix: two copies drift apart, and the one that lies is always the
    client's, offering a button the backend rejects. See
    `modules/authz/permissions.ts`. */
  callerPermissions: (
    | "company:read"
    | "company:write"
    | "company-users:read"
    | "company-users:write"
    | "certificate:read"
    | "certificate:write"
    | "certificate:self"
    | "caf:read"
    | "caf:write"
    | "caf:annul"
    | "dte:read"
    | "dte:issue"
    | "dte:send"
    | "inbound:read"
    | "inbound:write"
    | "libro:read"
    | "libro:write"
    | "report:read"
    | "integration:read"
    | "integration:operate"
    | "integration:write"
    | "company:create"
    | "members:read"
    | "members:write"
    | "apikey:read"
    | "apikey:write"
    | "settings:read"
    | "settings:write"
  )[];
  id: string;
  taxNumber: string;
  legalName: string;
  /** GiroEmis. Required in order to issue at all. */
  businessActivity: string | null;
  /** Economic activity codes. At least one is needed in order to issue. */
  acteco: number[] | null;
  address: string | null;
  district: string | null;
  city: string | null;
  branches: BranchDto[] | null;
  /** Date of the resolution authorising issuance (YYYY-MM-DD). */
  resolutionDate: string | null;
  resolutionNumber: string | null;
  /** The SII Dirección Regional / Unidad printed under the timbre. When it is
    missing, the printed samples come out reading "S.I.I. - SIN INFORMAR" and the
    SII objects to them. */
  siiRegionalOffice: string | null;
  /** Geography, not consent: it picks the SII host (maullín vs palena). The folio
    automation is enabled separately, through `siiRpaEnabled`. */
  isProduction: boolean;
  /** A fictitious company in the sandbox environment (P-4): a self-signed
    certificate and synthetic CAFs the SII never issued. It is independent of
    `isProduction`, and the database stops a sandbox company pointing at
    production.
    
    **It travels in the response because the UI needs BOTH booleans** to say
    which environment a company is in. While it was missing,
    `deriveCompanyEnvironment` received a hardcoded `false` and a sandbox
    company showed up as "Certificación" in the issuance filters and in the
    company listing. That indicator is the second line of defence after the
    `AppShell` badge, and both exist for the same reason: so nobody issues
    believing they are testing. A consumed folio does not come back. */
  isSandbox: boolean;
  /** The company's intercambio casilla. **It has to be registered with the SII**
    for the reception results and inbound DTEs to route back. */
  exchangeEmail: string | null;
  createdAt: string;
  updatedAt: string;
};
export type CreateCompanyDto = {
  taxNumber: string;
  legalName: string;
  businessActivity?: string;
  acteco?: number[];
  address?: string;
  district?: string;
  city?: string;
  branches?: BranchDto[];
  resolutionDate?: string;
  resolutionNumber?: string;
  /** The head office's SII Dirección Regional (or Unidad), e.g. "SANTIAGO
    CENTRO". Printed under the folio box as "S.I.I. - <unidad>" on the muestras
    impresas (Manual de Muestras Impresas §1.1.4). Read it from "Mi SII" /
    "Datos para la construcción de DTE". */
  siiRegionalOffice?: string;
  isProduction?: boolean;
  exchangeEmail?: string;
};
export type UpdateCompanyDto = {
  taxNumber?: string;
  legalName?: string;
  businessActivity?: string;
  acteco?: number[];
  address?: string;
  district?: string;
  city?: string;
  branches?: BranchDto[];
  resolutionDate?: string;
  resolutionNumber?: string;
  /** The head office's SII Dirección Regional (or Unidad), e.g. "SANTIAGO
    CENTRO". Printed under the folio box as "S.I.I. - <unidad>" on the muestras
    impresas (Manual de Muestras Impresas §1.1.4). Read it from "Mi SII" /
    "Datos para la construcción de DTE". */
  siiRegionalOffice?: string;
  isProduction?: boolean;
  exchangeEmail?: string;
};
export type SiiCredentialsStatusDto = {
  configured: boolean;
  /** The company's explicit consent for the RPA to request folios on its own.
    Independent of `isProduction`. */
  rpaEnabled: boolean;
  /** A **partial** RUT (`12***-5`): it identifies a natural person, so it confirms
   *which one* without repeating it in full. The UI must not try to complete it. */
  userRut: string | null;
};
export type SetSiiCredentialsDto = {
  /** RUT of the natural person who owns the certificate. Different from the
    company's RUT: the certificate authenticates the person, and the timbraje is
    done on the contribuyente. */
  siiUserRut: string;
  /** Opt in to the automatic folio request. Defaults to false. */
  siiRpaEnabled?: boolean;
};
export type PromoteToProductionDto = {
  resolutionDate: string;
  resolutionNumber: string;
};
export type CompanyUserDto = {
  userId: string;
  email: string;
  role: "admin" | "operator" | "viewer";
  /** When they were authorised on this company. */
  createdAt: string;
  /** `false` for as long as the person has never signed in through SSO. The
    screen uses it to explain why someone just authorised "does not show up":
    the authorisation exists from the outset, and the account is linked on their
    first sign-in. */
  hasSignedIn: boolean;
  /** `true` when the role does NOT come from a `company_user` row but from being
    `owner`/`admin` of the organisation, who administer every company. The
    screen does not offer to remove them from here: there is nothing to remove,
    and the change belongs at the organisation level. */
  fromOrganization: boolean;
};
export type CompanyUserListDto = {
  users: CompanyUserDto[];
};
export type AuthorizeCompanyUserDto = {
  /** The email the person signs in to TCIT's SSO with. If they do not belong to
    the organisation yet, they are added as a `member` — belonging enables
    nothing by itself; what they will be able to do comes from this role. */
  email: string;
  role: "admin" | "operator" | "viewer";
};
export type UpdateCompanyUserRoleDto = {
  role: "admin" | "operator" | "viewer";
};
export type CertificateResponseDto = {
  id: string;
  companyId: string;
  /** Whose it is: the holder's user id, or `null` when it is the organisation's
    certificate. In the SII's model a certificate belongs to a PERSON — "de uso
    personal e intransferible" — and every authorised user signs with their own;
    see `docs/USUARIOS_Y_ROLES.md`. */
  userId: string | null;
  /** RUT of the certificate holder (the natural person who signs). */
  subjectTaxNumber: string;
  subjectCommonName: string | null;
  validFrom: string;
  /** Expiry. The dashboard warns within a 30-day window. */
  validTo: string;
  fingerprint: string;
  isActive: boolean;
};
export type UploadCertificateDto = {
  /** Base64-encoded PKCS#12 file. */
  p12Base64: string;
  passphrase: string;
  /** `company` (the default) replaces the organisation's certificate: the one the
    background jobs use — the upload to the SII, the status poll, the folio RPA
    — and any call made with an api key, because there is no person behind
    those. Requires `certificate:write`.
    
    `personal` stores the certificate of WHOEVER is making the call, and only
    what that person issues gets signed with it. Requires `certificate:self`,
    which the operator also holds: that is what lets them sign with their own
    without being able to touch anyone else's. It demands a session — an api key
    has no holder to assign it to, so the call is rejected rather than falling
    back to `company`.
    
    The default is `company` on purpose: it is what every client that already
    exists was doing, and changing it under them would move the certificate
    today's signatures are made with. */
  scope?: "company" | "personal";
};
export type CafSummaryDto = {
  id: string;
  dteType: number;
  folioFrom: number;
  folioTo: number;
  /** The authorisation date. For the types carrying crédito fiscal (33, 43, 46,
    56, 61) the CAF expires 6 months after this date, and an expired CAF counts
    as **0 available folios** because the SII rejects it — glosa
    `(CAF-3-517) RECHAZO – CAF VENCIDO`. */
  authorizationDate: string;
  idk: number;
  status: "active" | "exhausted" | "expired";
  createdAt: string;
};
export type UploadCafDto = {
  xml: string;
};
export type CafPreviewDto = {
  dteType: number;
  folioFrom: number;
  folioTo: number;
  folioCount: number;
  authorizationDate: string;
  idk: number;
  rutEmisor: string;
  razonSocialEmisor: string;
  rsaModulus: string;
  /** `verified` = the SII's signature checks out. `skipped`/`unverifiable` do
    not block the upload, but they are reported. */
  siiSignatureStatus: "skipped" | "verified" | "unverifiable";
  warning?: string;
};
export type AnnulmentCandidateDto = {
  /** The CAF it belongs to; `null` for a gap, which no CAF of this company covers. */
  cafId: string | null;
  companyId: string;
  dteType: number;
  /** The range's ends, inclusive. */
  folioFrom: number;
  folioTo: number;
  count: number;
  /** The CAF's authorisation date, or the consultation's, when known. */
  authorizationDate: string | null;
  /** `expired`: unused or returned folios of a CAF that lost its vigencia.
    `gap`: assigned to the RUT by the SII but held by no CAF of this company.
    `rejected`: folios of DTEs the SII rejected; reported only, never annullable. */
  reason: "rejected" | "expired" | "gap";
  /** `factit_data`: this company's own CAFs and documents. `factit_accounts`: a
    CAF of another factit company with the same RUT. `sii_consultation`: the
    latest SII folio consultation. */
  source: "factit_data" | "factit_accounts" | "sii_consultation";
  /** True when any folio of it lies inside a CAF of another factit company of the RUT. */
  heldByOtherAccount: boolean;
  /** For a gap seen by a consultation: when the SII page was read. */
  observedAt: string | null;
  /** Whether a request to annul it would be accepted now. */
  annullable: boolean;
  /** Why it may not be annulled, exactly when `annullable` is false. */
  blockedReason:
    | (
        | "reason_not_enabled"
        | "assigned_elsewhere"
        | "in_use"
        | "received_by_sii"
        | "stale_consultation"
        | "partial_not_supported"
        | "precheck_source_missing"
        | "annulment_open"
      )
    | null;
  /** A request must carry `acknowledgeExternalUse: true` (a gap outside every factit CAF). */
  requiresAcknowledgeExternalUse: boolean;
  /** A request must carry `acknowledgeOtherCompanyCaf: true` (`heldByOtherAccount`). */
  requiresAcknowledgeOtherCompanyCaf: boolean;
  /** The hash of the candidate as listed; a request must send it back unchanged. */
  payloadHash: string;
};
export type FolioRequestDto = {
  id: string;
  companyId: string;
  dteType: number;
  /** The CAF that resolved the request. `null` until one arrives. */
  cafId: string | null;
  trigger: "manual" | "low" | "exhausted" | "reconcile";
  status:
    "pending" | "failed" | "in_progress" | "fulfilled" | "awaiting_manual";
  /** Folios left when it fired: this is what explains the urgency. */
  remainingAtTrigger: number;
  /** How many were requested. It comes from the policy in effect at that moment. */
  quantity: number;
  /** Real provisioning runs. It does not include the re-notices. */
  attempts: number;
  /** Re-notices sent by this request.
    
    It goes apart from `attempts` because they are different things, and
    together they lied: an `attempts` of 100 on an `awaiting_manual` row was
    almost all reminders every six hours, not a hundred runs against the SII's
    portal. */
  manualNudges: number;
  /** The request is barred from the automatic path. The RPA marks it when the
    SII has already assigned a range factit did not manage to store: retrying
    would request another range and leave the previous one lost, so the retake
    must only notify again. */
  manualOnly: boolean;
  /** A notice went out that the automation loaded a CAF and the company was
    **still** below the threshold. The SII limits how much it authorises at a
    time, so insisting does not fix it; the mark exists to avoid one email per
    folio arriving in dribs and drabs. */
  insufficientNotifiedAt: string | null;
  /** What the SII's form declared on this run: how much it authorises
    downloading now (`MAX_AUTOR`) and how many unused folios it believes the
    contribuyente holds (`FOLIOS_DISP`).
    
    **The second explains the first.** The Informativo de Timbraje says the
    maximum is computed by discounting the available folios the contribuyente
    already holds, so a low ceiling almost always means folios assigned to DTEs
    that were never sent. Null when the port only notified a human (it has
    nowhere to get them from) and for the types with no declared ceiling. */
  siiMaxAutor: number | null;
  siiFoliosDisp: number | null;
  lastError: string | null;
  resolvedAt: string | null;
  createdAt: string;
  /** The cursor's basis; the database's `set_updated_at` trigger maintains it. */
  updatedAt: string;
};
export type FolioPolicyDto = {
  companyId: string;
  dteType: number;
  /** Folios available today across the valid CAFs. An expired CAF contributes 0. */
  available: number;
  /** The threshold in effect: the greater of the configured floor and the rate reorder point. */
  lowThreshold: number;
  /** The quantity in effect: the greater of the configured floor and what is missing to reach the target. */
  requestQuantity: number;
  /** Where the threshold came from. `rate` = measured consumption lifted it
    above the floor; `policy` = there is an explicit row; `env` = the
    deployment default. */
  lowThresholdSource: "policy" | "rate" | "env";
  /** Where the quantity came from. `target` = the coverage target lifted it;
    `policy` / `company` / `env` = the three levels of configuration, most
    specific to least. */
  requestQuantitySource: "company" | "target" | "policy" | "env";
  /** Folios per day measured over recent history. 0 when there is not enough of it. */
  dailyRate: number;
  /** Days of cover left at the current pace. `null` when the pace is 0. */
  daysOfCover: number | null;
  /** What is written in `company_folio_policy`, unresolved. `null` in each field
    the row does not pin — or when there is no row — which is what tells "it is
    configured at 20" apart from "it landed on 20 because that is the default". */
  configuredLowThreshold: number | null;
  configuredRequestQuantity: number | null;
  /** `available <= lowThreshold`: the same criterion the cron warns by. */
  isLow: boolean;
  /** The open request for this type, when there is one. There is a single one
    per (company, type) — the partial index `folio_request_open_unique`
    guarantees it — so this is an object and not an array. */
  openRequest: FolioRequestDto | null;
};
export type UpdateFolioPolicyDto = {
  lowThreshold?: number | null;
  requestQuantity?: number | null;
};
export type FolioRequestListResponseDto = {
  items: FolioRequestDto[];
  /** `null` when no pages are left. */
  nextCursor: string | null;
};
export type FolioAutomationStatusDto = {
  /** True when a request would open the browser against the SII's portal. */
  automatic: boolean;
  /** Why the automatic path would not run, for a person to act on. `null` when
    it would.
    
    It is the same string the worker logs, deliberately: the deployment-level
    ones name the environment variable to fix, and the company-level ones name
    the flag or the field. A friendlier paraphrase would cost the reader the
    one thing they need in order to fix it. */
  reason: string | null;
};
export type FolioRequestEnqueuedDto = {
  companyId: string;
  dteType: number;
  /** The request already open for this (company, type) at the moment of
    queueing, or `null`.
    
    It is the difference between "it was queued and will run" and "there was
    already one in progress and the worker will re-take it", and whoever
    presses the button needs to tell them apart: with a recent
    `awaiting_manual`, `claimRequest` does not re-take it until it goes stale,
    so the click changes nothing yet and saying so stops someone pressing it five times. */
  openRequest: FolioRequestDto | null;
};
export type RequestFoliosNowDto = {
  /** The document type folios are requested for.
    
    There is no "all types": the SII authorises per type, the
    `folio_request_open_unique` index is per (company, type), and a button that
    fired all eight at once would spend eight timbrajes on one click. */
  dteType: number;
};
export type FolioConsultationDto = {
  id: string;
  companyId: string;
  status: "pending" | "failed" | "in_progress" | "succeeded";
  /** `manual` (the button) or `after_annulment`. */
  trigger: string;
  requestedBy: string | null;
  attempts: number;
  errorCode: string | null;
  errorMessage: string | null;
  /** When the SII page was read. */
  observedAt: string | null;
  createdAt: string;
};
export type SiiAssignedRangeDto = {
  dteType: number;
  folioFrom: number;
  folioTo: number;
  authorizationDate: string | null;
};
export type SiiFolioCounterDto = {
  dteType: number;
  maxAutor: number | null;
  foliosDisp: number | null;
};
export type LatestFolioConsultationDto = {
  consultation: FolioConsultationDto | null;
  /** When the SII was last read successfully; gap staleness is measured from it. */
  lastObservedAt: string | null;
  ranges: SiiAssignedRangeDto[];
  counters: SiiFolioCounterDto[];
};
export type FolioAnnulmentEventDto = {
  at: string;
  fromStatus: string | null;
  toStatus: string;
  /** A user id, an API key reference (`apikey:<id>`) or `worker`. */
  actor: string;
  detail: string | null;
};
export type FolioAnnulmentDto = {
  /** Why it ended where it did. */
  errorCode:
    | (
        | "flag_off"
        | "portal_unusable"
        | "consent_off"
        | "sandbox"
        | "environment_pinned"
        | "production_blocked"
        | "company_opt_out"
        | "sii_permission_missing"
        | "hash_mismatch"
        | "not_a_candidate"
        | "reason_not_enabled"
        | "stale_consultation"
        | "precheck_source_missing"
        | "annulment_open"
        | "assigned_elsewhere"
        | "caf_elsewhere_unconfirmed"
        | "in_use"
        | "received"
        | "precheck_unproven"
        | "range_mismatch"
        | "config"
        | "launch"
        | "timeout"
        | "certificate"
        | "portal"
        | "sii_refused"
        | "unknown_after_submit"
      )
    | null;
  id: string;
  companyId: string;
  dteType: number;
  folioFrom: number;
  folioTo: number;
  count: number;
  reason: "expired" | "gap";
  /** The confirmation of several ranges this one came from; `null` for a single annulment. */
  batchId: string | null;
  /** `pending` and `in_progress` are in flight; `succeeded`, `refused`, `stopped`
    and `failed` are final; `unknown_after_submit` means the irreversible step
    was sent and the answer is not known, and is settled by a verification. */
  status:
    | "pending"
    | "failed"
    | "in_progress"
    | "succeeded"
    | "refused"
    | "stopped"
    | "unknown_after_submit";
  /** User id of the person who confirmed it. */
  requestedBy: string | null;
  confirmedAt: string;
  payloadHash: string;
  acknowledgeExternalUse: boolean;
  acknowledgeOtherCompanyCaf: boolean;
  /** When the run reached the irreversible step, if it did. */
  submitReachedAt: string | null;
  attempts: number;
  errorMessage: string | null;
  /** The answer page's text, verbatim. */
  siiResponseText: string | null;
  diagnosticsKey: string | null;
  /** The last authorised maximum the SII showed for the type before the annulment. */
  maxAutorBefore: number | null;
  /** The first one observed after it succeeded. */
  maxAutorAfter: number | null;
  resolvedAt: string | null;
  createdAt: string;
  /** The status transitions, oldest first. */
  events: FolioAnnulmentEventDto[];
};
export type CreateFolioAnnulmentDto = {
  /** The confirmation word the person typed. It must be exactly the expected word. */
  confirmationText: string;
  /** The document type of the candidate. */
  dteType: number;
  /** The candidate's first folio. v1 annuls whole candidate ranges only. */
  folioFrom: number;
  /** The candidate's last folio. */
  folioTo: number;
  /** The candidate's reason. Rejected folios are never annullable. */
  reason: "expired" | "gap";
  /** The `payloadHash` of the candidate as it was listed; a different one is a 409. */
  payloadHash: string;
  /** Required for a gap outside every factit CAF: the person confirms no other
    system uses these folios. */
  acknowledgeExternalUse?: boolean;
  /** Required when the candidate lies inside a CAF of another factit company of
    the same RUT: the person confirms that company will not use these folios.
    Its administrators are notified once the annulment succeeds. */
  acknowledgeOtherCompanyCaf?: boolean;
};
export type FolioAnnulmentBatchDto = {
  /** Shared by the rows of the confirmation; `null` when it carried a single range. */
  batchId: string | null;
  annulments: FolioAnnulmentDto[];
};
export type FolioAnnulmentItemDto = {
  /** The document type of the candidate. */
  dteType: number;
  /** The candidate's first folio. v1 annuls whole candidate ranges only. */
  folioFrom: number;
  /** The candidate's last folio. */
  folioTo: number;
  /** The candidate's reason. Rejected folios are never annullable. */
  reason: "expired" | "gap";
  /** The `payloadHash` of the candidate as it was listed; a different one is a 409. */
  payloadHash: string;
  /** Required for a gap outside every factit CAF: the person confirms no other
    system uses these folios. */
  acknowledgeExternalUse?: boolean;
  /** Required when the candidate lies inside a CAF of another factit company of
    the same RUT: the person confirms that company will not use these folios.
    Its administrators are notified once the annulment succeeds. */
  acknowledgeOtherCompanyCaf?: boolean;
};
export type CreateFolioAnnulmentBatchDto = {
  /** The candidate ranges to annul, each as it was listed. All are accepted, or none. */
  items: FolioAnnulmentItemDto[];
  /** The confirmation word the person typed, once for every range. */
  confirmationText: string;
};
export type FolioAnnulmentSettingsDto = {
  /** The first gate that keeps the annulment from running, or `null`. */
  firstFailingGate:
    | (
        | "flag_off"
        | "portal_unusable"
        | "consent_off"
        | "sandbox"
        | "environment_pinned"
        | "production_blocked"
        | "company_opt_out"
        | "sii_permission_missing"
      )
    | null;
  /** The first gate that keeps the read-only SII consultation from running, or `null`. */
  consultationGate:
    | (
        | "flag_off"
        | "portal_unusable"
        | "consent_off"
        | "sandbox"
        | "environment_pinned"
        | "production_blocked"
        | "company_opt_out"
        | "sii_permission_missing"
      )
    | null;
  /** The per-company opt-in. */
  enabled: boolean;
  enabledBy: string | null;
  enabledAt: string | null;
  /** When the portal last refused for lack of the SII user attribute. */
  lastSiiPermissionRefusalAt: string | null;
  /** Whether that refusal still blocks the action. */
  siiPermissionMissing: boolean;
  siiPermissionRestoredBy: string | null;
  siiPermissionRestoredAt: string | null;
};
export type UpdateFolioAnnulmentSettingsDto = {
  /** The per-company opt-in to annulling folios from factit. */
  enabled?: boolean;
  /** An explicit acknowledgement that the SII user attribute to annul folios was
    granted again after the portal refused for lack of it. Only `true` is
    meaningful. */
  siiPermissionRestored?: boolean;
};
export type EventCatalogResponseDto = {
  /** The one place in the inventory that needs an explicit `@ApiProperty`: the
    plugin does not resolve a `readonly` array of a literal union and reports it
    as a circular dependency, so the enum is declared by hand. */
  events: (
    | "dte.issued"
    | "dte.sent"
    | "dte.accepted"
    | "dte.objected"
    | "dte.rejected"
    | "inbound_dte.received"
    | "folios.low"
    | "folios.exhausted"
    | "integration.document_failed"
    | "integration.connection_paused"
  )[];
};
export type EventCountByNameDto = {
  name: string;
  count: number;
};
export type DomainEventResponseDto = {
  id: string;
  name:
    | "dte.issued"
    | "dte.sent"
    | "dte.accepted"
    | "dte.objected"
    | "dte.rejected"
    | "inbound_dte.received"
    | "folios.low"
    | "folios.exhausted"
    | "integration.document_failed"
    | "integration.connection_paused";
  aggregateType:
    | "company"
    | "dte"
    | "envio"
    | "inbound_dte"
    | "integration_connection"
    | "integration_document";
  aggregateId: string | null;
  companyId: string | null;
  payload: {
    [key: string]: any;
  };
  occurredAt: string;
};
export type EventListResponseDto = {
  items: DomainEventResponseDto[];
  /** `null` when no pages remain. */
  nextCursor: string | null;
};
export type WebhookSubscriptionWithSecretDto = {
  /** The secret for validating the signature. **It travels exactly once**: it is
    not stored reversibly, so rotating replaces it and the old one cannot be
    recovered. */
  secret: string;
  id: string;
  url: string;
  description: string | null;
  events: string[];
  isActive: boolean;
  /** Why it disabled itself (e.g. consecutive dead deliveries). */
  disabledReason: string | null;
  createdAt: string;
};
export type CreateWebhookSubscriptionDto = {
  /** `require_tld: false` so internal hosts are not rejected in development; the
    real policy (https, no private ranges) is applied by `checkWebhookUrl`,
    which does distinguish environments. */
  url: string;
  description?: string;
  /** Empty or absent = every event. See GET /api/events/catalog. */
  events?: string[];
};
export type WebhookSubscriptionDto = {
  id: string;
  url: string;
  description: string | null;
  events: string[];
  isActive: boolean;
  /** Why it disabled itself (e.g. consecutive dead deliveries). */
  disabledReason: string | null;
  createdAt: string;
};
export type UpdateWebhookSubscriptionDto = {
  url?: string;
  description?: string;
  events?: string[];
  isActive?: boolean;
};
export type WebhookDeletedDto = {
  deleted: boolean;
};
export type WebhookSecretRotatedDto = {
  id: string;
  /** The new secret. **Shown exactly once.** */
  secret: string;
};
export type WebhookTestQueuedDto = {
  deliveryId: string;
};
export type WebhookDeliveryDto = {
  id: string;
  subscriptionId: string;
  eventId: string | null;
  eventName: string;
  /** `dead` is the end of the 6-attempt ladder (10s → 1m → 5m → 30m → 2h): the
    only way out of it is a manual re-send. */
  status: "pending" | "failed" | "delivered" | "dead";
  attempts: number;
  responseStatus: number | null;
  lastError: string | null;
  deliveredAt: string | null;
  createdAt: string;
  /** The EXACT body that was sent (or is about to be), as stored when the
    delivery was created.
    
    **It is the first thing anyone looks at when diagnosing a dead delivery**,
    and it was the one thing view 33 could not show: without it, an operator saw
    that the customer's endpoint returned 500 and had no way to know WITH WHAT.
    The column existed from the start (`webhook_delivery.payload`); what was
    missing was exposing it.
    
    It is stored with the delivery and not recomputed from the event on purpose:
    a re-send has to deliver the same body that was signed, and the event could
    have changed shape in between. */
  payload: {
    [key: string]: any;
  };
};
export type WebhookResendQueuedDto = {
  id: string;
  status: string;
};
export type DteResponseDto = {
  id: string;
  dteType: number;
  folio: number;
  status:
    | "draft"
    | "queued"
    | "accepted"
    | "rejected"
    | "objected"
    | "sent"
    | "signed"
    | "voided";
  totalAmount: number;
  trackId: string | null;
  /** Folios left in the CAF this document came from. */
  foliosRemaining?: number;
  /** Present when `foliosRemaining` is at or below the configured threshold. */
  foliosWarning?: string;
};
export type DteDispatchDto = {
  indTraslado?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  tipoDespacho?: 1 | 2 | 3;
};
export type DteReceptorDto = {
  taxNumber: string;
  legalName: string;
  businessActivity?: string;
  address?: string;
  district?: string;
  city?: string;
  contactEmail?: string;
  /** Exportación (110/111/112) only: the foreign receptor's tax ID in its own
    country, emitted as <Extranjero><NumId>. Ignored on every other type. */
  foreignTaxId?: string;
};
export type DteItemDto = {
  lineNumber: number;
  name: string;
  description?: string;
  /** These three had `@IsOptional()` and no type validator, so with
    `enableImplicitConversion: false` a string body value (`{"quantity": "5"}`)
    sailed past validation and blew up deeper in the builder as a 500 instead of
    a 400 (code review 2026-07, medio/correctitud DTE). Quantities and prices
    are decimal, hence `@IsNumber` rather than `@IsInt`; `maxDecimalPlaces`
    matches the numeric(18,6) columns they are stored in. */
  quantity?: number;
  unit?: string;
  unitPrice?: number;
  /** A percentage: the SII's DescuentoPct is 0–100 with 2 decimals. */
  discountPct?: number;
  discountAmount?: number;
  /** A percentage: the SII's RecargoPct is 0–100 with 2 decimals. */
  surchargePct?: number;
  surchargeAmount?: number;
  /** MontoItem. A whole number of pesos on every domestic document. An
    exportación (110/111/112) states it in the sale's own currency, with up to
    four decimals as the export schema allows (e.g. 2 × USD 631.58 = 1263.16). */
  lineAmount: number;
  isExempt?: boolean;
  /** Liquidación-Factura (43) only: <TpoDocLiq>, the type of document being
    liquidated (e.g. "33", "39", "61"). */
  tpoDocLiq?: string;
};
export type DteReferenceDto = {
  lineNumber: number;
  /** TpoDocRef: the referenced document's type. Either a DTE or document type
    number (33, 801 orden de compra, 807 DUS…) or one of the SII's 1-3
    character alphanumeric codes (`HES`). Always a string; a JSON number is
    still accepted and converted, so callers written against the old integer
    field keep working. */
  referencedDteType: string;
  /** IndGlobal: the reference covers a set of documents of the referenced type
    rather than a single folio (the folio is then 0). */
  globalIndicator?: boolean;
  referencedFolio: string;
  referencedDate: string;
  referenceCode?: number;
  reason?: string;
};
export type DteGlobalAdjustmentDto = {
  lineNumber: number;
  movement: "D" | "R";
  glosa?: string;
  valueType: "%" | "$";
  value: number;
  /** The D/R applies to the exempt base instead of the taxable one. */
  isExempt?: boolean;
};
export type DteCommissionDto = {
  lineNumber: number;
  type: "C" | "O";
  glosa: string;
  netAmount: number;
  exemptAmount?: number;
};
export type DteAduanaDto = {
  codModVenta?: number;
  codClauVenta?: number;
  totClauVenta?: number;
  codViaTransp?: number;
  codPtoEmbarque?: number;
  codPtoDesemb?: number;
  codUnidMedTara?: number;
  codUnidPesoBruto?: number;
  codUnidPesoNeto?: number;
  totBultos?: number;
  /** Package type code; `totBultos` is its quantity. */
  codTpoBultos?: number;
  marcas?: string;
  /** Container number; required by the SII when the package type is a container. */
  idContainer?: string;
  /** Container seal, with its check digit; required with `idContainer`. */
  sello?: string;
  /** Who issued the seal. */
  emisorSello?: string;
  flete?: number;
  seguro?: number;
  codPaisRecep?: number;
  codPaisDestin?: number;
};
export type DteExportDto = {
  currency: string;
  /** CLP per unit of `currency`, for the mandatory <OtraMoneda> block. */
  tipoCambio?: number;
  nationality?: string;
  /** Export payment method code (FmaPagExp), from the customs payment table. */
  paymentMethod?: number;
  /** Export of services: 3 services invoice, 4 hotel, 5 international land transport. */
  serviceIndicator?: 3 | 4 | 5;
  /** Puerto de embarque / desembarque and país receptor as names — printed on
    the muestra impresa (Manual §1.4); not emitted in the XML. */
  portEmbarque?: string;
  portDesembarque?: string;
  country?: string;
  aduana?: DteAduanaDto;
};
export type DteTransportDto = {
  /** RUTTrans: the carrier's RUT. */
  carrierTaxNumber?: string;
  /** Patente: the vehicle's plate. */
  plate?: string;
  /** RUTChofer: the driver's RUT. Required when `driverName` is given. */
  driverTaxNumber?: string;
  /** NombreChofer: the driver's name. Required when `driverTaxNumber` is given. */
  driverName?: string;
};
export type DteBoletaDto = {
  indServicio?: 1 | 2 | 3 | 4;
  periodoDesde?: string;
  periodoHasta?: string;
  medioPago?: 1 | 2 | 3 | 4 | 5;
};
export type CreateDteDto = {
  companyId: string;
  dteType: 33 | 34 | 39 | 41 | 43 | 46 | 52 | 56 | 61 | 110 | 111 | 112;
  issueDate: string;
  dueDate?: string;
  dispatch?: DteDispatchDto;
  /** Factura de Compra (46) / notes on one: withhold the seller's IVA in full
    (SII TipoImp 15). Defaults to false; the onboarding sets it automatically
    for the certification set. */
  retainVat?: boolean;
  /** Required for every document type except a boleta (39/41), which defaults
    to the SII's consumidor-final receptor (66666666-6) when omitted. */
  receptor?: DteReceptorDto;
  /** RUT the *envío* (SetDTE carátula) is addressed to, when it differs from the
    DTE body's `receptor.taxNumber`. Exports carry RUTRecep=55555555-5 in the
    body but the envelope goes to the real recipient / the SII (60803000-K);
    likewise a traslado-interno guía's body RUTRecep is the emisor. This drives
    the stored receiver used to group and address envíos, keeping the envelope
    consistent while the DTE body keeps its own RUTRecep. Defaults to
    `receptor.taxNumber`. */
  envelopeReceiverTaxNumber?: string;
  items: DteItemDto[];
  references?: DteReferenceDto[];
  /** The SII Set de Pruebas case this document answers, e.g. `CASO 5101886-1`.
    Certification only: when present, the document's first reference line is
    TpoDocRef `SET` with this text as RazonRef, as the SII requires of every
    set document, and `references` follow from line 2. */
  certificationCase?: string;
  /** Global discounts/surcharges (<DscRcgGlobal>). They reduce/raise the
    MntNeto or MntExe base before IVA and must be shown on the printed
    representation (SII set: "los descuentos por línea o globales deben ser
    indicados en las representaciones impresas"). */
  globalAdjustments?: DteGlobalAdjustmentDto[];
  /** Liquidación-Factura (43) only: commission lines to deduct. */
  commissions?: DteCommissionDto[];
  /** Exportación (110/111/112) only: currency + aduana info. */
  exportInfo?: DteExportDto;
  /** Guía de Despacho (52) and Exportación (110/111/112) only: the vehicle,
    carrier and driver, emitted as <Transporte>. Ignored on every other type. */
  transport?: DteTransportDto;
  /** Boleta (39/41) only: IndServicio + optional período / medio de pago. */
  boletaInfo?: DteBoletaDto;
  /** FmaPago: 1 cash, 2 credit, 3 no charge. Emitted on 33, 34, 43, 46, 52, 56
    and 61; ignored on exports (which use `exportInfo.paymentMethod`) and
    boletas. Not stored. */
  paymentForm?: 1 | 2 | 3;
  /** TpoTranVenta (SII `TipoTransVENTA`, 1-4): the kind of sale. Emitted and
    ignored like `paymentForm`. Not stored. */
  saleTransactionType?: number;
  /** TpoTranCompra (SII `TipoTransCOMPRA`, 1-7): the kind of purchase. Emitted
    and ignored like `paymentForm`. Not stored. */
  purchaseTransactionType?: number;
  idempotencyKey?: string;
};
export type DteListItemDto = {
  id: string;
  /** 33, 34, 39, 41, 43, 46, 52, 56, 61, 110, 111 or 112. */
  dteType: number;
  folio: number;
  /** Issue date (YYYY-MM-DD). */
  issueDate: string;
  receiverTaxNumber: string;
  /** The receiver's razón social, so the listing shows more than just the RUT. */
  receiverLegalName: string;
  totalAmount: number;
  status:
    | "draft"
    | "queued"
    | "accepted"
    | "rejected"
    | "objected"
    | "sent"
    | "signed"
    | "voided";
  /** Track ID the SII assigned to the envelope that carried this document. */
  trackId: string | null;
  /** The **live** envelope carrying this document, or `null` if it has not gone
    out in any yet.
    
    It travels with the `envioStatus` filter: being able to filter by envelope
    status without being able to say WHICH envelope would leave the operator's
    screen with a set of documents and no way to act on the envelope grouping
    them (re-send, download the XML, verify the trackId).
    
    "Live" means `superseded_at IS NULL`, the same rule the detail uses: an
    envelope the SII rejected never had its documents evaluated, and those folios
    went out again in a corrected one, so returning the old one would point at an
    envelope that no longer represents the document's status. */
  envioId: string | null;
  createdAt: string;
  /** The incremental-sync cursor's basis; the database trigger maintains it. */
  updatedAt: string;
};
export type DteListResponseDto = {
  items: DteListItemDto[];
  /** `null` when no pages remain. */
  nextCursor: string | null;
};
export type SourceXmlReceptorDto = {
  taxNumber: string;
  legalName: string;
  businessActivity: string | null;
  address: string | null;
  district: string | null;
  city: string | null;
  /** Exportación only: <Extranjero><NumId>, the receptor's tax ID abroad. */
  foreignTaxId: string | null;
};
export type SourceXmlItemDto = {
  lineNumber: number;
  name: string;
  description: string | null;
  quantity: number | null;
  unit: string | null;
  unitPrice: number | null;
  discountPct: number | null;
  discountAmount: number | null;
  /** MontoItem, as the document states it. */
  lineAmount: number;
  isExempt: boolean;
};
export type SourceXmlReferenceDto = {
  lineNumber: number;
  /** TpoDocRef as a string: a type number ('801') or a code ('HES'). */
  referencedDteType: string;
  referencedFolio: string;
  /** YYYY-MM-DD. */
  referencedDate: string;
  /** CodRef: 1 annuls, 2 corrects text, 3 corrects amounts. */
  referenceCode: number | null;
  reason: string | null;
};
export type SourceXmlGlobalAdjustmentDto = {
  lineNumber: number;
  /** 'D' discount, 'R' surcharge. */
  movement: string;
  glosa: string | null;
  /** '%' a percentage of the affected base, '$' an amount. */
  valueType: string;
  value: number;
  isExempt: boolean;
};
export type SourceXmlDocumentDto = {
  dteType: number;
  /** The document's own folio. */
  folio: number;
  /** YYYY-MM-DD. */
  issueDate: string;
  issuerTaxNumber: string;
  receptor: SourceXmlReceptorDto;
  items: SourceXmlItemDto[];
  references: SourceXmlReferenceDto[];
  globalAdjustments: SourceXmlGlobalAdjustmentDto[];
  /** Exportación only: the SII currency name (TpoMoneda, e.g. «EURO»). */
  currency: string | null;
  /** Exportación only: CLP per unit of `currency` (TpoCambio). */
  exchangeRate: number | null;
};
export type SourceXmlResponseDto = {
  documents: SourceXmlDocumentDto[];
};
export type SourceXmlRequestDto = {
  /** The company the document must have been issued by. */
  companyId: string;
  /** The file's name, for the person's reference; it is not stored. */
  fileName: string;
  /** The file's bytes, base64-encoded; at most 2 MB once decoded. */
  contentBase64: string;
};
export type DteDetailItemDto = {
  lineNumber: number;
  name: string;
  description: string | null;
  /** Up to six decimals. */
  quantity: number | null;
  unit: string | null;
  /** Up to six decimals; `null` on a valueless line. */
  unitPrice: number | null;
  /** Percentage, 0-100 with two decimals. */
  discountPct: number | null;
  discountAmount: number | null;
  /** Percentage, 0-100 with two decimals. `null` on documents issued before migration 0055. */
  surchargePct: number | null;
  /** `null` on documents issued before migration 0055. */
  surchargeAmount: number | null;
  /** MontoItem, rounded to the unit: an exportación's line carries cents in its
    own currency, which only the signed XML keeps. */
  lineAmount: number;
  isExempt: boolean;
  /** Liquidación-Factura (43) only: the type of the liquidated document
    (TpoDocLiq). `null` on every other type and on documents issued before
    migration 0055. */
  tpoDocLiq: string | null;
};
export type DteDetailReferenceDto = {
  lineNumber: number;
  /** TpoDocRef, verbatim: a type number as a string ('33', '801') or a code ('HES'). */
  referencedDteType: string;
  /** IndGlobal: the reference covers every document of that type (folio 0). */
  globalIndicator: boolean;
  referencedFolio: string;
  /** YYYY-MM-DD. */
  referencedDate: string;
  /** CodRef: 1 annuls, 2 corrects text, 3 corrects amounts. */
  referenceCode: number | null;
  reason: string | null;
};
export type DteDetailGlobalAdjustmentDto = {
  /** 'D' discount, 'R' surcharge. */
  movement: "D" | "R";
  /** '%' a percentage of the affected base, '$' an amount. */
  valueType: "%" | "$";
  lineNumber: number;
  glosa: string | null;
  /** The value as declared: a percentage or an amount, per `valueType`. */
  value: number;
  /** The amount the totals were computed with, rounded to the unit. */
  amount: number;
  /** It applies to the exempt base instead of the taxable one. */
  isExempt: boolean;
};
export type DteDetailCommissionDto = {
  /** 'C' commission, 'O' other charges. */
  type: "C" | "O";
  lineNumber: number;
  glosa: string;
  netAmount: number;
  exemptAmount: number;
  /** The IVA on the commission, as the signed XML allocated it. */
  vatAmount: number;
};
export type DteEnvioSummaryDto = {
  /** The **envelope's** status, distinct from the document's. An envelope can end
    up `partially_accepted` with both accepted and rejected documents inside,
    and `needs_review` demands human intervention (runbook §g.3). */
  status:
    | "queued"
    | "accepted"
    | "rejected"
    | "sending"
    | "sent"
    | "processed"
    | "partially_accepted"
    | "needs_review";
  id: string;
  /** Track ID the SII assigned when it received the envelope. */
  trackId: string | null;
  /** The SII's glosa about the whole envelope, not about this document. */
  siiMessage: string | null;
  sentAt: string | null;
};
export type DteDetailResponseDto = {
  id: string;
  companyId: string;
  dteType: number;
  folio: number;
  /** Issue date (YYYY-MM-DD). */
  issueDate: string;
  /** Due date (YYYY-MM-DD), when the document carries one. */
  dueDate: string | null;
  receiverTaxNumber: string;
  receiverLegalName: string;
  receiverBusinessActivity: string | null;
  receiverAddress: string | null;
  receiverDistrict: string | null;
  receiverCity: string | null;
  netAmount: number;
  exemptAmount: number;
  vatAmount: number;
  totalAmount: number;
  /** The detail lines, in line order. */
  items: DteDetailItemDto[];
  /** The references to other documents, in line order. */
  references: DteDetailReferenceDto[];
  /** The global discounts and surcharges, in line order. */
  globalAdjustments: DteDetailGlobalAdjustmentDto[];
  /** Liquidación-Factura (43) only: the commission lines; empty on every other type. */
  commissions: DteDetailCommissionDto[];
  /** Whether the buyer withheld the IVA in full (TipoImp 15): a factura de
    compra (46), or a note adjusting one, issued with `retainVat`. Derived from
    the stored totals, where a retained IVA is declared but left out of the
    total. */
  retainVat: boolean;
  /** Exportación (110/111/112) only: the SII currency name (TpoMoneda, e.g.
    «DOLAR USA», «EURO»). `null` on every other type. */
  exportCurrency: string | null;
  /** Exportación (110/111/112) only: the foreign receptor's tax ID
    (<Extranjero><NumId>). `null` when none was given. */
  receptorForeignTaxId: string | null;
  status:
    | "draft"
    | "queued"
    | "accepted"
    | "rejected"
    | "objected"
    | "sent"
    | "signed"
    | "voided";
  trackId: string | null;
  /** The SII's glosa for **this folio**, in the format `(CODE) text`.
    
    It is the datum that explains a `rejected` or an `objected`, and the only
    source is the `RESULTADO_ENVIO` email: the SII's status services deliver
    per-document-type counters only, never the per-folio detail. */
  errorMessage: string | null;
  /** The live envelope carrying it, or `null` if it has not been grouped yet. */
  envio: DteEnvioSummaryDto | null;
  /** Who issued it, when it was a person: the user id of the session that made
    the POST. `null` for what an api key or a background process issued, and for
    everything predating migration 0032. */
  createdByUserId: string | null;
  /** RUT of the holder of the certificate this document was SIGNED with.
    
    It is not the company's RUT: in the SII's model the document is issued by a
    legal entity and signed by an authorised natural person, and since each user
    can hold their own certificate, which of them signed stopped being deducible
    from the company. `null` for documents predating the signer being recorded. */
  signedBySubjectTaxNumber: string | null;
  createdAt: string;
  updatedAt: string;
};
export type DteXmlUrlResponseDto = {
  url: string;
};
export type DteEmailResponseDto = {
  messageId: string;
  /** The address it was dispatched to. */
  to: string;
};
export type EmailDteDto = {
  to: string;
  subject?: string;
  from?: string;
};
export type EnvioResponseDto = {
  status:
    | "queued"
    | "accepted"
    | "rejected"
    | "sending"
    | "sent"
    | "processed"
    | "partially_accepted"
    | "needs_review";
  id: string;
  /** Track ID the SII assigned when it received the envelope. */
  trackId: string | null;
  /** The last thing known about the envelope in words: the SII's glosa when there
    was an answer, or the reason the envelope was left parked when there was
    not.
    
    It is the field that explains a `needs_review` with no trackId, which
    otherwise reads as an envelope that "lost" its trackId: the two paths
    leading to that state (a dependency that was never accepted, or an upload
    claimed and never confirmed) leave their reason here, and without it the
    review queue — the screen that exists to resolve them — cannot say what
    happened. */
  siiMessage: string | null;
  /** When it was uploaded to the SII. `null` while it has not been. */
  sentAt: string | null;
  /** The signed envelope, in the exact bytes that were uploaded (ISO-8859-1). */
  envioXml: string;
};
export type CreateEnvioDto = {
  companyId: string;
  receiverTaxNumber: string;
  dteIds: string[];
};
export type EnvioSendQueuedDto = {
  id: string;
  queued: boolean;
};
export type ReconcileResultDto = {
  /** Never uploaded — the send job was re-enqueued. */
  requeuedSend: string[];
  /** Uploaded, verdict unknown — the status poll was re-enqueued. */
  requeuedPoll: string[];
  /** Uploads claimed but never confirmed. **Only a person resolves these**: the
    trackId has to be checked at the SII before re-sending (runbook §g.3). */
  needsReview: string[];
};
export type IngestResultDto = {
  inboundEnvioId: string;
  inboundDteIds: string[];
  reciboXml: string;
  /** The acuse that has to be dispatched. Building the response is half the
    obligation: the emisor has to receive it. */
  acknowledgementId: string;
  /** The `EstadoRecepEnv` the acuse reports for the envelope. */
  estadoRecepEnvio: 0 | 1 | 2 | 3 | 90 | 99 | 91;
};
export type IngestEnvioDto = {
  companyId: string;
  xml: string;
  /** File name the envelope arrived as, reported back in the acuse's mandatory
    `<NmbEnvio>`. Optional because a direct API post has no attachment; a
    synthetic, traceable name is used then. */
  fileName?: string;
  /** Address to send the acuse back to. Normally filled in from the `From` of the
    mail the envelope arrived in; supplied here for a direct post. */
  senderEmail?: string;
  /** How the acuse de recibo reaches the emisor. `email` (the default) queues it
    for `SendAcuseJob`. `portal` is the SII certification's Set de Intercambio:
    the envelope was downloaded from the SII portal and the answers are
    uploaded back there, so nothing is emailed. */
  delivery?: "email" | "portal";
};
export type InboundEnvioListItemDto = {
  id: string;
  companyId: string;
  senderTaxNumber: string;
  /** `<NmbEnvio>`: the file name it arrived as, when known. */
  fileName: string | null;
  /** The `CodEnvio` we assigned to it. */
  codEnvio: number;
  receivedAt: string;
  /** Documents of the envelope that verified and were stored. */
  dteCount: number;
  /** Which of the three response files already exist. */
  responseKinds: ("recepcion" | "recibo" | "resultado")[];
};
export type InboundEnvioDteDto = {
  id: string;
  dteType: number;
  folio: number;
  issueDate: string;
  emisorTaxNumber: string;
  emisorLegalName: string;
  totalAmount: number;
  acknowledgementStatus:
    | "pending"
    | "accepted"
    | "rejected"
    | "claimed_content"
    | "claimed_not_received";
};
export type IntercambioResponseFileDto = {
  kind: "recepcion" | "recibo" | "resultado";
  acknowledgementId: string;
  /** The name it downloads as. */
  fileName: string;
  createdAt: string;
};
export type InboundEnvioDetailDto = {
  id: string;
  companyId: string;
  senderTaxNumber: string;
  fileName: string | null;
  codEnvio: number;
  receivedAt: string;
  dtes: InboundEnvioDteDto[];
  /** The newest file of each kind; a kind not built yet is absent. */
  responses: IntercambioResponseFileDto[];
};
export type EnvioDecisionDto = {
  inboundDteId: string;
  /** `accept` → EstadoDTE 0, `discrepancy` → 1, `reject` → 2. */
  decision: "accept" | "discrepancy" | "reject";
  /** Required unless the document is accepted; see {@link AcknowledgeDto.reason}. */
  reason?: string;
  /** `CodRchDsc`, a negative integer; see {@link AcknowledgeDto.codRchDsc}. */
  codRchDsc?: number;
};
export type RespondEnvioDto = {
  decisions: EnvioDecisionDto[];
  /** `<Recinto>` of the Ley 19.983 receipt of the accepted documents. */
  recinto: string;
};
export type InboundDteListItemDto = {
  id: string;
  companyId: string;
  dteType: number;
  folio: number;
  issueDate: string;
  emisorTaxNumber: string;
  emisorLegalName: string;
  totalAmount: number;
  /** While it stays `pending` the clock runs: **8 calendar days** per DTE
    received, after which the SII treats it as **tacitly accepted**. */
  acknowledgementStatus:
    | "pending"
    | "accepted"
    | "rejected"
    | "claimed_content"
    | "claimed_not_received";
  updatedAt: string;
};
export type InboundDteListResponseDto = {
  items: InboundDteListItemDto[];
  /** `null` when no pages remain. */
  nextCursor: string | null;
};
export type AcknowledgeResultDto = {
  /** The signed acuse that gets dispatched to the emisor. */
  xml: string;
  status: "accepted" | "rejected" | "received" | "claimed_content";
  acknowledgementId: string;
};
export type AcknowledgeDto = {
  /** `accept` → EstadoDTE 0, `discrepancy` → 1, `reject` → 2.
    `claim_content` is the previous name of `reject`, still accepted. */
  decision: "accept" | "discrepancy" | "reject" | "claim_content";
  /** Required to reject or flag a discrepancy: it becomes the `EstadoDTEGlosa`,
    and Ley 19.983 requires a rejection motive to be stated expressly. */
  reason?: string;
  /** `CodRchDsc`. The schema types it `xs:negativeInteger` with 3 digits — the
    RCD/RFP/RFT letter codes belong to the SII's reclamo web service, not to this
    document, which is why this is a number and not a string. */
  codRchDsc?: number;
};
export type AcuseReciboDto = {
  /** Where delivery was taken (`<Recinto>`, max 80 chars in the schema): "el lugar
    donde se materializa la recepción conforme". */
  recinto: string;
};
export type SesNotificationResultDto = {
  accepted: boolean;
  /** How many ingest jobs were enqueued. Absent when it was not accepted. */
  enqueued?: number;
};
export type SnsEnvelopeDto = {
  Type: "Notification" | "SubscriptionConfirmation" | "UnsubscribeConfirmation";
  MessageId?: string;
  TopicArn?: string;
  Token?: string;
  SubscribeURL?: string;
  Message?: string;
  Subject?: string;
  Timestamp?: string;
  Signature?: string;
  SignatureVersion?: string;
  SigningCertURL?: string;
  UnsubscribeURL?: string;
  MessageAttributes?: {
    [key: string]: any;
  };
};
export type ConnectorCapabilitiesDto = {
  /** Pulls sales documents from the ERP (issuing). */
  pullSalesDocuments: boolean;
  /** Receives webhooks from the ERP instead of (or as well as) polling. */
  webhooks: boolean;
  /** Writes folio/status/PDF back into the ERP. */
  writeBackIssued: boolean;
  /** Pushes purchase DTEs received through intercambio into the ERP. */
  pushPurchaseDocument: boolean;
  /** Master data it exposes so the mapping table can be pre-filled. */
  masters: ("unit" | "tax" | "document_type" | "branch" | "series")[];
  /** Needs the on-premise agent to reach the ERP. */
  requiresEdgeAgent: boolean;
};
export type ConnectorConfigOptionDto = {
  value: string;
  label: string;
};
export type ConnectorConfigFieldDto = {
  key: string;
  label: string;
  type: "string" | "number" | "boolean" | "select" | "secret";
  required: boolean;
  help?: string;
  options?: ConnectorConfigOptionDto[];
  default?: object;
};
export type ConnectorCatalogEntryDto = {
  /** The adapter's stable key; it is what `integration_connection` stores. */
  key: string;
  label: string;
  vendor: string;
  tier: "corporate" | "midmarket" | "chilean" | "ecommerce" | "generic";
  capabilities: ConnectorCapabilitiesDto;
  configFields: ConnectorConfigFieldDto[];
  /** Fields of `configFields` that are secret and are stored encrypted. */
  secretFields: string[];
  docsUrl?: string;
};
export type IntegrationPendingCountsDto = {
  /** Documents waiting on a human decision: `held` (`assisted` mode, awaiting
    approval) plus `failed`.
    
    **It does not count `pending`.** A freshly seen document is processing
    itself and needs nobody to do anything; including it would keep the badge
    from ever reaching zero on an active connection, which is the quickest way
    to make people stop looking at it. */
  documentsNeedingReview: number;
  /** Mappings with a NULL `internal_value`. They block their connection's activation. */
  unresolvedMappings: number;
};
export type ConnectionResponseDto = {
  id: string;
  connector: string;
  name: string;
  companyId: string;
  /** The product's risk control. `observe` normalises and displays **without
    issuing** — it is the default and the rollout mode, and it is what stops a
    misconfigured tax mapping from issuing 400 irreversible DTEs on day one.
    `assisted` asks for approval per document. `auto` issues on its own. */
  mode: "auto" | "observe" | "assisted";
  /** Starts out `draft`; `activate` fails while any mapping is unresolved. */
  status: "active" | "error" | "draft" | "paused";
  config: {
    [key: string]: any;
  };
  cursor: string | null;
  syncIntervalMinutes: number;
  lastSyncAt: string | null;
  lastError: string | null;
  pausedReason: string | null;
  createdAt: string;
};
export type CreateConnectionDto = {
  connector: string;
  name: string;
  companyId: string;
  /** Fields declared by the connector's manifest, secrets included. */
  config: {
    [key: string]: any;
  };
  mode?: "observe" | "assisted" | "auto";
  syncIntervalMinutes?: number;
};
export type CreateBoletaImportDto = {
  companyId: string;
};
export type UpdateConnectionDto = {
  mode?: "observe" | "assisted" | "auto";
  syncIntervalMinutes?: number;
  config?: {
    [key: string]: any;
  };
};
export type ConnectionDeletedDto = {
  deleted: boolean;
};
export type RotateCredentialsDto = {
  config: {
    [key: string]: any;
  };
};
export type ConnectionHealthDto = {
  ok: boolean;
  message: string;
  detail?: {
    [key: string]: any;
  };
};
export type PauseConnectionDto = {
  reason: string;
};
export type MappingResponseDto = {
  kind: "unit" | "tax" | "document_type" | "branch" | "series";
  externalKey: string;
  externalLabel?: string | null;
  /** `null` = unresolved, and it blocks the connection's activation. */
  internalValue: string | null;
};
export type UpsertMappingDto = {
  kind: "tax" | "unit" | "document_type" | "branch" | "series";
  externalKey: string;
  externalLabel?: string;
  /** `null` leaves the mapping unresolved, which blocks activation. */
  internalValue?: string | null;
};
export type MappingImportResultDto = {
  imported: number;
};
export type SyncResultDto = {
  connectionId: string;
  syncRunId: string;
  seen: number;
  created: number;
  failed: number;
  cursor: string | null;
};
export type BoletaUploadResultDto = {
  connectionId: string;
  /** Documents found in the file. */
  documents: number;
  /** Documents new to the inbox. */
  created: number;
  /** Documents the inbox already knew by `external_id`. */
  updated: number;
};
export type UploadConnectionFileDto = {
  /** The file's name, kept with the documents for traceability. */
  fileName: string;
  /** The CSV's content, decoded as text. */
  content: string;
};
export type SyncRunResponseDto = {
  id: string;
  trigger: "manual" | "webhook" | "scheduled" | "backfill";
  status: "failed" | "running" | "completed";
  cursorBefore: string | null;
  cursorAfter: string | null;
  documentsSeen: number;
  documentsNew: number;
  documentsFailed: number;
  error: string | null;
  startedAt: string;
  finishedAt: string | null;
};
export type IntegrationDocumentResponseDto = {
  status: "pending" | "failed" | "skipped" | "emitted" | "held" | "ready";
  id: string;
  externalId: string;
  documentHint: string | null;
  errorClass:
    ("auth" | "sii" | "transient" | "mapping" | "validation" | "fatal") | null;
  errorMessage: string | null;
  dteId: string | null;
  dteType: number | null;
  folio: number | null;
  attempts: number;
  emittedAt: string | null;
  writtenBackAt: string | null;
  createdAt: string;
};
export type IntegrationDocumentQueuedDto = {
  status: "pending" | "failed" | "skipped" | "emitted" | "held" | "ready";
  documentId: string;
};
export type ReconFindingDetectedDto = {
  kind: "missing_in_factit" | "missing_in_erp" | "total_mismatch";
  externalId: string | null;
  dteId?: string | null;
  detail: {
    [key: string]: any;
  };
};
export type ReconResultDto = {
  connectionId: string;
  from: string;
  to: string;
  comparedInErp: number;
  comparedInFactit: number;
  findings: ReconFindingDetectedDto[];
  /** Documents that recovered on their own because the engine re-ingested them. */
  recovered: number;
};
export type ReconcileDto = {
  from?: string;
  to?: string;
};
export type ReconFindingResponseDto = {
  id: string;
  kind: "missing_in_factit" | "missing_in_erp" | "total_mismatch";
  externalId: string | null;
  dteId: string | null;
  detail: {
    [key: string]: any;
  };
  periodStart: string;
  periodEnd: string;
  createdAt: string;
};
export type ReconFindingResolvedDto = {
  id: string;
  status: "open" | "resolved" | "ignored";
};
export type BoletaSubtotalDto = {
  dteType: number;
  count: number;
};
export type BuiltBoletaEnvioDto = {
  id: string;
  documentCount: number;
  signedXmlUri: string;
  status: "built" | "accepted" | "rejected" | "objected" | "sent";
  subtotales: BoletaSubtotalDto[];
};
export type CreateBoletaEnvioDto = {
  companyId: string;
  /** The boletas (39/41) to put in the sobre. At most 500 per EnvioBOLETA
    (`EnvioBOLETA_v11.xsd`); the SII recommends ~50 per request for throughput. */
  dteIds: string[];
  /** RUT the sobre is addressed to (<RutReceptor>). Defaults to the SII
    (60803000-K): a boleta has no identified buyer to deliver it to. */
  receiverTaxNumber?: string;
};
export type BoletaEnvioListItemDto = {
  id: string;
  companyId: string;
  documentCount: number;
  receiverTaxNumber: string;
  trackId: string | null;
  status: "built" | "accepted" | "rejected" | "objected" | "sent";
  /** The latest raw SII code known (`REC`, `EPR`, `RPR`, …). */
  estado: string | null;
  glosa: string;
  /** When it was uploaded to the SII; `null` while it is merely built. */
  sentAt: string | null;
  createdAt: string;
  /** The cursor's basis; the database's `set_updated_at` trigger maintains it. */
  updatedAt: string;
};
export type BoletaEnvioListResponseDto = {
  items: BoletaEnvioListItemDto[];
  /** `null` when no pages remain. */
  nextCursor: string | null;
};
export type BoletaEnvioUploadResultDto = {
  id: string;
  /** The boleta trackId is **15 digits**, unlike the factura one. */
  trackId: string | null;
  status: "built" | "accepted" | "rejected" | "objected" | "sent";
  /** The SII's raw code (`REC`, `SOK`, `EPR`, `RPR`, `RCH`, …). */
  estado: string;
};
export type BoletaEnvioStatDto = {
  tipo: number;
  informados: number;
  aceptados: number;
  rechazados: number;
  reparos: number;
};
export type BoletaEnvioStatusResultDto = {
  id: string;
  trackId: string | null;
  status: "built" | "accepted" | "rejected" | "objected" | "sent";
  estado: string;
  glosa: string;
  terminal: boolean;
  stats: BoletaEnvioStatDto[];
  /** Per-folio verdicts, as `T39/F12 [RCH] (…)` lines. */
  details: string[];
};
export type BoletaEnvioDetailDto = {
  id: string;
  companyId: string;
  documentCount: number;
  /** Receiver from the envelope's Caratula. */
  receiverTaxNumber: string;
  trackId: string | null;
  status: "built" | "accepted" | "rejected" | "objected" | "sent";
  /** The latest raw SII code known. */
  estado: string;
  glosa: string;
  signedXmlUri: string;
};
export type FolioRangeDto = {
  inicial: number;
  final: number;
};
export type ConsumoFolioResumenDto = {
  /** 39 (boleta), 41 (boleta exenta) or 61 (nota de crédito). */
  tipoDocumento: 61 | 39 | 41;
  netAmount: number;
  vatAmount: number;
  exemptAmount: number;
  totalAmount: number;
  foliosEmitidos: number;
  foliosAnulados: number;
  /** Issued + annulled: every folio that was consumed. */
  foliosUtilizados: number;
  rangoUtilizados: FolioRangeDto[];
  rangoAnulados: FolioRangeDto[];
};
export type BuiltConsumoFolioResultDto = {
  id: string;
  /** The day it summarises (YYYY-MM-DD). */
  fecha: string;
  secEnvio: number;
  documentCount: number;
  signedXmlUri: string;
  status: string;
  resumenes: ConsumoFolioResumenDto[];
};
export type BuildConsumoFoliosDto = {
  companyId: string;
  /** Day to summarize, "YYYY-MM-DD". Defaults to today in America/Santiago. */
  fecha?: string;
  /** <SecEnvio>: 1 for the day's first report, +1 on each corrective re-send of
    the same day. Defaults to one past the highest already stored for that day. */
  secEnvio?: number;
  /** <Correlativo>: optional counter within the day. */
  correlativo?: number;
};
export type ConsumoFolioListItemDto = {
  id: string;
  companyId: string;
  /** The day it summarises (YYYY-MM-DD). */
  fecha: string;
  secEnvio: number;
  documentCount: number;
  status: string;
  createdAt: string;
  /** The cursor's basis; the database's `set_updated_at` trigger maintains it. */
  updatedAt: string;
};
export type ConsumoFolioListResponseDto = {
  items: ConsumoFolioListItemDto[];
  /** `null` when no pages remain. */
  nextCursor: string | null;
};
export type ConsumoFolioDetailDto = {
  id: string;
  companyId: string;
  fecha: string;
  secEnvio: number;
  documentCount: number;
  status: string;
  signedXmlUri: string;
  resumenes: ConsumoFolioResumenDto[];
};
export type CertificationRunSummaryDto = {
  /** `null` when the request named no set (every set in the file was emitted). */
  setNumber: string | null;
  /** `null` only when the set failed before a run could be claimed — a folio
    shortfall, or a set whose slot is held by a run that cannot advance. There
    is then nothing to poll, and `errorMessage` says why. */
  certificationRunId: string | null;
  /** Documents emitted **by this request**. It is `0` on a reused run: the set
    was already certified and nothing new was issued.
    
    It used to report the reused run's document count, which made a request
    that emitted nothing answer `dtesEmitted: 32` — the whole reason a set
    silently dropping out of the batch went unnoticed for over a week. */
  dtesEmitted: number;
  /** True when this set was NOT emitted again because a previous run of it is
    still valid — either already approved by the SII, or still in flight.
    `certificationRunId` then points at that earlier run. */
  reused: boolean;
  /** Why this set emitted nothing, when it failed. `null` on success. The other
    sets of the request are emitted regardless: one set's folio shortfall is
    not a reason to skip the six that have folios. */
  errorMessage: string | null;
};
export type CertificationLibroSummaryDto = {
  /** The libro's attention number in the set file. */
  setNumber: string;
  operacion: "VENTA" | "COMPRA" | "GUIAS";
  /** The row tracking it, which the runs screen lists. `null` only when the
    libro was answered by an earlier one the SII already accepted, which is
    then `libroId`. */
  certificationLibroId: string | null;
  libroId: string | null;
  /** True when nothing new was scheduled: the SII already accepted this libro of
    this set, or one is already on its way. */
  reused: boolean;
  status: "failed" | "accepted" | "rejected" | "waiting" | "sending" | "sent";
  /** Why the libro cannot be sent, when it cannot; `null` otherwise. */
  errorMessage: string | null;
};
export type OnboardingResultDto = {
  companyId: string;
  /** The exchange casilla that has to be **registered at the SII** ("Mail
    Contacto SII") so reception results and inbound DTEs come back. It is
    exposed here to avoid forcing a follow-up `GET /companies/:id`; it is
    `null` when provisioning is switched off. */
  exchangeEmail: string | null;
  cafsUploaded: number;
  certificateFingerprint: string;
  /** The FIRST run, for anyone reading a single id. With several sets chosen
    there are several: see `certificationRuns`. */
  certificationRunId: string | null;
  /** Total documents emitted **by this request**, summed over every run. */
  dtesEmitted: number;
  /** Documents this request did NOT emit because their set was already covered
    by a valid run. `dtesEmitted + dtesReused` is what the set selection asked
    for, which is what makes a partial batch visible. */
  dtesReused: number;
  /** One run per requested set, in the order they were emitted. Empty when the
    onboarding emitted nothing (`completed_no_cases`). */
  certificationRuns: CertificationRunSummaryDto[];
  /** The libros of the set the request named, scheduled after its runs: each
    waits for the runs it summarizes to be accepted, then is built and sent.
    Empty when the request named no libro. */
  libros: CertificationLibroSummaryDto[];
  status: "in_progress" | "completed_no_cases";
};
export type OnboardingCertificationDto = {
  /** The set number, normalised to `undefined` when it arrives empty.
    
    This is not cosmetic: the `certification_run_active_unique` index uses
    `COALESCE(set_number,'')`, so to the database `''` and `NULL` are **the same
    key**, while a search for `set_number = ''` never finds a row holding
    `NULL`. A `setNumber: ""` — which passes validation, there is no
    `@IsNotEmpty` — left the code looking up one key while the database stored
    another: the lookup did not see the in-flight run, the INSERT collided with
    it, and out came a 500.
    
    It is exactly the same index-versus-lookup mismatch this change fixes for
    `kind`, in `setNumber`'s `null`/`''` sibling. It is resolved once here, at
    the boundary, so every reader of the DTO — `loadCases` included, which
    already treated `''` as "no number" — agrees on the same representation. */
  setNumber?: string;
  /** The sets to certify. **Each one emits its own run.**
    
    The SII's file carries the seven sets certificación requires
    (BASICO, GUIA DE DESPACHO, FACTURA EXENTA, EXPORTACION 1 and 2,
    LIQUIDACIONES, FACTURA DE COMPRA) and only one could be requested before:
    the whole wizard had to be repeated seven times, re-uploading every file on
    each pass.
    
    One run per set — rather than one spanning all of them — because that is
    the shape everything else already has: `certification_run_active_unique` is
    indexed by `(company, kind, set_number)`, the Runs screen lists per set and
    the SII evaluates set by set. It also isolates failure: one rejected set
    does not contaminate the other six.
    
    `setNumber` (singular) is still accepted and is equivalent to sending a
    single one. Empty or absent: every set with cases in the file is emitted,
    which is what it already did. */
  setNumbers?: string[];
  /** Emit every chosen set again, even one a previous run already got the SII to
    approve.
    
    Off by default, and that default is the right one: re-emitting an approved
    set spends a fresh folio range for a verdict already obtained, and the
    reuse is what makes an onboarding retry cheap. But the skip used to be
    invisible — a request asking for the seven sets would emit three and answer
    as though it had emitted all seven — so the way to say "no, issue them all"
    had to exist before the skip could be reported honestly.
    
    It does not override a run that is still IN FLIGHT: those folios are alive
    at the SII and a second batch alongside them is the one thing the
    `certification_run_active_unique` slot exists to prevent. */
  reemitApprovedSets?: boolean;
  receiver: DteReceptorDto;
  /** SII test set file (`SIISetDePruebas<RUT>.txt`, ISO-8859-1),
    base64-encoded. Required when `certification` is provided because
    the SII delivers a *per-emisor* file when granting certification —
    there is no canonical location factit could fetch it from.
    
    Size guard: 100 chars of base64 ≈ 75 bytes (smallest plausible
    set), 700 000 chars ≈ 500 KB (much larger than any real set).
    
    **Optional when the company already has one stored**
    (`company.test_set_txt`, migration 0035): the file is per emisor and does
    not change between runs, so hunting for it on disk again on each of the
    seven passes was pure friction. When it does arrive, it replaces the stored
    one. */
  testSetBase64?: string;
};
export type OnboardingDto = {
  company: CreateCompanyDto;
  /** The signing `.p12`. **Optional when the company already has an active
    one**: in that case the stored one is reused and the response returns its
    fingerprint all the same.
    
    It used to be mandatory always, and that turned every retry of a
    certificación into a chore of re-uploading the certificate and its
    passphrase — data the company ALREADY holds and that the envío itself uses
    without asking. It is the same family as the wizard that started blank over
    an existing company: the application forgot what it already knew, and every
    round of retyping is one more chance to get wrong a datum that ends up
    signing tax documents.
    
    It remains mandatory when the company has no active certificate: without it
    there is nothing to sign with, and saying so here beats failing only at
    emission time. */
  certificate?: UploadCertificateDto;
  /** CAFs to upload. **Optional**, and an empty list is valid: the company may
    already hold CAFs with free folios of the types the set needs, and
    re-uploading the same files only produces the "overlap" `upsertCafs`
    already discards silently.
    
    If folios are missing, the error still arrives — naming the concrete
    document type — at emission time. */
  cafs?: UploadCafDto[];
  /** Emits the Set de Pruebas in the same request. */
  certification?: OnboardingCertificationDto;
  /** Consent for factit to obtain this company's folios from the SII on its
    behalf, instead of the customer downloading each CAF from the portal by
    hand: «Quiero que factit obtenga mis folios del SII por mí».
    
    It is a CONSENT and not a setting. The automation drives the SII's own
    portal as the contribuyente, signing with their certificate, so it is not
    something to switch on for somebody — hence an explicit field that defaults
    to off, and hence its being asked at the moment it is relevant rather than
    living in a tab nobody finds (see `docs/ONBOARDING_FOLIOS_ANALYSIS.md`,
    increment B).
    
    The other datum the automation needs, the electronic representative's RUT,
    is NOT asked for: it is derived from the certificate that was just
    uploaded, because the certificate belongs to that natural person by
    definition. Empresas → SII stays the place to correct it when the
    certificate holder is not the representative. */
  siiRpaEnabled?: boolean;
};
export type TestSetPreviewSetDto = {
  /** The number the SII identifies the set by, e.g. `4964610`. */
  number: string;
  title: string;
  /** Cases the file declares for this set. */
  totalCases: number;
  /** Cases the onboarding will actually emit (those of a supported type). It can
    be lower than `totalCases`; the difference is what the wizard has to say
    BEFORE submitting, not after. */
  emittableCases: number;
  /** The DTE types present among the emittable cases, sorted. */
  dteTypes: number[];
};
export type TestSetPreviewLibroDto = {
  /** The libro's attention number, e.g. `4265988`. */
  number: string;
  title: string;
  operacion: "VENTA" | "COMPRA" | "GUIAS";
  /** The sets whose runs the libro waits on: the BASICO for the ventas (the
    FACTURA EXENTA only when the file has no BASICO), GUIA DE DESPACHO (and BASICO, when a guía is reported as invoiced)
    for the guías, none for the compras. */
  dependsOnSetNumbers: string[];
};
export type TestSetPreviewDto = {
  /** Sets with at least one case, in the file's order. */
  sets: TestSetPreviewSetDto[];
  /** The libros of the file, in the SII's order: ventas, compras, guías. */
  libros: TestSetPreviewLibroDto[];
};
export type PreviewTestSetDto = {
  /** The file. **Optional when `companyId` is passed**: the wizard previews the
    one the company already has stored, which is what lets it offer the sets
    without forcing another hunt for the `.txt` on disk. */
  testSetBase64?: string;
  /** Which company to read the stored set from when no file is sent. */
  companyId?: string;
};
export type OnboardingDraftCompanyDto = {
  taxNumber?: string;
  legalName?: string;
  businessActivity?: string;
  address?: string;
  district?: string;
  city?: string;
  siiRegionalOffice?: string;
  /** The emisor's SII "Fecha Resolución", in ISO (`2020-03-26`). Stored as text
    and without validating the format, like the rest: this is a draft, and a
    half-typed date field cannot return a 400. */
  resolutionDate?: string;
  /** The ACTECO codes exactly as typed, comma-separated. Text and not a
    `number[]`: the draft stores what was typed, and a half-written "620900, "
    is not a list of integers yet. */
  acteco?: string;
  exchangeEmail?: string;
};
export type OnboardingDraftDto = {
  confirmedPostulacion: boolean;
  company: OnboardingDraftCompanyDto;
  /** When it was last saved. The screen shows it: without that, "saved" is a
    claim the user cannot verify. */
  updatedAt: string;
};
export type SaveOnboardingDraftDto = {
  /** Whether step 1 (applying as an emisor on sii.cl, outside the application)
    has been marked done. It is the only piece of PROGRESS that is stored:
    steps 3 and 4 depend on having submitted the onboarding, and that already
    has a record of its own (`onboarding_attempt`, the certification run). */
  confirmedPostulacion?: boolean;
  company?: OnboardingDraftCompanyDto;
};
export type TestSetEmissionResultDto = {
  companyId: string;
  /** The FIRST run, for anyone reading a single id. With several sets chosen
    there are several: see `certificationRuns`. */
  certificationRunId: string | null;
  /** Total documents emitted **by this request**, summed over every run. */
  dtesEmitted: number;
  /** Documents this request did NOT emit because their set was already covered
    by a valid run. `dtesEmitted + dtesReused` is what the set selection asked
    for. */
  dtesReused: number;
  /** One run per requested set, in the order they were emitted. */
  certificationRuns: CertificationRunSummaryDto[];
  /** The libros of the set the request named, scheduled after its runs: each
    waits for the runs it summarizes to be accepted, then is built and sent.
    Empty when the request named no libro. */
  libros: CertificationLibroSummaryDto[];
};
export type EmitTestSetDto = {
  /** The set number, normalised to `undefined` when it arrives empty.
    
    This is not cosmetic: the `certification_run_active_unique` index uses
    `COALESCE(set_number,'')`, so to the database `''` and `NULL` are **the same
    key**, while a search for `set_number = ''` never finds a row holding
    `NULL`. A `setNumber: ""` — which passes validation, there is no
    `@IsNotEmpty` — left the code looking up one key while the database stored
    another: the lookup did not see the in-flight run, the INSERT collided with
    it, and out came a 500.
    
    It is exactly the same index-versus-lookup mismatch this change fixes for
    `kind`, in `setNumber`'s `null`/`''` sibling. It is resolved once here, at
    the boundary, so every reader of the DTO — `loadCases` included, which
    already treated `''` as "no number" — agrees on the same representation. */
  setNumber?: string;
  /** The sets to certify. **Each one emits its own run.**
    
    The SII's file carries the seven sets certificación requires
    (BASICO, GUIA DE DESPACHO, FACTURA EXENTA, EXPORTACION 1 and 2,
    LIQUIDACIONES, FACTURA DE COMPRA) and only one could be requested before:
    the whole wizard had to be repeated seven times, re-uploading every file on
    each pass.
    
    One run per set — rather than one spanning all of them — because that is
    the shape everything else already has: `certification_run_active_unique` is
    indexed by `(company, kind, set_number)`, the Runs screen lists per set and
    the SII evaluates set by set. It also isolates failure: one rejected set
    does not contaminate the other six.
    
    `setNumber` (singular) is still accepted and is equivalent to sending a
    single one. Empty or absent: every set with cases in the file is emitted,
    which is what it already did. */
  setNumbers?: string[];
  /** Emit every chosen set again, even one a previous run already got the SII to
    approve.
    
    Off by default, and that default is the right one: re-emitting an approved
    set spends a fresh folio range for a verdict already obtained, and the
    reuse is what makes an onboarding retry cheap. But the skip used to be
    invisible — a request asking for the seven sets would emit three and answer
    as though it had emitted all seven — so the way to say "no, issue them all"
    had to exist before the skip could be reported honestly.
    
    It does not override a run that is still IN FLIGHT: those folios are alive
    at the SII and a second batch alongside them is the one thing the
    `certification_run_active_unique` slot exists to prevent. */
  reemitApprovedSets?: boolean;
  receiver: DteReceptorDto;
  /** SII test set file (`SIISetDePruebas<RUT>.txt`, ISO-8859-1),
    base64-encoded. Required when `certification` is provided because
    the SII delivers a *per-emisor* file when granting certification —
    there is no canonical location factit could fetch it from.
    
    Size guard: 100 chars of base64 ≈ 75 bytes (smallest plausible
    set), 700 000 chars ≈ 500 KB (much larger than any real set).
    
    **Optional when the company already has one stored**
    (`company.test_set_txt`, migration 0035): the file is per emisor and does
    not change between runs, so hunting for it on disk again on each of the
    seven passes was pure friction. When it does arrive, it replaces the stored
    one. */
  testSetBase64?: string;
  companyId: string;
};
export type SimulationDocumentResultDto = {
  dteId: string;
  dteType: number;
  folio: number;
};
export type SimulationResultDto = {
  certificationRunId: string;
  companyId: string;
  /** The single envelope the whole batch travels in — the SII asks for one envío. */
  envioId: string;
  dtesEmitted: number;
  documents: SimulationDocumentResultDto[];
};
export type SimulationBatchReferenceDto = {
  /** Zero-based position in `documents` of the referenced document; it must come earlier. */
  documentIndex: number;
  /** CodRef: 1 voids the document, 2 corrects its text, 3 corrects its amounts.
    Left out on a reference that corrects nothing, such as a factura naming the
    guía de despacho it invoices. */
  referenceCode?: 1 | 2 | 3;
  /** RazonRef. */
  reason?: string;
};
export type SimulationDocumentDto = {
  dteType: 33 | 34 | 39 | 41 | 43 | 46 | 52 | 56 | 61 | 110 | 111 | 112;
  issueDate: string;
  dueDate?: string;
  dispatch?: DteDispatchDto;
  /** Factura de Compra (46) / notes on one: withhold the seller's IVA in full
    (SII TipoImp 15). Defaults to false; the onboarding sets it automatically
    for the certification set. */
  retainVat?: boolean;
  /** Required for every document type except a boleta (39/41), which defaults
    to the SII's consumidor-final receptor (66666666-6) when omitted. */
  receptor?: DteReceptorDto;
  items: DteItemDto[];
  references?: DteReferenceDto[];
  /** The SII Set de Pruebas case this document answers, e.g. `CASO 5101886-1`.
    Certification only: when present, the document's first reference line is
    TpoDocRef `SET` with this text as RazonRef, as the SII requires of every
    set document, and `references` follow from line 2. */
  certificationCase?: string;
  /** Global discounts/surcharges (<DscRcgGlobal>). They reduce/raise the
    MntNeto or MntExe base before IVA and must be shown on the printed
    representation (SII set: "los descuentos por línea o globales deben ser
    indicados en las representaciones impresas"). */
  globalAdjustments?: DteGlobalAdjustmentDto[];
  /** Liquidación-Factura (43) only: commission lines to deduct. */
  commissions?: DteCommissionDto[];
  /** Exportación (110/111/112) only: currency + aduana info. */
  exportInfo?: DteExportDto;
  /** Guía de Despacho (52) and Exportación (110/111/112) only: the vehicle,
    carrier and driver, emitted as <Transporte>. Ignored on every other type. */
  transport?: DteTransportDto;
  /** Boleta (39/41) only: IndServicio + optional período / medio de pago. */
  boletaInfo?: DteBoletaDto;
  /** FmaPago: 1 cash, 2 credit, 3 no charge. Emitted on 33, 34, 43, 46, 52, 56
    and 61; ignored on exports (which use `exportInfo.paymentMethod`) and
    boletas. Not stored. */
  paymentForm?: 1 | 2 | 3;
  /** TpoTranVenta (SII `TipoTransVENTA`, 1-4): the kind of sale. Emitted and
    ignored like `paymentForm`. Not stored. */
  saleTransactionType?: number;
  /** TpoTranCompra (SII `TipoTransCOMPRA`, 1-7): the kind of purchase. Emitted
    and ignored like `paymentForm`. Not stored. */
  purchaseTransactionType?: number;
  idempotencyKey?: string;
  /** References to EARLIER documents of the same batch, resolved at emission.
    
    A credit or debit note has to name the folio of the document it
    adjusts, and inside a Simulación that folio does not exist until the batch
    is emitted: every document takes its folio from the company's CAFs then.
    So instead of a folio the note names the referenced document's position in
    `documents`, and the run fills in its type, folio and date once that
    document has been issued. They are appended after `references`. */
  batchReferences?: SimulationBatchReferenceDto[];
};
export type CreateSimulationDto = {
  companyId: string;
  documents: SimulationDocumentDto[];
  /** RUT the envío's carátula is addressed to. Defaults to the SII
    (60803000-K); overridable only because a rehearsal against a non-SII
    receiver is occasionally useful. */
  envelopeReceiverTaxNumber?: string;
};
export type CertificationRunListItemDto = {
  id: string;
  companyId: string;
  setNumber: string | null;
  kind: "set" | "simulacion";
  status: "failed" | "queued" | "sent" | "completed" | "emitting" | "polling";
  totalCases: number;
  accepted: number;
  rejected: number;
  objected: number;
  errorMessage: string | null;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  /** The run this one reissues, and the run that reissued it. A listing of a
    company that hit a burnt band of folios is otherwise a column of identical
    red failures, each of which is really one link of a single chain: with these
    the row can say «re-emitida» instead of reading as an open problem.
    
    They are here and `folioConflicts` is not: that one needs each run's
    documents, and this listing deliberately carries none (see the note above). */
  reissueOfRunId: string | null;
  reissuedAsRunId: string | null;
  reissueCount: number;
  /** The cursor's basis; the database's `set_updated_at` trigger maintains it. */
  updatedAt: string;
};
export type CertificationRunListResponseDto = {
  items: CertificationRunListItemDto[];
  /** `null` when no pages are left. */
  nextCursor: string | null;
};
export type CertificationLibroDto = {
  id: string;
  companyId: string;
  operacion: "VENTA" | "COMPRA" | "GUIAS";
  /** The libro's own attention number in the set file, e.g. `5148090`. */
  setNumber: string;
  status: "failed" | "accepted" | "rejected" | "waiting" | "sending" | "sent";
  /** The `libro` row once it is built, for «Libros IECV / Guías». */
  libroId: string | null;
  /** The SII's trackId once uploaded. */
  trackId: string | null;
  /** The SII's raw libro state (`LSO`, `LOK`, `LRC`…) once polled. */
  siiEstado: string | null;
  /** Why it failed or was rejected; while waiting, the last transient problem. */
  lastError: string | null;
  createdAt: string;
  updatedAt: string;
  resolvedAt: string | null;
};
export type CertificationRunDteDto = {
  dteId: string;
  /** The test-set case this document covers (e.g. "CASO 1"). */
  caseId: string | null;
  dteType: number;
  folio: number;
  status:
    | "draft"
    | "queued"
    | "accepted"
    | "rejected"
    | "objected"
    | "sent"
    | "signed"
    | "voided";
  trackId: string | null;
  /** The SII's glosa, formatted `(CODE) text`. It comes from the
    `RESULTADO_ENVIO` email, which is the **only** source of per-folio detail:
    the SII's status services give only per-type counters. */
  errorMessage: string | null;
};
export type CertificationRunStatusDto = {
  id: string;
  companyId: string;
  setNumber: string | null;
  kind: "set" | "simulacion";
  status: "failed" | "queued" | "sent" | "completed" | "emitting" | "polling";
  totalCases: number;
  accepted: number;
  rejected: number;
  objected: number;
  pending: number;
  errorMessage: string | null;
  startedAt: string | null;
  completedAt: string | null;
  /** How many of this run's rejections are the SII saying it already had that
    folio («(DTE-3-101) Folio para este Tipo de documento ya fue recibido en el
    SII»).
    
    It is published, rather than left for the client to spot in the glosas,
    because the rule that recognises the code lives in the backend
    (`folio-conflict.ts`) and it is the same rule that decides whether to spend
    folios reissuing. A second copy in the SPA would be the one that drifts.
    
    The distinction it buys the reader is the whole point: `rejected` counts
    documents, and a folio conflict is not a defective document — it is a
    perfect document carrying an unusable number. Compare it against `rejected`
    to know which of the two a run is suffering. */
  folioConflicts: number;
  /** What is going to happen about those conflicts, already decided. Each value
    maps to a different action by whoever reads the screen — wait, follow the
    successor, fix the documents, or load a new CAF — and none of them can be
    worked out from the glosas alone: see `ReissueOutcome`. */
  reissueOutcome:
    | "pending"
    | "none"
    | "reissued"
    | "other_rejections"
    | "budget_exhausted"
    | "no_emission_input";
  /** The run this one reissues, or `null` when it is a first attempt. */
  reissueOfRunId: string | null;
  /** The run that reissued THIS one, or `null`. Non-null means this run was
    superseded: its folios were the SII's already, and the set went out again
    over new ones. Nothing here is left to do — the reader has to be sent to the
    successor instead of to a red failure. */
  reissuedAsRunId: string | null;
  /** How many reissues this chain carries. `0` on a first attempt. It is what
    separates "the reissue has not run yet" from "it ran and the folio was
    taken again", which read identically from the glosa alone. */
  reissueCount: number;
  /** The envelopes grouping this run's DTEs. They are what allows resending with
    `POST /envios/:id/send` when one gets stuck. */
  envioIds: string[];
  dtes: CertificationRunDteDto[];
};
export type ApplyReceptionResultSummaryDto = {
  /** The track id the result names (with no leading zeros). */
  trackId: string;
  /** Detail rows that matched a DTE of this run. */
  matched: number;
  /** Rows with no matching DTE — wrong run or wrong envelope. */
  unmatched: number;
  /** DTEs marked accepted (they do not appear in the detail). */
  accepted: number;
  /** DTEs marked rejected (RCH). */
  rejected: number;
  /** DTEs marked with reparos (RPR — "aceptado con reparos"). */
  objected: number;
};
export type ReceptionResultDto = {
  /** The raw structured "Resultado de Validación de Envío" — the content of the
    DTEMAIL<trackId>.xml attachment on the SII reception email
    (siidte_error@sii.cl), i.e. the `<RESULTADO_ENVIO>…</RESULTADO_ENVIO>` XML.
    The parser understands only this structured XML; the plain-text .txt twin
    is not accepted (an empty TRACKID is rejected with 400). */
  text: string;
};
export type SimulationDateWindowDto = {
  from: string;
  to: string;
};
export type SimulationFolioRequirementDto = {
  dteType: number;
  count: number;
};
export type FolioShortfallDto = {
  dteType: number;
  required: number;
  available: number;
};
export type SimulationFolioSummaryDto = {
  /** The folios the emission will consume, per type. A document an earlier
    attempt already issued, and that can still go out in an envío, is replayed
    on its own folio and is not counted. */
  required: SimulationFolioRequirementDto[];
  shortfalls: FolioShortfallDto[];
};
export type SimulationSourceFolioDto = {
  dteType: number;
  sourceFolio: number;
};
export type SimulationCompletionDto = {
  /** How many documents the company's own are short of 20. */
  missingDocuments: number;
  /** Certified DTE types the company's own documents do not carry. */
  missingTypes: number[];
  /** What the completion needs and the documents do not hold: `customer`,
    `taxableProduct`, `exemptProduct`, `exportCustomer`. Each can be invented
    with `complete.inventMissing`. */
  gaps: string[];
  /** How many composed documents this preview's batch carries. */
  composedCount: number;
};
export type SimulationPreviewDto = {
  /** Postable verbatim as `documents` of `POST /certification-runs/simulation`. */
  documents: SimulationDocumentDto[];
  /** What the parser saw and is worth a look (references, boletas, lines with no amount). */
  warnings: string[];
  /** What would make the emission fail: future dates, boletas, minimums/maximums. */
  problems: string[];
  /** The emission dates accepted today — what the date problems were judged against. */
  dateWindow: SimulationDateWindowDto;
  folios: SimulationFolioSummaryDto;
  sourceFolios: SimulationSourceFolioDto[];
  /** `true` when there are no problems and no folios are missing. */
  issuingIsSafe: boolean;
  /** Present on a preview of the company's own documents (`xmls` or `importId`). */
  completion?: SimulationCompletionDto;
};
export type ComposeSimulationCustomerDto = {
  taxNumber: string;
  legalName: string;
  businessActivity: string;
  address: string;
  district: string;
  city?: string;
};
export type ComposeSimulationProductDto = {
  name: string;
  /** Net unit price in CLP, before IVA. */
  unitPrice: number;
  /** Sold without IVA. Exempt products go on facturas exentas (34), the rest on 33. */
  isExempt?: boolean;
};
export type ComposeSimulationExportCustomerDto = {
  legalName: string;
  /** The buyer's country, spelled as the Aduana's country table spells it
    (`ESTADOS UNIDOS`, `CHINA`, `ALEMANIA`…). It is both the receptor's and
    the destination country. */
  country: string;
  address?: string;
  city?: string;
  /** The currency the export is invoiced in, as the SII names it (`DOLAR USA`,
    `EURO`…). Defaults to `DOLAR USA`. Product prices, which are in pesos, are
    converted at a fixed rate: the certification environment checks that the
    PESO CL restatement is consistent, not that the rate is the day's. */
  currency?: string;
};
export type ComposeSimulationDto = {
  customers: ComposeSimulationCustomerDto[];
  products: ComposeSimulationProductDto[];
  /** Required when the batch has a factura de exportación (110) to compose, or
    a nota de exportación (111/112) and no 110 to adjust. */
  exportCustomer?: ComposeSimulationExportCustomerDto;
  /** How many documents the envío carries in all, recovered ones included; the
    declaration form takes 20 to 100. */
  documentCount: number;
};
export type CompleteSimulationDto = {
  /** Fills with plainly generic values what the documents do not provide —
    a foreign buyer for a composed 110, an exempt product for a composed 34.
    Without it, such gaps are reported in `completion.gaps` and nothing is
    composed. */
  inventMissing?: boolean;
};
export type PreviewSimulationDto = {
  companyId: string;
  /** Already-emitted DTEs: a lone `<DTE>`, a whole `<EnvioDTE>`, or the `<SetDTE>`
    backup the SII's own portal exports, in any combination.
    
    Each entry is either the XML itself or its bytes in base64, and base64 is
    what a browser should send. The SII declares its documents ISO-8859-1 while
    a browser reads an uploaded file as UTF-8, which destroys every accented
    character before the server sees it; base64 carries the bytes intact and the
    server decodes them by the encoding the document declares.
    
    The cap counts entries, not documents: one envelope can bring many, and the
    Simulación's real limit (100) is checked against the recovered documents. */
  xmls?: string[];
  /** A finished import from the SII's free invoicing system, used instead of
    uploading its files by hand.
    
    The documents are read from where the import stored them, so previewing
    again costs nothing at the SII: the portal is walked once, when the import
    runs. Exactly one of `xmls`, `importId` and `compose` must be given. */
  importId?: string;
  /** Builds the batch from the company's customers and products instead of
    from documents it already issued: the path for a company with no invoicing
    history to recover. The documents come back like any other preview's,
    postable as they are. */
  compose?: ComposeSimulationDto;
  /** Completes the documents given in `xmls` or `importId` automatically, from
    their own customers and products. Not taken together with `compose`. */
  complete?: CompleteSimulationDto;
};
export type MuestrasMailRunDto = {
  runId: string;
  documents: number;
  files: number;
};
export type MuestrasMailResultDto = {
  messageId: string;
  to: string[];
  attachments: number;
  totalBytes: number;
  runs: MuestrasMailRunDto[];
};
export type EmailMuestrasDto = {
  /** The runs whose muestras are sent. Several in one email because the SII asks
    for the test set's documents AND the simulation's together. */
  runIds: string[];
  /** Narrows a run to some of its documents: a run with at least one document in
    this list sends only those, and a run with none sends every document.
    
    It is how the ten documents of the Simulación go alongside the WHOLE Set de
    Pruebas in one email — the simulation run can hold up to 100. */
  dteIds?: string[];
  /** An explicit recipient; by default, the SII's impresos casilla. */
  to?: string[];
  subject?: string;
  from?: string;
};
export type EmittedDteImportBatchDto = {
  /** Inclusive window this file covers, `YYYY-MM-DD`. */
  from: string;
  to: string;
  /** Documents inside it. The portal exports at most 20 per file. */
  documents: number;
};
export type EmittedDteSelectionDto = {
  dteType: number;
  folio: number;
  /** `YYYY-MM-DD`. */
  issueDate: string;
  receiverTaxNumber: string;
  /** CLP, integer. */
  totalAmount: number;
};
export type EmittedDteExclusionDto = {
  /** One of `outside-window`, `type-not-allowed`, `unknown-type`, `not-emitted`,
    `note-excluded`, `no-folios`, `busy-day`, `over-target`. */
  reason: string;
  count: number;
};
export type EmittedDteReportSummaryDto = {
  /** Report lines read for the window, after de-duplication. */
  rows: number;
  /** Lines that passed every eligibility rule, whether or not they were picked. */
  eligible: number;
  excluded: EmittedDteExclusionDto[];
  /** «Archivo Respaldo» navigations the plan needed, including top-ups. */
  requests: number;
};
export type EmittedDteImportDto = {
  id: string;
  companyId: string;
  /** The window asked for, which is not necessarily one file: see `batches`. */
  windowFrom: string;
  windowTo: string;
  /** `pending` | `in_progress` | `fulfilled` | `failed`. */
  status: string;
  attempts: number;
  /** Documents recovered across every file. */
  documentCount: number;
  batches: EmittedDteImportBatchDto[];
  /** `window` | `auto`. Which path produced this import: an explicit date range
    chosen by the operator, or the set assembled from the «Informe». The screen
    shows a different progress line and a different result for each, so it is
    part of the row rather than something the caller has to remember from the
    request that started it. */
  mode: string;
  /** The documents the `auto` path chose, in the order it ranked them; `null` on
    a `window` import, which chooses nothing and takes the range entire.
    
    Not the same as the contents of `batches`: one «Archivo Respaldo» export
    answers with whole days, so the stored files hold documents that were never
    part of the set. This is the set. */
  selection: EmittedDteSelectionDto[] | null;
  /** Counts behind the set, or `null` on a `window` import. */
  reportSummary: EmittedDteReportSummaryDto | null;
  /** How many documents the `auto` path was asked to aim for, or `null` when the
    caller did not choose and the server's own default applied. It is echoed so
    a caller that sent one can see it was honoured rather than assume it. */
  targetSize: number | null;
  /** What went wrong, or — on a run that finished — what it could not cover:
    the windows the portal refused to export, which have to be uploaded by
    hand, and the ones that came back empty, which are the taxpayer's own
    history rather than a failure. */
  lastError: string | null;
  createdAt: string;
  resolvedAt: string | null;
};
export type EmittedDteImportEnqueuedDto = {
  enqueued: EmittedDteImportDto;
};
export type CreateEmittedDteImportDto = {
  /** `window` (the default) takes the range below; `auto` computes it and
    chooses the documents. */
  mode?: "window" | "auto";
  /** Inclusive, `YYYY-MM-DD`. Required on the `window` path; not accepted on `auto`. */
  from?: string;
  /** Inclusive, `YYYY-MM-DD`. Required on the `window` path; not accepted on `auto`. */
  to?: string;
  /** How many documents the `auto` path aims for; 22 when it is not given.
    
    A value below 20, the minimum the pe_avance2 declaration form puts on the
    Simulación envío, is raised to 20: a smaller set could be issued but not
    declared. It is not accepted on the `window` path, which takes
    whatever the range holds: a caller that sends a size there believes it is
    capping the set, and that path cannot honour it. */
  targetSize?: number;
};
export type EmittedDteImportAvailabilityDto = {
  available: boolean;
  /** Absent when `available`. Written for an operator, not for a log. */
  reason: string | null;
};
export type BuiltLibroResponseDto = {
  id: string;
  operacion: "VENTA" | "COMPRA" | "GUIAS";
  /** Tax period (YYYY-MM). */
  periodo: string;
  documentCount: number;
  signedXmlUri: string;
  status: "built" | "accepted" | "rejected" | "sent";
};
export type LibroIvaNoRecuperableDto = {
  /** 1 no gravadas/exentas, 2 fuera de plazo, 3 gastos rechazados, 4 entrega gratuita, 9 otros. */
  codigo: 1 | 2 | 3 | 4 | 9;
  monto: number;
};
export type LibroDocDto = {
  dteType: number;
  folio: number;
  issueDate?: string;
  counterpartyRut?: string;
  counterpartyName?: string;
  exemptAmount?: number;
  netAmount?: number;
  /** Recoverable IVA only — see {@link LibroDoc.vatAmount}. */
  vatAmount?: number;
  /** IVA rate as a percentage (19). */
  tasaImp?: number;
  /** IVA uso común, prorated by the libro's `factorProporcionalidadIva`. */
  ivaUsoComun?: number;
  ivaNoRecuperable?: LibroIvaNoRecuperableDto[];
  /** IVA withheld in full by the buyer (factura de compra). */
  ivaRetTotal?: number;
  /** The document this one modifies, for a nota de crédito/débito. */
  refDteType?: number;
  refFolio?: number;
  totalAmount: number;
};
export type LibroGuiaFacturaDto = {
  dteType: number;
  folio: number;
  issueDate?: string;
};
export type LibroGuiaOverrideDto = {
  folio: number;
  /** 1 annulled before being sent to the SII, 2 after, 3 partial reception. */
  anulado?: 1 | 2 | 3;
  /** The corrected amount; only applies with `anulado: 3`. */
  montoModificado?: number;
  facturadaPor?: LibroGuiaFacturaDto;
};
export type BuildLibroDto = {
  companyId: string;
  /** VENTA/GUIAS build from emitted DTEs; COMPRA builds from `docs`. */
  operacion: "VENTA" | "COMPRA" | "GUIAS";
  /** Tax period, "YYYY-MM". */
  periodo: string;
  /** The certification's attention number (FolioNotificacion). */
  folioNotificacion?: string;
  /** Restricts the emitted DTEs the libro aggregates to those of one
    certification run — i.e. to one SII test set. Omit for a real libro, which
    must declare every document of the period. */
  certificationRunId?: string;
  /** Like `certificationRunId`, for a libro that spans several test sets: the
    libro de ventas declares the documents of both the basic set and the
    exempt-invoice set. Combined with `certificationRunId` when both are given. */
  certificationRunIds?: string[];
  /** The Set de Pruebas attention number this libro answers — normally the
    libro's own «NUMERO DE ATENCION» in the set file, the same value as
    `folioNotificacion`. Stored on the libro so «Declarar Avance» can tell a
    libro of the current set from one of a set the SII no longer evaluates.
    Omit for a real libro. */
  setNumber?: string;
  /** Received documents for a Libro de Compras. */
  docs?: LibroDocDto[];
  /** `FctProp` — factor de proporcionalidad del IVA uso común (e.g. 0.6), used
    to derive `TotCredIVAUsoComun`. Only meaningful for a Libro de Compras that
    has documents with IVA uso común. */
  factorProporcionalidadIva?: number;
  /** A Libro de Compras normally also declares the company's OWN facturas de
    compra (tipo 46) — those are purchases where we withheld the IVA. Set this
    to false to declare exactly the documents in `docs`, which is what an SII
    certification set requires: it names the documents the libro must contain,
    and the facturas de compra emitted for a different set are not among them. */
  includeEmittedFacturasCompra?: boolean;
  /** VENTA and COMPRA only: send the period's totals without the per-document
    detail. The SII already holds every electronic document; a certification
    set's libro de ventas is sent this way. */
  summaryOnly?: boolean;
  /** Per-guía overrides for a Libro de Guías, keyed by folio. */
  guias?: LibroGuiaOverrideDto[];
};
export type LibroListItemDto = {
  id: string;
  companyId: string;
  operacion: "VENTA" | "COMPRA" | "GUIAS";
  /** Tax period (YYYY-MM). */
  periodo: string;
  documentCount: number;
  trackId: string | null;
  status: "built" | "accepted" | "rejected" | "sent";
  /** The SII's raw code (`LSO`, `LOK`, `LRC`, `-11`), once it has been polled. */
  siiEstado: string | null;
  glosa: string;
  /** When it was uploaded to the SII; `null` while it is merely built. */
  sentAt: string | null;
  createdAt: string;
  /** The cursor's basis; the database's `set_updated_at` trigger maintains it. */
  updatedAt: string;
};
export type LibroListResponseDto = {
  items: LibroListItemDto[];
  /** `null` when no pages remain. */
  nextCursor: string | null;
};
export type LibroUploadResponseDto = {
  id: string;
  trackId: string | null;
  status: "built" | "accepted" | "rejected" | "sent";
  glosa: string;
};
export type LibroStatusResponseDto = {
  id: string;
  trackId: string | null;
  status: "built" | "accepted" | "rejected" | "sent";
  /** The SII's raw code: `LSO`, `LOK`, `LRC` or `-11`. */
  estado: string;
  glosa: string;
  terminal: boolean;
  errors: string[];
};
export type LibroDetailDto = {
  id: string;
  trackId: string | null;
  status: "built" | "accepted" | "rejected" | "sent";
  glosa: string;
  operacion: "VENTA" | "COMPRA" | "GUIAS";
  /** Tax period (YYYY-MM). */
  periodo: string;
};
export type CertificationStepDto = {
  key:
    | "simulacion"
    | "set_de_pruebas"
    | "intercambio"
    | "muestras_impresas"
    | "declaracion_cumplimiento"
    | "autorizado";
  status: "pending" | "done" | "current";
};
export type CertificationStageViewDto = {
  current:
    | "simulacion"
    | "set_de_pruebas"
    | "intercambio"
    | "muestras_impresas"
    | "declaracion_cumplimiento"
    | "autorizado";
  /** `sii` when the step comes from the PASO read off «Ver Avance»; `local` when
    it is estimated from Factit's own records because no known PASO was read. */
  source: "sii" | "local";
  /** All six steps, in the official order. */
  steps: CertificationStepDto[];
};
export type AvanceSnapshotRowDto = {
  label: string;
  estado: string;
};
export type AvanceSnapshotViewDto = {
  /** The PASO, verbatim, e.g. `SET DE PRUEBAS`. */
  paso: string;
  /** In page order. */
  rows: AvanceSnapshotRowDto[];
  readAt: string;
  /** What triggered the read. */
  source: "manual" | "scheduled" | "after_declaration" | "after_advance";
};
export type SetVerdictReparoDto = {
  /** The case as the SII names it, e.g. `CASO 5101892-1` or `Resumen Doc 34`. */
  caseLabel: string;
  /** The document type, or null on a libro's resumen line. */
  dteType: number | null;
  /** The folio, or null on a libro's resumen line. */
  folio: number | null;
  /** Each reparo of the case, as the SII wrote it. */
  messages: string[];
};
export type SetVerdictDto = {
  /** The set's number, e.g. `5101892`. */
  setNumber: string;
  /** The reviewed envío's trackId, without leading zeros. */
  trackId: string;
  /** The set type, verbatim. */
  setType: string;
  /** `SOK` when approved, `SRH` when rejected; others are passed through. */
  estadoCode: string;
  /** The estado's words, verbatim. */
  estadoText: string;
  approved: boolean;
  /** Empty when approved. */
  reparos: SetVerdictReparoDto[];
  /** `email` when it arrived by itself, `manual` when it was pasted in. */
  source: "email" | "manual";
  receivedAt: string;
  /** True when it is about the row's current envío. False when the row now holds
    a newer envío the SII has not reviewed, and this is the last verdict on the
    same set: what the new envío was meant to fix. */
  forCurrentEnvio: boolean;
};
export type AvanceRowDto = {
  kind:
    | "basico"
    | "guia"
    | "exenta"
    | "exportacion1"
    | "exportacion2"
    | "factura_compra"
    | "liquidacion"
    | "libro_ventas"
    | "libro_compras"
    | "libro_guias"
    | "simulacion";
  /** The portal's hidden set code: the row's key. */
  setCode: string;
  /** The SII's label, verbatim. */
  label: string;
  /** The set's number in the company's current Set de Pruebas file, or null. */
  attentionNumber: string | null;
  /** The trackId exactly as the SII issued it, or null. */
  trackId: string | null;
  /** The envío's date as the form wants it: `dd-mm-aaaa`, America/Santiago. */
  fecha: string | null;
  /** The instant `fecha` comes from, ISO 8601. */
  sentAt: string | null;
  sourceType: ("libro" | "envio") | null;
  /** `envio.id` or `libro.id`. */
  sourceId: string | null;
  /** The certification run behind the envío, for the link to its screen. */
  runId: string | null;
  /** The run's status or the libro's SII code, as a short machine value. */
  factitStatus: string | null;
  /** The estado the SII shows for this row, verbatim, or null when never read. */
  siiEstado: string | null;
  siiEstadoClass:
    ("pending" | "rejected" | "unknown" | "in_review" | "approved") | null;
  /** True when a libro was matched to the current set by date only. */
  inferred: boolean;
  /** How many documents the row's run holds, or null without a run. */
  documentCount: number | null;
  /** The certified DTE types the Simulación envío lacks; empty for every other row. */
  missingDteTypes: number[];
  /** True exactly when `reasons` is empty. */
  eligible: boolean;
  /** Every rule the row fails; `not_offered` when the portal has no such row. */
  reasons: (
    | "document_count"
    | "no_candidate"
    | "superseded_set"
    | "not_accepted"
    | "split_envio"
    | "out_of_window"
    | "bad_track_id"
    | "unmapped"
    | "already_declared"
    | "not_offered"
    | "missing_dte_types"
  )[];
  /** What the SII's SETMAIL said about this set, or null when none is on file. */
  setVerdict: SetVerdictDto | null;
};
export type AvanceDeclarationRowDto = {
  setCode: string;
  kind:
    | "basico"
    | "guia"
    | "exenta"
    | "exportacion1"
    | "exportacion2"
    | "factura_compra"
    | "liquidacion"
    | "libro_ventas"
    | "libro_compras"
    | "libro_guias"
    | "simulacion";
  label: string;
  trackId: string;
  /** `dd-mm-aaaa`. */
  fecha: string;
  sourceType: "libro" | "envio";
  sourceId: string;
};
export type AvanceDeclarationDto = {
  id: string;
  step: "simulacion" | "set_de_pruebas";
  status: "pending" | "failed" | "in_progress" | "submitted";
  /** What this declaration sent, sorted by set code. When it is the follow-up
    that declared held-back libros, the round's first batch is included, so
    the rows are the whole round. */
  rows: AvanceDeclarationRowDto[];
  /** Confirmed libros held back until the SII approves the set they depend on
    (the LIBRO DE GUIAS waits for the SET GUIA DE DESPACHO). Factit declares
    them by itself once the set's verdict is in. */
  deferredRows: AvanceDeclarationRowDto[];
  /** When `deferredRows` were declared in a follow-up or dropped; null while they wait. */
  deferredSettledAt: string | null;
  /** Set on the follow-up that declared another declaration's held-back libros. */
  deferredFromId: string | null;
  /** The failure's code (spec §5.3), or null. */
  errorCode:
    | (
        | "certificate"
        | "portal-down"
        | "rate-limited"
        | "form-changed"
        | "fill-mismatch"
        | "rejected-by-portal"
        | "unknown-after-submit"
      )
    | null;
  /** What went wrong. On `rejected-by-portal` it is the SII's own text,
    verbatim, so the screen can show it as the SII wrote it. */
  errorMessage: string | null;
  /** The text of the portal's answer to «Confirmar Revisión», tags stripped. */
  responseText: string | null;
  /** Blob key of the failure diagnostics, when they were captured. */
  diagnosticsKey: string | null;
  /** Portal runs started for this declaration. */
  attempts: number;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  /** When the job was about to click «Confirmar Revisión». Once set, nothing
    submits this declaration again; a run that cannot tell how the SII answered
    ends as `unknown-after-submit` instead. */
  submitReachedAt: string | null;
};
export type AvanceStepAdvanceDto = {
  id: string;
  /** The PASO it advanced from, verbatim, e.g. `SET DE PRUEBAS`. */
  paso: string;
  /** The SII's code for that PASO as the button posted it (`P01`), once read. */
  pasoCode: string | null;
  status: "pending" | "failed" | "in_progress" | "submitted";
  errorCode:
    | (
        | "certificate"
        | "portal-down"
        | "rate-limited"
        | "form-changed"
        | "fill-mismatch"
        | "rejected-by-portal"
        | "unknown-after-submit"
      )
    | null;
  /** What went wrong; the SII's own text on `rejected-by-portal`. */
  errorMessage: string | null;
  /** The text of the portal's answer to the press, tags stripped. */
  responseText: string | null;
  diagnosticsKey: string | null;
  attempts: number;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  /** When the job was about to click. Once set, nothing presses again for this
    row; a run that cannot tell how the SII answered ends as
    `unknown-after-submit`. */
  submitReachedAt: string | null;
};
export type AvanceStepAdvanceViewDto = {
  /** The latest «Ver Avance» read shows every set of its PASO approved. */
  ready: boolean;
  /** The PASO to confirm with `POST …/step-advances`, when `ready`. */
  paso: string | null;
  /** Why it cannot be pressed right now although `ready`, or null. */
  blockedReason: string | null;
  /** The press still pending or in progress, if any. */
  open: AvanceStepAdvanceDto | null;
  /** The most recent press that finished. */
  last: AvanceStepAdvanceDto | null;
};
export type SiiAvanceViewDto = {
  stage: CertificationStageViewDto;
  /** The latest «Ver Avance» read, or null when the SII was never read. */
  snapshot: AvanceSnapshotViewDto | null;
  /** Every row, in portal order. */
  rows: AvanceRowDto[];
  /** The hash to confirm with `POST …/declarations`, or null when nothing can be
    declared right now (see each row's `reasons`). */
  payloadHash: string | null;
  /** The declaration still pending or in progress, if any. */
  openDeclaration: AvanceDeclarationDto | null;
  /** The most recent declaration that finished, submitted or failed. */
  lastDeclaration: AvanceDeclarationDto | null;
  /** Whether a declaration may leave some offered rows blank. */
  allowPartial: boolean;
  /** Why no portal run can be attempted for this company right now (the
    automation switched off, no enabled representative, no valid certificate),
    or null when one can. */
  unavailableReason: string | null;
  /** «Avanzar Siguiente Paso», offered once every set of the PASO is approved. */
  stepAdvance: AvanceStepAdvanceViewDto;
};
export type SiiAvanceDeclarationEnqueuedDto = {
  declarationId: string;
};
export type DeclareSiiAvanceDto = {
  /** The `payloadHash` of `GET /companies/:companyId/sii-avance`: 64 hex characters. */
  payloadHash: string;
};
export type SiiAvanceStepAdvanceEnqueuedDto = {
  advanceId: string;
};
export type AdvanceSiiAvanceStepDto = {
  /** `stepAdvance.paso` of `GET /companies/:companyId/sii-avance`, verbatim. */
  paso: string;
};
export type RecordSetVerdictDto = {
  /** The attachment's text, verbatim. */
  text: string;
};
export type SiiAvanceRefreshEnqueuedDto = {
  /** Always true: the read was queued and will land as a new snapshot. */
  enqueued: boolean;
};
export type SiiTestSetEntryDto = {
  /** The number the SII identifies the set by, e.g. `4964610`. */
  number: string;
  title: string;
};
export type SiiTestSetOptionDto = {
  /** The SII's field name, e.g. `SET03`. */
  field: string;
  /** The SII's label, verbatim. */
  label: string;
  /** The file on record carries this set, so the screen ticks it by default. */
  suggested: boolean;
};
export type SiiTestSetPreviousDto = {
  label: string;
  estado: string;
};
export type SiiTestSetDownloadDto = {
  id: string;
  /** The optional sets requested; the SET BASICO is implied. */
  optionalSets: string[];
  status: "pending" | "failed" | "in_progress" | "submitted";
  errorCode:
    | (
        | "certificate"
        | "portal-down"
        | "rate-limited"
        | "form-changed"
        | "fill-mismatch"
        | "rejected-by-portal"
        | "unknown-after-submit"
      )
    | null;
  /** What went wrong; the SII's own text on `rejected-by-portal`. */
  errorMessage: string | null;
  diagnosticsKey: string | null;
  /** What the SII listed as obtained right before the click, once a run read it. */
  previousSets: SiiTestSetPreviousDto[] | null;
  /** The set numbers of the new file, once it arrived. */
  setNumbers: string[] | null;
  attempts: number;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  /** When the job was about to click. Once set, nothing presses again for this
    row; a run that cannot tell how the SII answered ends as
    `unknown-after-submit`. */
  submitReachedAt: string | null;
};
export type SiiTestSetViewDto = {
  /** The sets of the file on record, in file order; empty when there is none. */
  currentSets: SiiTestSetEntryDto[];
  options: SiiTestSetOptionDto[];
  /** The POST must carry the company's RUT as `confirmTaxNumber`. */
  confirmTaxNumber: boolean;
  /** Why it cannot be pressed right now, or null. */
  blockedReason: string | null;
  /** Why no portal run can be attempted for this company at all, or null. */
  unavailableReason: string | null;
  /** The download still pending or in progress, if any. */
  open: SiiTestSetDownloadDto | null;
  /** The most recent download that finished. */
  last: SiiTestSetDownloadDto | null;
};
export type SiiTestSetDownloadEnqueuedDto = {
  downloadId: string;
};
export type DownloadSiiTestSetDto = {
  /** The optional sets to request, as `GET …/sii-test-set` lists them in
    `options` (`SET03`, `SET72`, …). The SET BASICO is always requested and is
    not listed. Empty asks for the SET BASICO and its libros only. */
  optionalSets: string[];
  /** Must be true: the person read that the current set stops counting. */
  acknowledgeReset: boolean;
  /** The company's RUT, typed by the person. Required when `confirmTaxNumber`
    of `GET …/sii-test-set` is true, because there is a set to lose. */
  confirmTaxNumber?: string;
};
export type SiiIntercambioDownloadDto = {
  id: string;
  status: "pending" | "failed" | "in_progress" | "succeeded";
  errorCode:
    | (
        | "certificate"
        | "portal-down"
        | "rate-limited"
        | "form-changed"
        | "fill-mismatch"
        | "rejected-by-portal"
        | "unknown-after-submit"
      )
    | null;
  /** What went wrong; the SII's own text on `rejected-by-portal`. */
  errorMessage: string | null;
  diagnosticsKey: string | null;
  /** The name the SII gave the file (`ENVIO_DTE_<n>.xml`), once it arrived. */
  fileName: string | null;
  /** The envelope the file became, to open on «Intercambio de información». */
  inboundEnvioId: string | null;
  attempts: number;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
};
export type SiiIntercambioSetViewDto = {
  /** Why no portal run can be attempted for this company at all, or null. */
  unavailableReason: string | null;
  /** The download still pending or in progress, if any. */
  open: SiiIntercambioDownloadDto | null;
  /** The most recent download that finished. */
  last: SiiIntercambioDownloadDto | null;
};
export type SiiIntercambioDownloadEnqueuedDto = {
  downloadId: string;
};
export type HealthCheckResponseDto = {
  /** `ok` when the dependencies answer. */
  status: string;
  /** Postgres status. */
  db: string;
  /** Redis status. */
  redis: string;
};
export type LowCafDto = {
  id: string;
  dteType: number;
  folioFrom: number;
  folioTo: number;
  remaining: number;
  /** A CAF past its validity (Res. Ex. SII N° 58/2017). Its folios count as 0
    because the SII rejects them, so it shows up here **even with its whole
    range intact** — and whoever operates needs to tell "spent" from "expired". */
  expired: boolean;
  /** The **effective** threshold for its (company, type): the greater of the
    configured floor (`company_folio_policy.low_threshold`, or the deployment's)
    and the rate-based reorder point, `ceil(daily_consumption ×
    FOLIO_REORDER_DAYS)`.
    
    It travels in the response because, with per-type and rate-based thresholds,
    the list stops being self-explanatory: a CAF with 40 folios can appear while
    one with 15 does not, and without this number that reads as a bug. */
  threshold: number;
  /** Usable folios left to this CAF's (company, type), summed across all of its
    CAFs — which is what gets compared against `threshold`.
    
    This is what explains why a CAF with half its range intact still appears:
    what is low is the pair's stock, not this row. Without it the list looks
    like it contradicts itself. */
  typeRemaining: number;
};
export type ExpiringCertificateDto = {
  id: string;
  companyId: string;
  validTo: string;
  subjectCommonName: string | null;
};
export type AdminHealthSnapshotDto = {
  /** How many DTEs there are in each status. */
  dteByStatus: {
    [key: string]: number;
  };
  cafsLow: LowCafDto[];
  certsExpiringSoon: ExpiringCertificateDto[];
  /** Received DTEs not yet acknowledged. Each has 8 calendar days to run. */
  inboundPending: number;
};
export type CuadraturaAmountsDto = {
  emitted: number;
  accepted: number;
  objected: number;
  rejected: number;
  awaitingVerdict: number;
  notPresented: number;
};
export type CuadraturaTallyDto = {
  emitted: number;
  accepted: number;
  /** Accepted with reparos: they exist for tax purposes, but the source needs fixing. */
  objected: number;
  rejected: number;
  /** In the SII's hands, with no verdict yet. */
  awaitingVerdict: number;
  /** **The serious case**: a folio consumed that the SII never saw — a gap in the
    numbering. It has to be investigated and then presented or annulled. */
  notPresented: number;
  amounts: CuadraturaAmountsDto;
};
export type CuadraturaByTypeDto = {
  emitted: number;
  accepted: number;
  /** Accepted with reparos: they exist for tax purposes, but the source needs fixing. */
  objected: number;
  rejected: number;
  /** In the SII's hands, with no verdict yet. */
  awaitingVerdict: number;
  /** **The serious case**: a folio consumed that the SII never saw — a gap in the
    numbering. It has to be investigated and then presented or annulled. */
  notPresented: number;
  amounts: CuadraturaAmountsDto;
  dteType: number;
};
export type CuadraturaByEnvioDto = {
  status:
    | (
        | "queued"
        | "accepted"
        | "rejected"
        | "sending"
        | "sent"
        | "processed"
        | "partially_accepted"
        | "needs_review"
      )
    | null;
  /** `null` groups every document that never travelled in an envio. */
  envioId: string | null;
  trackId: string | null;
  emitted: number;
  accepted: number;
  /** Accepted with reparos: they exist for tax purposes, but the source needs fixing. */
  objected: number;
  rejected: number;
  /** In the SII's hands, with no verdict yet. */
  awaitingVerdict: number;
  /** **The serious case**: a folio consumed that the SII never saw — a gap in the
    numbering. It has to be investigated and then presented or annulled. */
  notPresented: number;
  amounts: CuadraturaAmountsDto;
};
export type CuadraturaExceptionDto = {
  dteId: string;
  dteType: number;
  folio: number;
  issueDate: string;
  status:
    | "draft"
    | "queued"
    | "accepted"
    | "rejected"
    | "objected"
    | "sent"
    | "signed"
    | "voided";
  bucket:
    "accepted" | "rejected" | "objected" | "awaitingVerdict" | "notPresented";
  trackId: string | null;
  /** The SII's per-folio glosa; `null` when it never issued one. */
  errorMessage: string | null;
  totalAmount: number;
};
export type CuadraturaReportDto = {
  from: string;
  to: string;
  companyId?: string;
  totals: CuadraturaTallyDto;
  byDteType: CuadraturaByTypeDto[];
  byEnvio: CuadraturaByEnvioDto[];
  /** Every document that is not `accepted`. This is the worklist: an auditor
    reads the totals, an operator works the exceptions. */
  exceptions: CuadraturaExceptionDto[];
  /** `true` when `exceptions` was cut short by `exceptionLimit`. */
  exceptionsTruncated: boolean;
};
export type SandboxCertificateDto = {
  fingerprint: string;
  validTo: string;
  /** Passphrase of the self-signed certificate. **Handed over exactly once**, when
    the sandbox is created. */
  passphrase: string;
};
export type SandboxCafDto = {
  dteType: number;
  folioFrom: number;
  folioTo: number;
};
export type SandboxCompanyDto = {
  companyId: string;
  taxNumber: string;
  legalName: string;
  isSandbox: boolean;
  isProduction: boolean;
  certificate: SandboxCertificateDto;
  cafs: SandboxCafDto[];
};
export type CreateSandboxDto = {
  name?: string;
  /** The DTE types to generate CAFs for. Default: the service's own set. */
  dteTypes?: number[];
  foliosPerType?: number;
};
export type SandboxCompanySummaryDto = {
  companyId: string;
  taxNumber: string;
  legalName: string;
  createdAt: string;
};
export type TopUpFoliosDto = {
  /** Required: it is what the contract could not express when it came out `{}`. */
  dteType: number;
  quantity?: number;
};
export const {
  useAuthControllerLoginQuery,
  useLazyAuthControllerLoginQuery,
  useAuthControllerCallbackQuery,
  useLazyAuthControllerCallbackQuery,
  useAuthControllerLogoutMutation,
  useEmailVerificationControllerStatusQuery,
  useLazyEmailVerificationControllerStatusQuery,
  useEmailVerificationControllerSendMutation,
  useEmailVerificationControllerVerifyMutation,
  usePhoneVerificationControllerStatusQuery,
  useLazyPhoneVerificationControllerStatusQuery,
  usePhoneVerificationControllerSendMutation,
  usePhoneVerificationControllerVerifyMutation,
  useAccountControllerAccountQuery,
  useLazyAccountControllerAccountQuery,
  useAccountControllerUpdateSelectionMutation,
  useAccountControllerOnboardingQuery,
  useLazyAccountControllerOnboardingQuery,
  useAccountControllerReadSegmentQuery,
  useLazyAccountControllerReadSegmentQuery,
  useAccountControllerUpdateSegmentMutation,
  useAccountControllerIssueApiKeyMutation,
  useAccountControllerRevokeApiKeyMutation,
  useAccountControllerListMembersQuery,
  useLazyAccountControllerListMembersQuery,
  useAccountControllerAddMemberMutation,
  useAccountControllerUpdateMemberRoleMutation,
  useAccountControllerRemoveMemberMutation,
  useSignupControllerSignupMutation,
  useSupportControllerTokenMutation,
  useBillingControllerStatusQuery,
  useLazyBillingControllerStatusQuery,
  useBillingControllerStartSetupMutation,
  useBillingControllerConfirmSetupMutation,
  useStripeWebhookControllerReceiveMutation,
  useCompanyControllerCreateMutation,
  useCompanyControllerListQuery,
  useLazyCompanyControllerListQuery,
  useCompanyControllerFindOneQuery,
  useLazyCompanyControllerFindOneQuery,
  useCompanyControllerUpdateMutation,
  useCompanyControllerSetSiiCredentialsMutation,
  useCompanyControllerGetSiiCredentialsQuery,
  useLazyCompanyControllerGetSiiCredentialsQuery,
  useCompanyControllerClearSiiCredentialsMutation,
  useCompanyControllerPromoteToProductionMutation,
  useCompanyUserControllerListQuery,
  useLazyCompanyUserControllerListQuery,
  useCompanyUserControllerAuthorizeMutation,
  useCompanyUserControllerSetRoleMutation,
  useCompanyUserControllerRevokeMutation,
  useCertificateControllerListQuery,
  useLazyCertificateControllerListQuery,
  useCertificateControllerUploadMutation,
  useCafControllerUploadMutation,
  useCafControllerListQuery,
  useLazyCafControllerListQuery,
  useCafControllerPreviewMutation,
  useCafControllerAnnulmentCandidatesQuery,
  useLazyCafControllerAnnulmentCandidatesQuery,
  useFolioPolicyControllerListQuery,
  useLazyFolioPolicyControllerListQuery,
  useFolioPolicyControllerUpdateMutation,
  useFolioRequestControllerListQuery,
  useLazyFolioRequestControllerListQuery,
  useCompanyFolioAutomationControllerStatusQuery,
  useLazyCompanyFolioAutomationControllerStatusQuery,
  useCompanyFolioRequestControllerRequestNowMutation,
  useFolioAnnulmentControllerRequestConsultationMutation,
  useFolioAnnulmentControllerLatestConsultationQuery,
  useLazyFolioAnnulmentControllerLatestConsultationQuery,
  useFolioAnnulmentControllerCreateMutation,
  useFolioAnnulmentControllerListQuery,
  useLazyFolioAnnulmentControllerListQuery,
  useFolioAnnulmentControllerCreateBatchMutation,
  useFolioAnnulmentControllerGetQuery,
  useLazyFolioAnnulmentControllerGetQuery,
  useFolioAnnulmentControllerVerifyMutation,
  useFolioAnnulmentControllerSettingsQuery,
  useLazyFolioAnnulmentControllerSettingsQuery,
  useFolioAnnulmentControllerUpdateSettingsMutation,
  useEventControllerCatalogQuery,
  useLazyEventControllerCatalogQuery,
  useEventControllerStatsQuery,
  useLazyEventControllerStatsQuery,
  useEventControllerListQuery,
  useLazyEventControllerListQuery,
  useWebhookControllerCreateMutation,
  useWebhookControllerListQuery,
  useLazyWebhookControllerListQuery,
  useWebhookControllerUpdateMutation,
  useWebhookControllerRemoveMutation,
  useWebhookControllerRotateMutation,
  useWebhookControllerTestMutation,
  useWebhookControllerDeliveriesQuery,
  useLazyWebhookControllerDeliveriesQuery,
  useWebhookControllerResendMutation,
  useDteControllerCreateMutation,
  useDteControllerListQuery,
  useLazyDteControllerListQuery,
  useDteControllerParseSourceXmlMutation,
  useDteControllerFindOneQuery,
  useLazyDteControllerFindOneQuery,
  useDteControllerGetXmlQuery,
  useLazyDteControllerGetXmlQuery,
  useDteControllerGetXmlUrlQuery,
  useLazyDteControllerGetXmlUrlQuery,
  useDteControllerEmailMutation,
  useDteControllerGetPdfQuery,
  useLazyDteControllerGetPdfQuery,
  useEnvioControllerCreateMutation,
  useEnvioControllerSendMutation,
  useEnvioControllerReconcileMutation,
  useEnvioControllerFindOneQuery,
  useLazyEnvioControllerFindOneQuery,
  useEnvioControllerGetXmlQuery,
  useLazyEnvioControllerGetXmlQuery,
  useIntercambioControllerIngestMutation,
  useIntercambioControllerListEnviosQuery,
  useLazyIntercambioControllerListEnviosQuery,
  useIntercambioControllerGetEnvioQuery,
  useLazyIntercambioControllerGetEnvioQuery,
  useIntercambioControllerRespondEnvioMutation,
  useIntercambioControllerDownloadResponseQuery,
  useLazyIntercambioControllerDownloadResponseQuery,
  useIntercambioControllerListQuery,
  useLazyIntercambioControllerListQuery,
  useIntercambioControllerAcknowledgeMutation,
  useIntercambioControllerAcuseReciboMutation,
  useSesWebhookControllerReceiveMutation,
  useIntegrationsControllerConnectorsQuery,
  useLazyIntegrationsControllerConnectorsQuery,
  useIntegrationsControllerPendingCountsQuery,
  useLazyIntegrationsControllerPendingCountsQuery,
  useIntegrationsControllerCreateMutation,
  useIntegrationsControllerListQuery,
  useLazyIntegrationsControllerListQuery,
  useIntegrationsControllerBoletaImportMutation,
  useIntegrationsControllerGetQuery,
  useLazyIntegrationsControllerGetQuery,
  useIntegrationsControllerUpdateMutation,
  useIntegrationsControllerRemoveMutation,
  useIntegrationsControllerRotateCredentialsMutation,
  useIntegrationsControllerHealthQuery,
  useLazyIntegrationsControllerHealthQuery,
  useIntegrationsControllerActivateMutation,
  useIntegrationsControllerPauseMutation,
  useIntegrationsControllerMappingsQuery,
  useLazyIntegrationsControllerMappingsQuery,
  useIntegrationsControllerUpsertMappingMutation,
  useIntegrationsControllerImportMastersMutation,
  useIntegrationsControllerSyncNowMutation,
  useIntegrationsControllerUploadMutation,
  useIntegrationsControllerSyncRunsQuery,
  useLazyIntegrationsControllerSyncRunsQuery,
  useIntegrationsControllerDocumentsQuery,
  useLazyIntegrationsControllerDocumentsQuery,
  useIntegrationsControllerRetryMutation,
  useIntegrationsControllerApproveMutation,
  useIntegrationsControllerReconcileMutation,
  useIntegrationsControllerFindingsQuery,
  useLazyIntegrationsControllerFindingsQuery,
  useIntegrationsControllerResolveFindingMutation,
  useBoletaControllerBuildMutation,
  useBoletaControllerListQuery,
  useLazyBoletaControllerListQuery,
  useBoletaControllerUploadMutation,
  useBoletaControllerPollMutation,
  useBoletaControllerGetQuery,
  useLazyBoletaControllerGetQuery,
  useConsumoFoliosControllerBuildMutation,
  useConsumoFoliosControllerListQuery,
  useLazyConsumoFoliosControllerListQuery,
  useConsumoFoliosControllerGetQuery,
  useLazyConsumoFoliosControllerGetQuery,
  useOnboardingControllerRunMutation,
  useOnboardingControllerPreviewTestSetMutation,
  useOnboardingControllerGetDraftQuery,
  useLazyOnboardingControllerGetDraftQuery,
  useOnboardingControllerSaveDraftMutation,
  useOnboardingControllerDiscardDraftMutation,
  useOnboardingControllerEmitTestSetMutation,
  useOnboardingControllerRunSimulationMutation,
  useOnboardingControllerListRunsQuery,
  useLazyOnboardingControllerListRunsQuery,
  useOnboardingControllerListCertificationLibrosQuery,
  useLazyOnboardingControllerListCertificationLibrosQuery,
  useOnboardingControllerStatusQuery,
  useLazyOnboardingControllerStatusQuery,
  useOnboardingControllerApplyReceptionResultMutation,
  useOnboardingControllerAbandonRunMutation,
  useOnboardingControllerPreviewSimulationMutation,
  useOnboardingControllerEmailMuestrasMutation,
  useOnboardingControllerBundleQuery,
  useLazyOnboardingControllerBundleQuery,
  useEmittedDteImportControllerStartMutation,
  useEmittedDteImportControllerListQuery,
  useLazyEmittedDteImportControllerListQuery,
  useEmittedDteImportControllerAvailabilityQuery,
  useLazyEmittedDteImportControllerAvailabilityQuery,
  useLibroControllerBuildMutation,
  useLibroControllerListQuery,
  useLazyLibroControllerListQuery,
  useLibroControllerUploadMutation,
  useLibroControllerPollMutation,
  useLibroControllerGetQuery,
  useLazyLibroControllerGetQuery,
  useSiiAvanceControllerReadQuery,
  useLazySiiAvanceControllerReadQuery,
  useSiiAvanceControllerDeclareMutation,
  useSiiAvanceControllerAdvanceStepMutation,
  useSiiAvanceControllerRecordSetVerdictMutation,
  useSiiAvanceControllerRefreshMutation,
  useSiiTestSetControllerReadQuery,
  useLazySiiTestSetControllerReadQuery,
  useSiiTestSetControllerDownloadMutation,
  useSiiIntercambioSetControllerReadQuery,
  useLazySiiIntercambioSetControllerReadQuery,
  useSiiIntercambioSetControllerDownloadMutation,
  useHealthControllerCheckQuery,
  useLazyHealthControllerCheckQuery,
  useAdminHealthControllerSnapshotQuery,
  useLazyAdminHealthControllerSnapshotQuery,
  useReportsControllerCuadraturaReportQuery,
  useLazyReportsControllerCuadraturaReportQuery,
  useSandboxControllerCreateMutation,
  useSandboxControllerListQuery,
  useLazySandboxControllerListQuery,
  useSandboxControllerTopUpMutation,
  useSandboxControllerTopUpByPathMutation,
} = injectedRtkApi;
